import { IRequestConfig } from "~/modules/@xy/request/src/types/fetch-type";
import {
  XinxuanConsoleBannerGetParams,
  XinxuanConsoleConsoleSysDeptDeleteDeleteParams,
  XinxuanConsoleConsoleSysDeptQueryGetParams,
  XinxuanConsoleConsoleSysResourceButtonsAndApisBatchGetParams,
  XinxuanConsoleConsoleSysResourceGetParams,
  XinxuanConsoleConsoleSysResourceTreeGetParams,
  XinxuanConsoleConsoleSysRoleDeleteDeleteParams,
  XinxuanConsoleConsoleSysRoleQueryAllGetParams,
  XinxuanConsoleConsoleSysRoleQueryGetParams,
  XinxuanConsoleConsoleSysUserDeleteDeleteParams,
  XinxuanConsoleConsoleSysUserQueryGetParams,
  XinxuanConsoleConsoleSysUserResetDefaultDeleteParams,
  XinxuanConsoleGoodsGaiaGoodsDetailGetParams,
  XinxuanConsoleGoodsGaiaGoodsPageGetParams,
  XinxuanConsoleGoodsGetParams,
  XinxuanConsoleGoodsPageIgnoreIntegralGoodsGetParams,
  XinxuanConsoleGoodsSimplePageGetParams,
  XinxuanConsoleGoodsSkuIntegralStockRecordGetParams,
  XinxuanConsoleGroupApprovesGetParams,
  XinxuanConsoleGroupsGetParams,
  XinxuanConsoleGroupsSimpleGetParams,
  XinxuanConsoleIntegralGoodsCategoryGetParams,
  XinxuanConsoleIntegralGoodsGetParams,
  XinxuanConsoleLiveGetParams,
  XinxuanConsoleLotteryRecordGetParams,
  XinxuanConsoleLotteryTurntableGetParams,
  XinxuanConsoleMuteWordsGetParams,
  XinxuanConsoleOrderGetParams,
  XinxuanConsoleOrderIntegralListGetParams,
  XinxuanConsoleOssPolicyGetParams,
  XinxuanConsolePostsGetParams,
  XinxuanConsoleProblemGetParams,
  XinxuanConsolePublicJstDeliverPostParams,
  XinxuanConsoleSurveyTemplatesGetParams,
  XinxuanConsoleTagsGetParams,
  XinxuanConsoleTasksGetParams,
  XinxuanConsoleTaskValidatorsDetailsGetParams,
  XinxuanConsoleTaskValidatorsGetParams,
  XinxuanConsoleTestHelloGetParams,
  XinxuanConsoleTopicsGetParams,
  XinxuanConsoleTrialGetParams,
  XinxuanConsoleTrialRecordGetParams,
  XinxuanConsoleUserGetParams,
  XinxuanConsoleUserGrowthRecordGetParams,
  XinxuanConsoleUserIntegralRecordAuditGetParams,
  XinxuanConsoleUserIntegralRecordGetParams,
  XinxuanConsoleUserInvitedRecordGetParams,
  XinxuanConsoleUserSimpleGetParams,
  XinxuanConsoleWorkOrderGetParams
} from "./data-contracts";
import requestInstance from "./instance";

type RequestConfig = Omit<IRequestConfig, "url" | "method">;

export const API = {
  /**
   * No description
   * @name DELETE /xinxuan/console/goods/{id}
   * @summary delete
   * @tags goods-controller
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xinxuan/console/goods/{id}_DELETE": (id: string, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xinxuan/console/goods/${id}`,
      method: "DELETE",
      data: raw,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name GET /xinxuan/console/goods/{id}
   * @summary detail
   * @tags goods-controller
   * @response `200` `{ code?: number, data?: { bannerImgs?: (string)[], code?: string, coverImg?: string, detailDesc?: string, gmtCreate?: string, gmtModified?: string, goodsPropertyList?: ({ gmtCreate?: string, gmtModified?: string, goodsId?: number, id?: number, propName?: string, propertyValueList?: (object)[] })[], id?: number, integralIs?: boolean, name?: string, outerId?: string, salesVolume?: number, skuList?: ({ code?: string, gmtCreate?: string, gmtModified?: string, goodsId?: number, id?: number, integral?: number, integralSalesVolume?: number, integralShelfIs?: boolean, integralStock?: number, outerId?: string, outerPrice?: number, price?: number, salesVolume?: number, shelfIs?: boolean, skuImg?: string, skuName?: string, specIds?: (number)[], specNames?: (string)[], stock?: number, version?: string })[], stock?: number, trialIs?: boolean }, msg?: string }` successful operation
   */
  "/xinxuan/console/goods/{id}_GET": (id: string, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xinxuan/console/goods/${id}`,
      method: "GET",
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        bannerImgs?: string[];
        code?: string;
        coverImg?: string;
        detailDesc?: string;
        gmtCreate?: string;
        gmtModified?: string;
        goodsPropertyList?: {
          gmtCreate?: string;
          gmtModified?: string;
          goodsId?: number;
          id?: number;
          propName?: string;
          propertyValueList?: object[];
        }[];
        id?: number;
        integralIs?: boolean;
        name?: string;
        outerId?: string;
        salesVolume?: number;
        skuList?: {
          code?: string;
          gmtCreate?: string;
          gmtModified?: string;
          goodsId?: number;
          id?: number;
          integral?: number;
          integralSalesVolume?: number;
          integralShelfIs?: boolean;
          integralStock?: number;
          outerId?: string;
          outerPrice?: number;
          price?: number;
          salesVolume?: number;
          shelfIs?: boolean;
          skuImg?: string;
          skuName?: string;
          specIds?: number[];
          specNames?: string[];
          stock?: number;
          version?: string;
        }[];
        stock?: number;
        trialIs?: boolean;
      };
      msg?: string;
    }>,
  /**
   * No description
   * @name GET /xinxuan/console/goods/detailIgnoreOffSku/{id}
   * @summary detailIgnoreOffSku
   * @tags goods-controller
   * @response `200` `{ code?: number, data?: { bannerImgs?: (string)[], code?: string, coverImg?: string, detailDesc?: string, gmtCreate?: string, gmtModified?: string, goodsPropertyList?: ({ gmtCreate?: string, gmtModified?: string, goodsId?: number, id?: number, propName?: string, propertyValueList?: (object)[] })[], id?: number, integralIs?: boolean, name?: string, outerId?: string, salesVolume?: number, skuList?: ({ code?: string, gmtCreate?: string, gmtModified?: string, goodsId?: number, id?: number, integral?: number, integralSalesVolume?: number, integralShelfIs?: boolean, integralStock?: number, outerId?: string, outerPrice?: number, price?: number, salesVolume?: number, shelfIs?: boolean, skuImg?: string, skuName?: string, specIds?: (number)[], specNames?: (string)[], stock?: number, version?: string })[], stock?: number, trialIs?: boolean }, msg?: string }` successful operation
   */
  "/xinxuan/console/goods/detailIgnoreOffSku/{id}_GET": (id: string, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xinxuan/console/goods/detailIgnoreOffSku/${id}`,
      method: "GET",
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        bannerImgs?: string[];
        code?: string;
        coverImg?: string;
        detailDesc?: string;
        gmtCreate?: string;
        gmtModified?: string;
        goodsPropertyList?: {
          gmtCreate?: string;
          gmtModified?: string;
          goodsId?: number;
          id?: number;
          propName?: string;
          propertyValueList?: object[];
        }[];
        id?: number;
        integralIs?: boolean;
        name?: string;
        outerId?: string;
        salesVolume?: number;
        skuList?: {
          code?: string;
          gmtCreate?: string;
          gmtModified?: string;
          goodsId?: number;
          id?: number;
          integral?: number;
          integralSalesVolume?: number;
          integralShelfIs?: boolean;
          integralStock?: number;
          outerId?: string;
          outerPrice?: number;
          price?: number;
          salesVolume?: number;
          shelfIs?: boolean;
          skuImg?: string;
          skuName?: string;
          specIds?: number[];
          specNames?: string[];
          stock?: number;
          version?: string;
        }[];
        stock?: number;
        trialIs?: boolean;
      };
      msg?: string;
    }>,
  /**
   * No description
   * @name GET /xinxuan/console/goods/gaiaGoodsDetail/{outerId}
   * @summary gaiaGoodsDetail
   * @tags goods-controller
   * @response `200` `{ code?: number, data?: { bannerImgs?: (string)[], code?: string, coverImg?: string, detailDesc?: string, gmtCreate?: string, gmtModified?: string, goodsPropertyList?: ({ gmtCreate?: string, gmtModified?: string, goodsId?: number, id?: number, propName?: string, propertyValueList?: (object)[] })[], goodsSpecList?: ({ children?: (any)[], gmtCreate?: string, gmtModified?: string, goodsId?: number, id?: number, name?: string, pid?: number })[], id?: number, integralIs?: boolean, name?: string, outerId?: string, salesVolume?: number, skuList?: ({ code?: string, gmtCreate?: string, gmtModified?: string, goodsId?: number, id?: number, integral?: number, integralSalesVolume?: number, integralShelfIs?: boolean, integralStock?: number, outerId?: string, outerPrice?: number, price?: number, salesVolume?: number, shelfIs?: boolean, skuImg?: string, skuName?: string, specIds?: (number)[], specNames?: (string)[], stock?: number, version?: string })[], stock?: number, trialIs?: boolean }, msg?: string }` successful operation
   */
  "/xinxuan/console/goods/gaiaGoodsDetail/{outerId}_GET": (outerId: string, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xinxuan/console/goods/gaiaGoodsDetail/${outerId}`,
      method: "GET",
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        bannerImgs?: string[];
        code?: string;
        coverImg?: string;
        detailDesc?: string;
        gmtCreate?: string;
        gmtModified?: string;
        goodsPropertyList?: {
          gmtCreate?: string;
          gmtModified?: string;
          goodsId?: number;
          id?: number;
          propName?: string;
          propertyValueList?: object[];
        }[];
        goodsSpecList?: {
          children?: any[];
          gmtCreate?: string;
          gmtModified?: string;
          goodsId?: number;
          id?: number;
          name?: string;
          pid?: number;
        }[];
        id?: number;
        integralIs?: boolean;
        name?: string;
        outerId?: string;
        salesVolume?: number;
        skuList?: {
          code?: string;
          gmtCreate?: string;
          gmtModified?: string;
          goodsId?: number;
          id?: number;
          integral?: number;
          integralSalesVolume?: number;
          integralShelfIs?: boolean;
          integralStock?: number;
          outerId?: string;
          outerPrice?: number;
          price?: number;
          salesVolume?: number;
          shelfIs?: boolean;
          skuImg?: string;
          skuName?: string;
          specIds?: number[];
          specNames?: string[];
          stock?: number;
          version?: string;
        }[];
        stock?: number;
        trialIs?: boolean;
      };
      msg?: string;
    }>,
  /**
   * No description
   * @name GET /xinxuan/console/goods/gaiaGoodsDetail
   * @summary gaiaGoodsDetail
   * @tags goods-controller
   * @response `200` `{ code?: number, data?: { bannerImgs?: (string)[], code?: string, coverImg?: string, detailDesc?: string, gmtCreate?: string, gmtModified?: string, goodsPropertyList?: ({ gmtCreate?: string, gmtModified?: string, goodsId?: number, id?: number, propName?: string, propertyValueList?: (object)[] })[], id?: number, integralIs?: boolean, name?: string, outerId?: string, salesVolume?: number, skuList?: ({ code?: string, gmtCreate?: string, gmtModified?: string, goodsId?: number, id?: number, integral?: number, integralSalesVolume?: number, integralShelfIs?: boolean, integralStock?: number, outerId?: string, outerPrice?: number, price?: number, salesVolume?: number, shelfIs?: boolean, skuImg?: string, skuName?: string, specIds?: (number)[], specNames?: (string)[], stock?: number, version?: string })[], stock?: number, trialIs?: boolean }, msg?: string }` successful operation
   */
  "/xinxuan/console/goods/gaiaGoodsDetail_GET": (
    query: XinxuanConsoleGoodsGaiaGoodsDetailGetParams,
    raw: File,
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/goods/gaiaGoodsDetail`,
      method: "GET",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        bannerImgs?: string[];
        code?: string;
        coverImg?: string;
        detailDesc?: string;
        gmtCreate?: string;
        gmtModified?: string;
        goodsPropertyList?: {
          gmtCreate?: string;
          gmtModified?: string;
          goodsId?: number;
          id?: number;
          propName?: string;
          propertyValueList?: object[];
        }[];
        id?: number;
        integralIs?: boolean;
        name?: string;
        outerId?: string;
        salesVolume?: number;
        skuList?: {
          code?: string;
          gmtCreate?: string;
          gmtModified?: string;
          goodsId?: number;
          id?: number;
          integral?: number;
          integralSalesVolume?: number;
          integralShelfIs?: boolean;
          integralStock?: number;
          outerId?: string;
          outerPrice?: number;
          price?: number;
          salesVolume?: number;
          shelfIs?: boolean;
          skuImg?: string;
          skuName?: string;
          specIds?: number[];
          specNames?: string[];
          stock?: number;
          version?: string;
        }[];
        stock?: number;
        trialIs?: boolean;
      };
      msg?: string;
    }>,
  /**
   * No description
   * @name GET /xinxuan/console/goods/gaiaGoodsPage
   * @summary gaiaGoodsPage
   * @tags goods-controller
   * @response `200` `{ code?: number, data?: { endRow?: number, firstPage?: number, hasNextPage?: boolean, hasPreviousPage?: boolean, isFirstPage?: boolean, isLastPage?: boolean, lastPage?: number, list?: ({ bannerImgs?: (string)[], code?: string, coverImg?: string, detailDesc?: string, gmtCreate?: string, gmtModified?: string, goodsPropertyList?: ({ gmtCreate?: string, gmtModified?: string, goodsId?: number, id?: number, propName?: string, propertyValueList?: (object)[] })[], id?: number, integralIs?: boolean, name?: string, outerId?: string, salesVolume?: number, skuList?: ({ code?: string, gmtCreate?: string, gmtModified?: string, goodsId?: number, id?: number, integral?: number, integralSalesVolume?: number, integralShelfIs?: boolean, integralStock?: number, outerId?: string, outerPrice?: number, price?: number, salesVolume?: number, shelfIs?: boolean, skuImg?: string, skuName?: string, specIds?: (number)[], specNames?: (string)[], stock?: number, version?: string })[], stock?: number, trialIs?: boolean })[], navigateFirstPage?: number, navigateLastPage?: number, navigatePages?: number, navigatepageNums?: (number)[], nextPage?: number, pageNum?: number, pageSize?: number, pages?: number, prePage?: number, size?: number, startRow?: number, total?: number }, msg?: string }` successful operation
   */
  "/xinxuan/console/goods/gaiaGoodsPage_GET": (
    query: XinxuanConsoleGoodsGaiaGoodsPageGetParams,
    raw: File,
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/goods/gaiaGoodsPage`,
      method: "GET",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        endRow?: number;
        firstPage?: number;
        hasNextPage?: boolean;
        hasPreviousPage?: boolean;
        isFirstPage?: boolean;
        isLastPage?: boolean;
        lastPage?: number;
        list?: {
          bannerImgs?: string[];
          code?: string;
          coverImg?: string;
          detailDesc?: string;
          gmtCreate?: string;
          gmtModified?: string;
          goodsPropertyList?: {
            gmtCreate?: string;
            gmtModified?: string;
            goodsId?: number;
            id?: number;
            propName?: string;
            propertyValueList?: object[];
          }[];
          id?: number;
          integralIs?: boolean;
          name?: string;
          outerId?: string;
          salesVolume?: number;
          skuList?: {
            code?: string;
            gmtCreate?: string;
            gmtModified?: string;
            goodsId?: number;
            id?: number;
            integral?: number;
            integralSalesVolume?: number;
            integralShelfIs?: boolean;
            integralStock?: number;
            outerId?: string;
            outerPrice?: number;
            price?: number;
            salesVolume?: number;
            shelfIs?: boolean;
            skuImg?: string;
            skuName?: string;
            specIds?: number[];
            specNames?: string[];
            stock?: number;
            version?: string;
          }[];
          stock?: number;
          trialIs?: boolean;
        }[];
        navigateFirstPage?: number;
        navigateLastPage?: number;
        navigatePages?: number;
        navigatepageNums?: number[];
        nextPage?: number;
        pageNum?: number;
        pageSize?: number;
        pages?: number;
        prePage?: number;
        size?: number;
        startRow?: number;
        total?: number;
      };
      msg?: string;
    }>,
  /**
   * No description
   * @name POST /xinxuan/console/goods
   * @summary insert
   * @tags goods-controller
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xinxuan/console/goods_POST": (
    root: {
      bannerImgs?: string[];
      beginTime?: string;
      code?: string;
      coverImg?: string;
      detailDesc?: string;
      endTime?: string;
      id?: number;
      ignoreIds?: number[];
      integralIs?: boolean;
      keyword?: string;
      name?: string;
      orderField?: string;
      orderScheme?: "ASC" | "DESC";
      outerId?: string;
      pageNum?: number;
      pageSize?: number;
      skuList?: {
        beginTime?: string;
        changeIntegralStock?: number;
        changeStock?: number;
        code?: string;
        endTime?: string;
        goodsId?: number;
        id?: number;
        integral?: number;
        integralSalesVolume?: number;
        integralShelfIs?: boolean;
        integralStock?: number;
        keyword?: string;
        orderField?: string;
        orderScheme?: "ASC" | "DESC";
        outerId?: string;
        outerPrice?: number;
        pageNum?: number;
        pageSize?: number;
        price?: number;
        salesVolume?: number;
        shelfIs?: boolean;
        skuImg?: string;
        skuName?: string;
        specIds?: number[];
        specNames?: string[];
        stock?: number;
        timeField?: string;
      }[];
      timeField?: string;
      trialIs?: boolean;
    },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/goods`,
      method: "POST",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name GET /xinxuan/console/goods
   * @summary page
   * @tags goods-controller
   * @response `200` `{ code?: number, data?: { endRow?: number, firstPage?: number, hasNextPage?: boolean, hasPreviousPage?: boolean, isFirstPage?: boolean, isLastPage?: boolean, lastPage?: number, list?: ({ bannerImgs?: (string)[], code?: string, coverImg?: string, detailDesc?: string, gmtCreate?: string, gmtModified?: string, goodsPropertyList?: ({ gmtCreate?: string, gmtModified?: string, goodsId?: number, id?: number, propName?: string, propertyValueList?: (object)[] })[], id?: number, integralIs?: boolean, name?: string, outerId?: string, salesVolume?: number, skuList?: ({ code?: string, gmtCreate?: string, gmtModified?: string, goodsId?: number, id?: number, integral?: number, integralSalesVolume?: number, integralShelfIs?: boolean, integralStock?: number, outerId?: string, outerPrice?: number, price?: number, salesVolume?: number, shelfIs?: boolean, skuImg?: string, skuName?: string, specIds?: (number)[], specNames?: (string)[], stock?: number, version?: string })[], stock?: number, trialIs?: boolean })[], navigateFirstPage?: number, navigateLastPage?: number, navigatePages?: number, navigatepageNums?: (number)[], nextPage?: number, pageNum?: number, pageSize?: number, pages?: number, prePage?: number, size?: number, startRow?: number, total?: number }, msg?: string }` successful operation
   */
  "/xinxuan/console/goods_GET": (query: XinxuanConsoleGoodsGetParams, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xinxuan/console/goods`,
      method: "GET",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        endRow?: number;
        firstPage?: number;
        hasNextPage?: boolean;
        hasPreviousPage?: boolean;
        isFirstPage?: boolean;
        isLastPage?: boolean;
        lastPage?: number;
        list?: {
          bannerImgs?: string[];
          code?: string;
          coverImg?: string;
          detailDesc?: string;
          gmtCreate?: string;
          gmtModified?: string;
          goodsPropertyList?: {
            gmtCreate?: string;
            gmtModified?: string;
            goodsId?: number;
            id?: number;
            propName?: string;
            propertyValueList?: object[];
          }[];
          id?: number;
          integralIs?: boolean;
          name?: string;
          outerId?: string;
          salesVolume?: number;
          skuList?: {
            code?: string;
            gmtCreate?: string;
            gmtModified?: string;
            goodsId?: number;
            id?: number;
            integral?: number;
            integralSalesVolume?: number;
            integralShelfIs?: boolean;
            integralStock?: number;
            outerId?: string;
            outerPrice?: number;
            price?: number;
            salesVolume?: number;
            shelfIs?: boolean;
            skuImg?: string;
            skuName?: string;
            specIds?: number[];
            specNames?: string[];
            stock?: number;
            version?: string;
          }[];
          stock?: number;
          trialIs?: boolean;
        }[];
        navigateFirstPage?: number;
        navigateLastPage?: number;
        navigatePages?: number;
        navigatepageNums?: number[];
        nextPage?: number;
        pageNum?: number;
        pageSize?: number;
        pages?: number;
        prePage?: number;
        size?: number;
        startRow?: number;
        total?: number;
      };
      msg?: string;
    }>,
  /**
   * No description
   * @name PUT /xinxuan/console/goods
   * @summary update
   * @tags goods-controller
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xinxuan/console/goods_PUT": (
    root: {
      bannerImgs?: string[];
      beginTime?: string;
      code?: string;
      coverImg?: string;
      detailDesc?: string;
      endTime?: string;
      id?: number;
      ignoreIds?: number[];
      integralIs?: boolean;
      keyword?: string;
      name?: string;
      orderField?: string;
      orderScheme?: "ASC" | "DESC";
      outerId?: string;
      pageNum?: number;
      pageSize?: number;
      skuList?: {
        beginTime?: string;
        changeIntegralStock?: number;
        changeStock?: number;
        code?: string;
        endTime?: string;
        goodsId?: number;
        id?: number;
        integral?: number;
        integralSalesVolume?: number;
        integralShelfIs?: boolean;
        integralStock?: number;
        keyword?: string;
        orderField?: string;
        orderScheme?: "ASC" | "DESC";
        outerId?: string;
        outerPrice?: number;
        pageNum?: number;
        pageSize?: number;
        price?: number;
        salesVolume?: number;
        shelfIs?: boolean;
        skuImg?: string;
        skuName?: string;
        specIds?: number[];
        specNames?: string[];
        stock?: number;
        timeField?: string;
      }[];
      timeField?: string;
      trialIs?: boolean;
    },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/goods`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name GET /xinxuan/console/goods/pageIgnoreIntegralGoods
   * @summary pageIgnoreIntegralGoods
   * @tags goods-controller
   * @response `200` `{ code?: number, data?: { endRow?: number, firstPage?: number, hasNextPage?: boolean, hasPreviousPage?: boolean, isFirstPage?: boolean, isLastPage?: boolean, lastPage?: number, list?: ({ bannerImgs?: (string)[], code?: string, coverImg?: string, detailDesc?: string, gmtCreate?: string, gmtModified?: string, goodsPropertyList?: ({ gmtCreate?: string, gmtModified?: string, goodsId?: number, id?: number, propName?: string, propertyValueList?: (object)[] })[], id?: number, integralIs?: boolean, name?: string, outerId?: string, salesVolume?: number, skuList?: ({ code?: string, gmtCreate?: string, gmtModified?: string, goodsId?: number, id?: number, integral?: number, integralSalesVolume?: number, integralShelfIs?: boolean, integralStock?: number, outerId?: string, outerPrice?: number, price?: number, salesVolume?: number, shelfIs?: boolean, skuImg?: string, skuName?: string, specIds?: (number)[], specNames?: (string)[], stock?: number, version?: string })[], stock?: number, trialIs?: boolean })[], navigateFirstPage?: number, navigateLastPage?: number, navigatePages?: number, navigatepageNums?: (number)[], nextPage?: number, pageNum?: number, pageSize?: number, pages?: number, prePage?: number, size?: number, startRow?: number, total?: number }, msg?: string }` successful operation
   */
  "/xinxuan/console/goods/pageIgnoreIntegralGoods_GET": (
    query: XinxuanConsoleGoodsPageIgnoreIntegralGoodsGetParams,
    raw: File,
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/goods/pageIgnoreIntegralGoods`,
      method: "GET",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        endRow?: number;
        firstPage?: number;
        hasNextPage?: boolean;
        hasPreviousPage?: boolean;
        isFirstPage?: boolean;
        isLastPage?: boolean;
        lastPage?: number;
        list?: {
          bannerImgs?: string[];
          code?: string;
          coverImg?: string;
          detailDesc?: string;
          gmtCreate?: string;
          gmtModified?: string;
          goodsPropertyList?: {
            gmtCreate?: string;
            gmtModified?: string;
            goodsId?: number;
            id?: number;
            propName?: string;
            propertyValueList?: object[];
          }[];
          id?: number;
          integralIs?: boolean;
          name?: string;
          outerId?: string;
          salesVolume?: number;
          skuList?: {
            code?: string;
            gmtCreate?: string;
            gmtModified?: string;
            goodsId?: number;
            id?: number;
            integral?: number;
            integralSalesVolume?: number;
            integralShelfIs?: boolean;
            integralStock?: number;
            outerId?: string;
            outerPrice?: number;
            price?: number;
            salesVolume?: number;
            shelfIs?: boolean;
            skuImg?: string;
            skuName?: string;
            specIds?: number[];
            specNames?: string[];
            stock?: number;
            version?: string;
          }[];
          stock?: number;
          trialIs?: boolean;
        }[];
        navigateFirstPage?: number;
        navigateLastPage?: number;
        navigatePages?: number;
        navigatepageNums?: number[];
        nextPage?: number;
        pageNum?: number;
        pageSize?: number;
        pages?: number;
        prePage?: number;
        size?: number;
        startRow?: number;
        total?: number;
      };
      msg?: string;
    }>,
  /**
   * No description
   * @name GET /xinxuan/console/goods/simplePage
   * @summary simplePage
   * @tags goods-controller
   * @response `200` `{ code?: number, data?: { endRow?: number, firstPage?: number, hasNextPage?: boolean, hasPreviousPage?: boolean, isFirstPage?: boolean, isLastPage?: boolean, lastPage?: number, list?: ({ bannerImgs?: (string)[], code?: string, coverImg?: string, detailDesc?: string, gmtCreate?: string, gmtModified?: string, goodsPropertyList?: ({ gmtCreate?: string, gmtModified?: string, goodsId?: number, id?: number, propName?: string, propertyValueList?: (object)[] })[], id?: number, integralIs?: boolean, name?: string, outerId?: string, salesVolume?: number, skuList?: ({ code?: string, gmtCreate?: string, gmtModified?: string, goodsId?: number, id?: number, integral?: number, integralSalesVolume?: number, integralShelfIs?: boolean, integralStock?: number, outerId?: string, outerPrice?: number, price?: number, salesVolume?: number, shelfIs?: boolean, skuImg?: string, skuName?: string, specIds?: (number)[], specNames?: (string)[], stock?: number, version?: string })[], stock?: number, trialIs?: boolean })[], navigateFirstPage?: number, navigateLastPage?: number, navigatePages?: number, navigatepageNums?: (number)[], nextPage?: number, pageNum?: number, pageSize?: number, pages?: number, prePage?: number, size?: number, startRow?: number, total?: number }, msg?: string }` successful operation
   */
  "/xinxuan/console/goods/simplePage_GET": (
    query: XinxuanConsoleGoodsSimplePageGetParams,
    raw: File,
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/goods/simplePage`,
      method: "GET",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        endRow?: number;
        firstPage?: number;
        hasNextPage?: boolean;
        hasPreviousPage?: boolean;
        isFirstPage?: boolean;
        isLastPage?: boolean;
        lastPage?: number;
        list?: {
          bannerImgs?: string[];
          code?: string;
          coverImg?: string;
          detailDesc?: string;
          gmtCreate?: string;
          gmtModified?: string;
          goodsPropertyList?: {
            gmtCreate?: string;
            gmtModified?: string;
            goodsId?: number;
            id?: number;
            propName?: string;
            propertyValueList?: object[];
          }[];
          id?: number;
          integralIs?: boolean;
          name?: string;
          outerId?: string;
          salesVolume?: number;
          skuList?: {
            code?: string;
            gmtCreate?: string;
            gmtModified?: string;
            goodsId?: number;
            id?: number;
            integral?: number;
            integralSalesVolume?: number;
            integralShelfIs?: boolean;
            integralStock?: number;
            outerId?: string;
            outerPrice?: number;
            price?: number;
            salesVolume?: number;
            shelfIs?: boolean;
            skuImg?: string;
            skuName?: string;
            specIds?: number[];
            specNames?: string[];
            stock?: number;
            version?: string;
          }[];
          stock?: number;
          trialIs?: boolean;
        }[];
        navigateFirstPage?: number;
        navigateLastPage?: number;
        navigatePages?: number;
        navigatepageNums?: number[];
        nextPage?: number;
        pageNum?: number;
        pageSize?: number;
        pages?: number;
        prePage?: number;
        size?: number;
        startRow?: number;
        total?: number;
      };
      msg?: string;
    }>,
  /**
   * No description
   * @name GET /xinxuan/console/goodsSkuIntegralStockRecord
   * @summary page
   * @tags goods-sku-integral-stock-record-controller
   * @response `200` `{ code?: number, data?: { endRow?: number, firstPage?: number, hasNextPage?: boolean, hasPreviousPage?: boolean, isFirstPage?: boolean, isLastPage?: boolean, lastPage?: number, list?: ({ createUser?: string, gmtCreate?: string, gmtModified?: string, goodsId?: number, goodsSkuId?: number, id?: number, integralGoodsId?: number, value?: number })[], navigateFirstPage?: number, navigateLastPage?: number, navigatePages?: number, navigatepageNums?: (number)[], nextPage?: number, pageNum?: number, pageSize?: number, pages?: number, prePage?: number, size?: number, startRow?: number, total?: number }, msg?: string }` successful operation
   */
  "/xinxuan/console/goodsSkuIntegralStockRecord_GET": (
    query: XinxuanConsoleGoodsSkuIntegralStockRecordGetParams,
    raw: File,
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/goodsSkuIntegralStockRecord`,
      method: "GET",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        endRow?: number;
        firstPage?: number;
        hasNextPage?: boolean;
        hasPreviousPage?: boolean;
        isFirstPage?: boolean;
        isLastPage?: boolean;
        lastPage?: number;
        list?: {
          createUser?: string;
          gmtCreate?: string;
          gmtModified?: string;
          goodsId?: number;
          goodsSkuId?: number;
          id?: number;
          integralGoodsId?: number;
          value?: number;
        }[];
        navigateFirstPage?: number;
        navigateLastPage?: number;
        navigatePages?: number;
        navigatepageNums?: number[];
        nextPage?: number;
        pageNum?: number;
        pageSize?: number;
        pages?: number;
        prePage?: number;
        size?: number;
        startRow?: number;
        total?: number;
      };
      msg?: string;
    }>,
  /**
   * No description
   * @name DELETE /xinxuan/console/integralGoods/{id}
   * @summary delete
   * @tags integral-goods-controller
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xinxuan/console/integralGoods/{id}_DELETE": (id: string, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xinxuan/console/integralGoods/${id}`,
      method: "DELETE",
      data: raw,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name GET /xinxuan/console/integralGoods/{id}
   * @summary detail
   * @tags integral-goods-controller
   * @response `200` `{ code?: number, data?: { bannerImgs?: (string)[], categoryId?: number, code?: string, coverImg?: string, detailDesc?: string, gmtCreate?: string, gmtModified?: string, goodsId?: number, goodsPropertyVOList?: ({ gmtCreate?: string, gmtModified?: string, goodsId?: number, id?: number, propName?: string, propertyValueList?: (object)[] })[], homeIs?: boolean, id?: number, integralMax?: number, integralMin?: number, name?: string, salesVolume?: number, shelfIs?: boolean, skuVOList?: ({ code?: string, gmtCreate?: string, gmtModified?: string, goodsId?: number, id?: number, integral?: number, integralSalesVolume?: number, integralShelfIs?: boolean, integralStock?: number, outerId?: string, outerPrice?: number, price?: number, salesVolume?: number, shelfIs?: boolean, skuImg?: string, skuName?: string, specIds?: (number)[], specNames?: (string)[], stock?: number, version?: string })[], sort?: number, stock?: number }, msg?: string }` successful operation
   */
  "/xinxuan/console/integralGoods/{id}_GET": (id: string, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xinxuan/console/integralGoods/${id}`,
      method: "GET",
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        bannerImgs?: string[];
        categoryId?: number;
        code?: string;
        coverImg?: string;
        detailDesc?: string;
        gmtCreate?: string;
        gmtModified?: string;
        goodsId?: number;
        goodsPropertyVOList?: {
          gmtCreate?: string;
          gmtModified?: string;
          goodsId?: number;
          id?: number;
          propName?: string;
          propertyValueList?: object[];
        }[];
        homeIs?: boolean;
        id?: number;
        integralMax?: number;
        integralMin?: number;
        name?: string;
        salesVolume?: number;
        shelfIs?: boolean;
        skuVOList?: {
          code?: string;
          gmtCreate?: string;
          gmtModified?: string;
          goodsId?: number;
          id?: number;
          integral?: number;
          integralSalesVolume?: number;
          integralShelfIs?: boolean;
          integralStock?: number;
          outerId?: string;
          outerPrice?: number;
          price?: number;
          salesVolume?: number;
          shelfIs?: boolean;
          skuImg?: string;
          skuName?: string;
          specIds?: number[];
          specNames?: string[];
          stock?: number;
          version?: string;
        }[];
        sort?: number;
        stock?: number;
      };
      msg?: string;
    }>,
  /**
   * No description
   * @name PUT /xinxuan/console/integralGoods/homeIs
   * @summary homeIs
   * @tags integral-goods-controller
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xinxuan/console/integralGoods/homeIs_PUT": (
    root: {
      beginTime?: string;
      categoryId?: number;
      code?: string;
      endTime?: string;
      goodsId?: number;
      haveIntegral?: number;
      homeIs?: boolean;
      id?: number;
      integralMax?: number;
      integralMin?: number;
      keyword?: string;
      name?: string;
      orderField?: string;
      orderScheme?: "ASC" | "DESC";
      pageNum?: number;
      pageSize?: number;
      shelfIs?: boolean;
      skuList?: {
        beginTime?: string;
        changeIntegralStock?: number;
        changeStock?: number;
        code?: string;
        endTime?: string;
        goodsId?: number;
        id?: number;
        integral?: number;
        integralSalesVolume?: number;
        integralShelfIs?: boolean;
        integralStock?: number;
        keyword?: string;
        orderField?: string;
        orderScheme?: "ASC" | "DESC";
        outerId?: string;
        outerPrice?: number;
        pageNum?: number;
        pageSize?: number;
        price?: number;
        salesVolume?: number;
        shelfIs?: boolean;
        skuImg?: string;
        skuName?: string;
        specIds?: number[];
        specNames?: string[];
        stock?: number;
        timeField?: string;
      }[];
      sort?: number;
      timeField?: string;
    },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/integralGoods/homeIs`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name POST /xinxuan/console/integralGoods
   * @summary insert
   * @tags integral-goods-controller
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xinxuan/console/integralGoods_POST": (
    root: {
      beginTime?: string;
      categoryId?: number;
      code?: string;
      endTime?: string;
      goodsId?: number;
      haveIntegral?: number;
      homeIs?: boolean;
      id?: number;
      integralMax?: number;
      integralMin?: number;
      keyword?: string;
      name?: string;
      orderField?: string;
      orderScheme?: "ASC" | "DESC";
      pageNum?: number;
      pageSize?: number;
      shelfIs?: boolean;
      skuList?: {
        beginTime?: string;
        changeIntegralStock?: number;
        changeStock?: number;
        code?: string;
        endTime?: string;
        goodsId?: number;
        id?: number;
        integral?: number;
        integralSalesVolume?: number;
        integralShelfIs?: boolean;
        integralStock?: number;
        keyword?: string;
        orderField?: string;
        orderScheme?: "ASC" | "DESC";
        outerId?: string;
        outerPrice?: number;
        pageNum?: number;
        pageSize?: number;
        price?: number;
        salesVolume?: number;
        shelfIs?: boolean;
        skuImg?: string;
        skuName?: string;
        specIds?: number[];
        specNames?: string[];
        stock?: number;
        timeField?: string;
      }[];
      sort?: number;
      timeField?: string;
    },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/integralGoods`,
      method: "POST",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name GET /xinxuan/console/integralGoods
   * @summary page
   * @tags integral-goods-controller
   * @response `200` `{ code?: number, data?: { endRow?: number, firstPage?: number, hasNextPage?: boolean, hasPreviousPage?: boolean, isFirstPage?: boolean, isLastPage?: boolean, lastPage?: number, list?: ({ bannerImgs?: (string)[], categoryId?: number, code?: string, coverImg?: string, detailDesc?: string, gmtCreate?: string, gmtModified?: string, goodsId?: number, goodsPropertyVOList?: ({ gmtCreate?: string, gmtModified?: string, goodsId?: number, id?: number, propName?: string, propertyValueList?: (object)[] })[], homeIs?: boolean, id?: number, integralMax?: number, integralMin?: number, name?: string, salesVolume?: number, shelfIs?: boolean, skuVOList?: ({ code?: string, gmtCreate?: string, gmtModified?: string, goodsId?: number, id?: number, integral?: number, integralSalesVolume?: number, integralShelfIs?: boolean, integralStock?: number, outerId?: string, outerPrice?: number, price?: number, salesVolume?: number, shelfIs?: boolean, skuImg?: string, skuName?: string, specIds?: (number)[], specNames?: (string)[], stock?: number, version?: string })[], sort?: number, stock?: number })[], navigateFirstPage?: number, navigateLastPage?: number, navigatePages?: number, navigatepageNums?: (number)[], nextPage?: number, pageNum?: number, pageSize?: number, pages?: number, prePage?: number, size?: number, startRow?: number, total?: number }, msg?: string }` successful operation
   */
  "/xinxuan/console/integralGoods_GET": (
    query: XinxuanConsoleIntegralGoodsGetParams,
    raw: File,
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/integralGoods`,
      method: "GET",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        endRow?: number;
        firstPage?: number;
        hasNextPage?: boolean;
        hasPreviousPage?: boolean;
        isFirstPage?: boolean;
        isLastPage?: boolean;
        lastPage?: number;
        list?: {
          bannerImgs?: string[];
          categoryId?: number;
          code?: string;
          coverImg?: string;
          detailDesc?: string;
          gmtCreate?: string;
          gmtModified?: string;
          goodsId?: number;
          goodsPropertyVOList?: {
            gmtCreate?: string;
            gmtModified?: string;
            goodsId?: number;
            id?: number;
            propName?: string;
            propertyValueList?: object[];
          }[];
          homeIs?: boolean;
          id?: number;
          integralMax?: number;
          integralMin?: number;
          name?: string;
          salesVolume?: number;
          shelfIs?: boolean;
          skuVOList?: {
            code?: string;
            gmtCreate?: string;
            gmtModified?: string;
            goodsId?: number;
            id?: number;
            integral?: number;
            integralSalesVolume?: number;
            integralShelfIs?: boolean;
            integralStock?: number;
            outerId?: string;
            outerPrice?: number;
            price?: number;
            salesVolume?: number;
            shelfIs?: boolean;
            skuImg?: string;
            skuName?: string;
            specIds?: number[];
            specNames?: string[];
            stock?: number;
            version?: string;
          }[];
          sort?: number;
          stock?: number;
        }[];
        navigateFirstPage?: number;
        navigateLastPage?: number;
        navigatePages?: number;
        navigatepageNums?: number[];
        nextPage?: number;
        pageNum?: number;
        pageSize?: number;
        pages?: number;
        prePage?: number;
        size?: number;
        startRow?: number;
        total?: number;
      };
      msg?: string;
    }>,
  /**
   * No description
   * @name PUT /xinxuan/console/integralGoods
   * @summary update
   * @tags integral-goods-controller
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xinxuan/console/integralGoods_PUT": (
    root: {
      beginTime?: string;
      categoryId?: number;
      code?: string;
      endTime?: string;
      goodsId?: number;
      haveIntegral?: number;
      homeIs?: boolean;
      id?: number;
      integralMax?: number;
      integralMin?: number;
      keyword?: string;
      name?: string;
      orderField?: string;
      orderScheme?: "ASC" | "DESC";
      pageNum?: number;
      pageSize?: number;
      shelfIs?: boolean;
      skuList?: {
        beginTime?: string;
        changeIntegralStock?: number;
        changeStock?: number;
        code?: string;
        endTime?: string;
        goodsId?: number;
        id?: number;
        integral?: number;
        integralSalesVolume?: number;
        integralShelfIs?: boolean;
        integralStock?: number;
        keyword?: string;
        orderField?: string;
        orderScheme?: "ASC" | "DESC";
        outerId?: string;
        outerPrice?: number;
        pageNum?: number;
        pageSize?: number;
        price?: number;
        salesVolume?: number;
        shelfIs?: boolean;
        skuImg?: string;
        skuName?: string;
        specIds?: number[];
        specNames?: string[];
        stock?: number;
        timeField?: string;
      }[];
      sort?: number;
      timeField?: string;
    },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/integralGoods`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name PUT /xinxuan/console/integralGoods/shelfIs
   * @summary shelfIs
   * @tags integral-goods-controller
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xinxuan/console/integralGoods/shelfIs_PUT": (
    root: {
      beginTime?: string;
      categoryId?: number;
      code?: string;
      endTime?: string;
      goodsId?: number;
      haveIntegral?: number;
      homeIs?: boolean;
      id?: number;
      integralMax?: number;
      integralMin?: number;
      keyword?: string;
      name?: string;
      orderField?: string;
      orderScheme?: "ASC" | "DESC";
      pageNum?: number;
      pageSize?: number;
      shelfIs?: boolean;
      skuList?: {
        beginTime?: string;
        changeIntegralStock?: number;
        changeStock?: number;
        code?: string;
        endTime?: string;
        goodsId?: number;
        id?: number;
        integral?: number;
        integralSalesVolume?: number;
        integralShelfIs?: boolean;
        integralStock?: number;
        keyword?: string;
        orderField?: string;
        orderScheme?: "ASC" | "DESC";
        outerId?: string;
        outerPrice?: number;
        pageNum?: number;
        pageSize?: number;
        price?: number;
        salesVolume?: number;
        shelfIs?: boolean;
        skuImg?: string;
        skuName?: string;
        specIds?: number[];
        specNames?: string[];
        stock?: number;
        timeField?: string;
      }[];
      sort?: number;
      timeField?: string;
    },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/integralGoods/shelfIs`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name PUT /xinxuan/console/order/cancel
   * @summary cancel
   * @tags order-controller
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xinxuan/console/order/cancel_PUT": (
    root: {
      beginTime?: string;
      cancelTime?: string;
      endTime?: string;
      freight?: number;
      id?: number;
      integral?: number;
      keyword?: string;
      logisticsCompany?: string;
      logisticsNo?: string;
      logisticsTime?: string;
      orderField?: string;
      orderItemList?: {
        beginTime?: string;
        endTime?: string;
        goodsCode?: string;
        goodsCoverImg?: string;
        goodsId?: number;
        goodsName?: string;
        goodsSkuId?: number;
        goodsSkuIntegral?: number;
        goodsSkuOuterId?: string;
        goodsSkuSpecNames?: string[];
        id?: number;
        integral?: number;
        integralGoodsId?: number;
        keyword?: string;
        orderField?: string;
        orderId?: number;
        orderIds?: number[];
        orderScheme?: "ASC" | "DESC";
        pageNum?: number;
        pageSize?: number;
        quantity?: number;
        timeField?: string;
      }[];
      orderNo?: string;
      orderScheme?: "ASC" | "DESC";
      pageNum?: number;
      pageSize?: number;
      pushIs?: boolean;
      receiverAddress?: string;
      receiverCity?: string;
      receiverDistrict?: string;
      receiverName?: string;
      receiverPhone?: string;
      receiverState?: string;
      receiverTime?: string;
      remark?: string;
      source?: "INTEGRAL_MALL" | "TRIAL";
      status?: "COMPLETED" | "SHIPPED" | "VOIDED" | "WAIT_SHIPPED";
      timeField?: string;
      userId?: number;
      userNick?: string;
      userPhone?: string;
    },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/order/cancel`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name GET /xinxuan/console/order/{id}
   * @summary detail
   * @tags order-controller
   * @response `200` `{ code?: number, data?: { cancelTime?: string, freight?: number, gmtCreate?: string, gmtModified?: string, id?: number, integral?: number, logisticsCompany?: string, logisticsNo?: string, logisticsTime?: string, orderItemVOList?: ({ gmtCreate?: string, gmtModified?: string, goodsCode?: string, goodsCoverImg?: string, goodsId?: number, goodsName?: string, goodsSkuId?: number, goodsSkuIntegral?: number, goodsSkuName?: string, goodsSkuOuterId?: string, goodsSkuSpecNames?: (string)[], id?: number, integral?: number, integralGoodsId?: number, orderId?: number, quantity?: number })[], orderNo?: string, pushIs?: boolean, receiverAddress?: string, receiverCity?: string, receiverDistrict?: string, receiverName?: string, receiverPhone?: string, receiverState?: string, receiverTime?: string, remark?: string, source?: "INTEGRAL_MALL" | "TRIAL", status?: "COMPLETED" | "SHIPPED" | "VOIDED" | "WAIT_SHIPPED", userId?: number, userNick?: string, userPhone?: string }, msg?: string }` successful operation
   */
  "/xinxuan/console/order/{id}_GET": (id: string, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xinxuan/console/order/${id}`,
      method: "GET",
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        cancelTime?: string;
        freight?: number;
        gmtCreate?: string;
        gmtModified?: string;
        id?: number;
        integral?: number;
        logisticsCompany?: string;
        logisticsNo?: string;
        logisticsTime?: string;
        orderItemVOList?: {
          gmtCreate?: string;
          gmtModified?: string;
          goodsCode?: string;
          goodsCoverImg?: string;
          goodsId?: number;
          goodsName?: string;
          goodsSkuId?: number;
          goodsSkuIntegral?: number;
          goodsSkuName?: string;
          goodsSkuOuterId?: string;
          goodsSkuSpecNames?: string[];
          id?: number;
          integral?: number;
          integralGoodsId?: number;
          orderId?: number;
          quantity?: number;
        }[];
        orderNo?: string;
        pushIs?: boolean;
        receiverAddress?: string;
        receiverCity?: string;
        receiverDistrict?: string;
        receiverName?: string;
        receiverPhone?: string;
        receiverState?: string;
        receiverTime?: string;
        remark?: string;
        source?: "INTEGRAL_MALL" | "TRIAL";
        status?: "COMPLETED" | "SHIPPED" | "VOIDED" | "WAIT_SHIPPED";
        userId?: number;
        userNick?: string;
        userPhone?: string;
      };
      msg?: string;
    }>,
  /**
   * No description
   * @name GET /xinxuan/console/order/integralList
   * @summary integralList
   * @tags order-controller
   * @response `200` `{ code?: number, data?: ({ cancelTime?: string, freight?: number, gmtCreate?: string, gmtModified?: string, id?: number, integral?: number, logisticsCompany?: string, logisticsNo?: string, logisticsTime?: string, orderItemVOList?: ({ gmtCreate?: string, gmtModified?: string, goodsCode?: string, goodsCoverImg?: string, goodsId?: number, goodsName?: string, goodsSkuId?: number, goodsSkuIntegral?: number, goodsSkuName?: string, goodsSkuOuterId?: string, goodsSkuSpecNames?: (string)[], id?: number, integral?: number, integralGoodsId?: number, orderId?: number, quantity?: number })[], orderNo?: string, pushIs?: boolean, receiverAddress?: string, receiverCity?: string, receiverDistrict?: string, receiverName?: string, receiverPhone?: string, receiverState?: string, receiverTime?: string, remark?: string, source?: "INTEGRAL_MALL" | "TRIAL", status?: "COMPLETED" | "SHIPPED" | "VOIDED" | "WAIT_SHIPPED", userId?: number, userNick?: string, userPhone?: string })[], msg?: string }` successful operation
   */
  "/xinxuan/console/order/integralList_GET": (
    query: XinxuanConsoleOrderIntegralListGetParams,
    raw: File,
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/order/integralList`,
      method: "GET",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        cancelTime?: string;
        freight?: number;
        gmtCreate?: string;
        gmtModified?: string;
        id?: number;
        integral?: number;
        logisticsCompany?: string;
        logisticsNo?: string;
        logisticsTime?: string;
        orderItemVOList?: {
          gmtCreate?: string;
          gmtModified?: string;
          goodsCode?: string;
          goodsCoverImg?: string;
          goodsId?: number;
          goodsName?: string;
          goodsSkuId?: number;
          goodsSkuIntegral?: number;
          goodsSkuName?: string;
          goodsSkuOuterId?: string;
          goodsSkuSpecNames?: string[];
          id?: number;
          integral?: number;
          integralGoodsId?: number;
          orderId?: number;
          quantity?: number;
        }[];
        orderNo?: string;
        pushIs?: boolean;
        receiverAddress?: string;
        receiverCity?: string;
        receiverDistrict?: string;
        receiverName?: string;
        receiverPhone?: string;
        receiverState?: string;
        receiverTime?: string;
        remark?: string;
        source?: "INTEGRAL_MALL" | "TRIAL";
        status?: "COMPLETED" | "SHIPPED" | "VOIDED" | "WAIT_SHIPPED";
        userId?: number;
        userNick?: string;
        userPhone?: string;
      }[];
      msg?: string;
    }>,
  /**
   * No description
   * @name PUT /xinxuan/console/order/receiverInfo
   * @summary modifyReceiverInfo
   * @tags order-controller
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xinxuan/console/order/receiverInfo_PUT": (
    root: {
      beginTime?: string;
      cancelTime?: string;
      endTime?: string;
      freight?: number;
      id?: number;
      integral?: number;
      keyword?: string;
      logisticsCompany?: string;
      logisticsNo?: string;
      logisticsTime?: string;
      orderField?: string;
      orderItemList?: {
        beginTime?: string;
        endTime?: string;
        goodsCode?: string;
        goodsCoverImg?: string;
        goodsId?: number;
        goodsName?: string;
        goodsSkuId?: number;
        goodsSkuIntegral?: number;
        goodsSkuOuterId?: string;
        goodsSkuSpecNames?: string[];
        id?: number;
        integral?: number;
        integralGoodsId?: number;
        keyword?: string;
        orderField?: string;
        orderId?: number;
        orderIds?: number[];
        orderScheme?: "ASC" | "DESC";
        pageNum?: number;
        pageSize?: number;
        quantity?: number;
        timeField?: string;
      }[];
      orderNo?: string;
      orderScheme?: "ASC" | "DESC";
      pageNum?: number;
      pageSize?: number;
      pushIs?: boolean;
      receiverAddress?: string;
      receiverCity?: string;
      receiverDistrict?: string;
      receiverName?: string;
      receiverPhone?: string;
      receiverState?: string;
      receiverTime?: string;
      remark?: string;
      source?: "INTEGRAL_MALL" | "TRIAL";
      status?: "COMPLETED" | "SHIPPED" | "VOIDED" | "WAIT_SHIPPED";
      timeField?: string;
      userId?: number;
      userNick?: string;
      userPhone?: string;
    },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/order/receiverInfo`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name GET /xinxuan/console/order
   * @summary page
   * @tags order-controller
   * @response `200` `{ code?: number, data?: { endRow?: number, firstPage?: number, hasNextPage?: boolean, hasPreviousPage?: boolean, isFirstPage?: boolean, isLastPage?: boolean, lastPage?: number, list?: ({ cancelTime?: string, freight?: number, gmtCreate?: string, gmtModified?: string, id?: number, integral?: number, logisticsCompany?: string, logisticsNo?: string, logisticsTime?: string, orderItemVOList?: ({ gmtCreate?: string, gmtModified?: string, goodsCode?: string, goodsCoverImg?: string, goodsId?: number, goodsName?: string, goodsSkuId?: number, goodsSkuIntegral?: number, goodsSkuName?: string, goodsSkuOuterId?: string, goodsSkuSpecNames?: (string)[], id?: number, integral?: number, integralGoodsId?: number, orderId?: number, quantity?: number })[], orderNo?: string, pushIs?: boolean, receiverAddress?: string, receiverCity?: string, receiverDistrict?: string, receiverName?: string, receiverPhone?: string, receiverState?: string, receiverTime?: string, remark?: string, source?: "INTEGRAL_MALL" | "TRIAL", status?: "COMPLETED" | "SHIPPED" | "VOIDED" | "WAIT_SHIPPED", userId?: number, userNick?: string, userPhone?: string })[], navigateFirstPage?: number, navigateLastPage?: number, navigatePages?: number, navigatepageNums?: (number)[], nextPage?: number, pageNum?: number, pageSize?: number, pages?: number, prePage?: number, size?: number, startRow?: number, total?: number }, msg?: string }` successful operation
   */
  "/xinxuan/console/order_GET": (query: XinxuanConsoleOrderGetParams, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xinxuan/console/order`,
      method: "GET",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        endRow?: number;
        firstPage?: number;
        hasNextPage?: boolean;
        hasPreviousPage?: boolean;
        isFirstPage?: boolean;
        isLastPage?: boolean;
        lastPage?: number;
        list?: {
          cancelTime?: string;
          freight?: number;
          gmtCreate?: string;
          gmtModified?: string;
          id?: number;
          integral?: number;
          logisticsCompany?: string;
          logisticsNo?: string;
          logisticsTime?: string;
          orderItemVOList?: {
            gmtCreate?: string;
            gmtModified?: string;
            goodsCode?: string;
            goodsCoverImg?: string;
            goodsId?: number;
            goodsName?: string;
            goodsSkuId?: number;
            goodsSkuIntegral?: number;
            goodsSkuName?: string;
            goodsSkuOuterId?: string;
            goodsSkuSpecNames?: string[];
            id?: number;
            integral?: number;
            integralGoodsId?: number;
            orderId?: number;
            quantity?: number;
          }[];
          orderNo?: string;
          pushIs?: boolean;
          receiverAddress?: string;
          receiverCity?: string;
          receiverDistrict?: string;
          receiverName?: string;
          receiverPhone?: string;
          receiverState?: string;
          receiverTime?: string;
          remark?: string;
          source?: "INTEGRAL_MALL" | "TRIAL";
          status?: "COMPLETED" | "SHIPPED" | "VOIDED" | "WAIT_SHIPPED";
          userId?: number;
          userNick?: string;
          userPhone?: string;
        }[];
        navigateFirstPage?: number;
        navigateLastPage?: number;
        navigatePages?: number;
        navigatepageNums?: number[];
        nextPage?: number;
        pageNum?: number;
        pageSize?: number;
        pages?: number;
        prePage?: number;
        size?: number;
        startRow?: number;
        total?: number;
      };
      msg?: string;
    }>,
  /**
   * No description
   * @name PUT /xinxuan/console/order/pushErp
   * @summary pushErp
   * @tags order-controller
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xinxuan/console/order/pushErp_PUT": (root: number[], options: RequestConfig = {}) =>
    requestInstance({
      url: `/xinxuan/console/order/pushErp`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name GET /xinxuan/console/integralGoodsCategory/all
   * @summary all
   * @tags 积分商品分类
   * @response `200` `{ code?: number, data?: ({ gmtCreate?: string, gmtModified?: string, id?: number, name?: string, shelfIs?: boolean, sort?: number })[], msg?: string }` successful operation
   */
  "/xinxuan/console/integralGoodsCategory/all_GET": (raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xinxuan/console/integralGoodsCategory/all`,
      method: "GET",
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        gmtCreate?: string;
        gmtModified?: string;
        id?: number;
        name?: string;
        shelfIs?: boolean;
        sort?: number;
      }[];
      msg?: string;
    }>,
  /**
   * No description
   * @name GET /xinxuan/console/integralGoodsCategory/{id}
   * @summary id查询
   * @tags 积分商品分类
   * @response `200` `{ code?: number, data?: { gmtCreate?: string, gmtModified?: string, id?: number, name?: string, shelfIs?: boolean, sort?: number }, msg?: string }` successful operation
   */
  "/xinxuan/console/integralGoodsCategory/{id}_GET": (id: string, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xinxuan/console/integralGoodsCategory/${id}`,
      method: "GET",
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: { gmtCreate?: string; gmtModified?: string; id?: number; name?: string; shelfIs?: boolean; sort?: number };
      msg?: string;
    }>,
  /**
   * No description
   * @name DELETE /xinxuan/console/integralGoodsCategory/{id}
   * @summary 删除
   * @tags 积分商品分类
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xinxuan/console/integralGoodsCategory/{id}_DELETE": (id: string, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xinxuan/console/integralGoodsCategory/${id}`,
      method: "DELETE",
      data: raw,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name PUT /xinxuan/console/integralGoodsCategory
   * @summary 修改
   * @tags 积分商品分类
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xinxuan/console/integralGoodsCategory_PUT": (
    root: {
      beginTime?: string;
      endTime?: string;
      id?: number;
      keyword?: string;
      name?: string;
      orderField?: string;
      orderScheme?: "ASC" | "DESC";
      pageNum?: number;
      pageSize?: number;
      shelfIs?: boolean;
      sort?: number;
      timeField?: string;
    },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/integralGoodsCategory`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name GET /xinxuan/console/integralGoodsCategory
   * @summary 分页查询
   * @tags 积分商品分类
   * @response `200` `{ code?: number, data?: { endRow?: number, firstPage?: number, hasNextPage?: boolean, hasPreviousPage?: boolean, isFirstPage?: boolean, isLastPage?: boolean, lastPage?: number, list?: ({ gmtCreate?: string, gmtModified?: string, id?: number, name?: string, shelfIs?: boolean, sort?: number })[], navigateFirstPage?: number, navigateLastPage?: number, navigatePages?: number, navigatepageNums?: (number)[], nextPage?: number, pageNum?: number, pageSize?: number, pages?: number, prePage?: number, size?: number, startRow?: number, total?: number }, msg?: string }` successful operation
   */
  "/xinxuan/console/integralGoodsCategory_GET": (
    query: XinxuanConsoleIntegralGoodsCategoryGetParams,
    raw: File,
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/integralGoodsCategory`,
      method: "GET",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        endRow?: number;
        firstPage?: number;
        hasNextPage?: boolean;
        hasPreviousPage?: boolean;
        isFirstPage?: boolean;
        isLastPage?: boolean;
        lastPage?: number;
        list?: {
          gmtCreate?: string;
          gmtModified?: string;
          id?: number;
          name?: string;
          shelfIs?: boolean;
          sort?: number;
        }[];
        navigateFirstPage?: number;
        navigateLastPage?: number;
        navigatePages?: number;
        navigatepageNums?: number[];
        nextPage?: number;
        pageNum?: number;
        pageSize?: number;
        pages?: number;
        prePage?: number;
        size?: number;
        startRow?: number;
        total?: number;
      };
      msg?: string;
    }>,
  /**
   * No description
   * @name POST /xinxuan/console/integralGoodsCategory
   * @summary 新增
   * @tags 积分商品分类
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xinxuan/console/integralGoodsCategory_POST": (
    root: {
      beginTime?: string;
      endTime?: string;
      id?: number;
      keyword?: string;
      name?: string;
      orderField?: string;
      orderScheme?: "ASC" | "DESC";
      pageNum?: number;
      pageSize?: number;
      shelfIs?: boolean;
      sort?: number;
      timeField?: string;
    },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/integralGoodsCategory`,
      method: "POST",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name GET /xinxuan/console/test/hello
   * @summary hello
   * @tags hello-controller
   * @response `200` `{ code?: number, data?: object, msg?: string }` successful operation
   */
  "/xinxuan/console/test/hello_GET": (
    query: XinxuanConsoleTestHelloGetParams,
    raw: File,
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/test/hello`,
      method: "GET",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{ code?: number; data?: object; msg?: string }>,
  /**
   * No description
   * @name PUT /xinxuan/console/console/sysConfig/task
   * @summary 更新固定任务配置
   * @tags 系统-配置管理
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xinxuan/console/console/sysConfig/task_PUT": (
    root: { growth?: number; integral?: number },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/console/sysConfig/task`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name GET /xinxuan/console/console/sysConfig/task
   * @summary 获取固定任务配置
   * @tags 系统-配置管理
   * @response `200` `{ code?: number, data?: { growth?: number, integral?: number }, msg?: string }` successful operation
   */
  "/xinxuan/console/console/sysConfig/task_GET": (raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xinxuan/console/console/sysConfig/task`,
      method: "GET",
      data: raw,
      ...options
    }) as unknown as Promise<{ code?: number; data?: { growth?: number; integral?: number }; msg?: string }>,
  /**
   * No description
   * @name PUT /xinxuan/console/console/sysConfig/groupCreationLevel
   * @summary 更新圈子创建等级配置
   * @tags 系统-配置管理
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xinxuan/console/console/sysConfig/groupCreationLevel_PUT": (
    root: { code?: string; value?: string },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/console/sysConfig/groupCreationLevel`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name GET /xinxuan/console/console/sysConfig/groupCreationLevel
   * @summary 获取圈子创建等级配置
   * @tags 系统-配置管理
   * @response `200` `{ code?: number, data?: { code?: string, createUser?: string, enabled?: boolean, gmtCreated?: string, gmtModified?: string, id?: number, modifyUser?: string, name?: string, status?: number, value?: string }, msg?: string }` successful operation
   */
  "/xinxuan/console/console/sysConfig/groupCreationLevel_GET": (raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xinxuan/console/console/sysConfig/groupCreationLevel`,
      method: "GET",
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        code?: string;
        createUser?: string;
        enabled?: boolean;
        gmtCreated?: string;
        gmtModified?: string;
        id?: number;
        modifyUser?: string;
        name?: string;
        status?: number;
        value?: string;
      };
      msg?: string;
    }>,
  /**
   * @description 请求示例 ``` [ { "day": 1, "integral": 1, "growth": 1 }, { "day": 2, "integral": 1, "growth": 1 }, { "day": 3, "integral": 1, "growth": 1 }, { "day": 4, "integral": 1, "growth": 1 }, { "day": 5, "integral": 1, "growth": 1 }, { "day": 6, "integral": 1, "growth": 1 }, { "day": 7, "integral": 1, "growth": 1 } ] ```
   * @name PUT /xinxuan/console/console/sysConfig/sign
   * @summary 更新签到配置
   * @tags 系统-配置管理
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xinxuan/console/console/sysConfig/sign_PUT": (
    root: { day?: number; growth?: number; integral?: number }[],
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/console/sysConfig/sign`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name GET /xinxuan/console/console/sysConfig/sign
   * @summary 获取签到配置
   * @tags 系统-配置管理
   * @response `200` `{ code?: number, data?: ({ day?: number, growth?: number, integral?: number })[], msg?: string }` successful operation
   */
  "/xinxuan/console/console/sysConfig/sign_GET": (raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xinxuan/console/console/sysConfig/sign`,
      method: "GET",
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: { day?: number; growth?: number; integral?: number }[];
      msg?: string;
    }>,
  /**
   * No description
   * @name DELETE /xinxuan/console/trial/{id}
   * @summary 删除活动
   * @tags 试用活动相关接口
   * @response `200` `{ code?: number, data?: object, msg?: string }` successful operation
   */
  "/xinxuan/console/trial/{id}_DELETE": (id: string, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xinxuan/console/trial/${id}`,
      method: "DELETE",
      data: raw,
      ...options
    }) as unknown as Promise<{ code?: number; data?: object; msg?: string }>,
  /**
   * No description
   * @name POST /xinxuan/console/trial/{id}
   * @summary 活动详情
   * @tags 试用活动相关接口
   * @response `200` `{ code?: number, data?: { activityImg?: string, activityName?: string, activityStatus?: number, applyBeginTime?: string, applyEndTime?: string, applyThresholdLevel?: (object)[], applyThresholdStatus?: boolean, feedbackNum?: number, goodsCoverImg?: string, goodsDetail?: { bannerImgs?: (string)[], code?: string, coverImg?: string, detailDesc?: string, gmtCreate?: string, gmtModified?: string, goodsPropertyList?: ({ gmtCreate?: string, gmtModified?: string, goodsId?: number, id?: number, propName?: string, propertyValueList?: (object)[] })[], id?: number, integralIs?: boolean, name?: string, outerId?: string, salesVolume?: number, skuList?: ({ code?: string, gmtCreate?: string, gmtModified?: string, goodsId?: number, id?: number, integral?: number, integralSalesVolume?: number, integralShelfIs?: boolean, integralStock?: number, outerId?: string, outerPrice?: number, price?: number, salesVolume?: number, shelfIs?: boolean, skuImg?: string, skuName?: string, specIds?: (number)[], specNames?: (string)[], stock?: number, version?: string })[], stock?: number, trialIs?: boolean }, goodsId?: number, goodsList?: ({ activityId?: number, delIs?: boolean, gmtCreate?: string, gmtModified?: string, goodsId?: number, goodsName?: string, goodsNo?: string, goodsPrice?: number, id?: number, skuId?: number, skuImg?: string, specName?: string, trialNumber?: number })[], goodsName?: string, goodsNum?: number, id?: number, indexStatus?: boolean, participateNum?: number, reportDeadline?: string, richText?: string, status?: boolean, winNum?: number }, msg?: string }` successful operation
   */
  "/xinxuan/console/trial/{id}_POST": (id: string, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xinxuan/console/trial/${id}`,
      method: "POST",
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        activityImg?: string;
        activityName?: string;
        activityStatus?: number;
        applyBeginTime?: string;
        applyEndTime?: string;
        applyThresholdLevel?: object[];
        applyThresholdStatus?: boolean;
        feedbackNum?: number;
        goodsCoverImg?: string;
        goodsDetail?: {
          bannerImgs?: string[];
          code?: string;
          coverImg?: string;
          detailDesc?: string;
          gmtCreate?: string;
          gmtModified?: string;
          goodsPropertyList?: {
            gmtCreate?: string;
            gmtModified?: string;
            goodsId?: number;
            id?: number;
            propName?: string;
            propertyValueList?: object[];
          }[];
          id?: number;
          integralIs?: boolean;
          name?: string;
          outerId?: string;
          salesVolume?: number;
          skuList?: {
            code?: string;
            gmtCreate?: string;
            gmtModified?: string;
            goodsId?: number;
            id?: number;
            integral?: number;
            integralSalesVolume?: number;
            integralShelfIs?: boolean;
            integralStock?: number;
            outerId?: string;
            outerPrice?: number;
            price?: number;
            salesVolume?: number;
            shelfIs?: boolean;
            skuImg?: string;
            skuName?: string;
            specIds?: number[];
            specNames?: string[];
            stock?: number;
            version?: string;
          }[];
          stock?: number;
          trialIs?: boolean;
        };
        goodsId?: number;
        goodsList?: {
          activityId?: number;
          delIs?: boolean;
          gmtCreate?: string;
          gmtModified?: string;
          goodsId?: number;
          goodsName?: string;
          goodsNo?: string;
          goodsPrice?: number;
          id?: number;
          skuId?: number;
          skuImg?: string;
          specName?: string;
          trialNumber?: number;
        }[];
        goodsName?: string;
        goodsNum?: number;
        id?: number;
        indexStatus?: boolean;
        participateNum?: number;
        reportDeadline?: string;
        richText?: string;
        status?: boolean;
        winNum?: number;
      };
      msg?: string;
    }>,
  /**
   * No description
   * @name POST /xinxuan/console/trial
   * @summary 添加活动
   * @tags 试用活动相关接口
   * @response `200` `{ code?: number, data?: object, msg?: string }` successful operation
   */
  "/xinxuan/console/trial_POST": (
    root: {
      activityImg?: string;
      activityName?: string;
      applyBeginTime?: string;
      applyEndTime?: string;
      applyThresholdLevel?: object[];
      applyThresholdStatus: boolean;
      goodsCoverImg?: string;
      goodsId: number;
      goodsList?: {
        activityId?: number;
        delIs?: boolean;
        gmtCreate?: string;
        gmtModified?: string;
        goodsId?: number;
        goodsName?: string;
        goodsNo?: string;
        goodsPrice?: number;
        id?: number;
        skuId?: number;
        skuImg?: string;
        specName?: string;
        trialNumber?: number;
      }[];
      goodsName?: string;
      id?: number;
      reportDeadline?: string;
      richText?: string;
      status?: boolean;
    },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/trial`,
      method: "POST",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; data?: object; msg?: string }>,
  /**
   * No description
   * @name GET /xinxuan/console/trial
   * @summary 试用活动列表
   * @tags 试用活动相关接口
   * @response `200` `{ code?: number, data?: { endRow?: number, firstPage?: number, hasNextPage?: boolean, hasPreviousPage?: boolean, isFirstPage?: boolean, isLastPage?: boolean, lastPage?: number, list?: ({ activityImg?: string, activityName?: string, activityStatus?: number, applyBeginTime?: string, applyEndTime?: string, applyThresholdLevel?: (object)[], applyThresholdStatus?: boolean, feedbackNum?: number, goodsCoverImg?: string, goodsDetail?: { bannerImgs?: (string)[], code?: string, coverImg?: string, detailDesc?: string, gmtCreate?: string, gmtModified?: string, goodsPropertyList?: ({ gmtCreate?: string, gmtModified?: string, goodsId?: number, id?: number, propName?: string, propertyValueList?: (object)[] })[], id?: number, integralIs?: boolean, name?: string, outerId?: string, salesVolume?: number, skuList?: ({ code?: string, gmtCreate?: string, gmtModified?: string, goodsId?: number, id?: number, integral?: number, integralSalesVolume?: number, integralShelfIs?: boolean, integralStock?: number, outerId?: string, outerPrice?: number, price?: number, salesVolume?: number, shelfIs?: boolean, skuImg?: string, skuName?: string, specIds?: (number)[], specNames?: (string)[], stock?: number, version?: string })[], stock?: number, trialIs?: boolean }, goodsId?: number, goodsList?: ({ activityId?: number, delIs?: boolean, gmtCreate?: string, gmtModified?: string, goodsId?: number, goodsName?: string, goodsNo?: string, goodsPrice?: number, id?: number, skuId?: number, skuImg?: string, specName?: string, trialNumber?: number })[], goodsName?: string, goodsNum?: number, id?: number, indexStatus?: boolean, participateNum?: number, reportDeadline?: string, richText?: string, status?: boolean, winNum?: number })[], navigateFirstPage?: number, navigateLastPage?: number, navigatePages?: number, navigatepageNums?: (number)[], nextPage?: number, pageNum?: number, pageSize?: number, pages?: number, prePage?: number, size?: number, startRow?: number, total?: number }, msg?: string }` successful operation
   */
  "/xinxuan/console/trial_GET": (query: XinxuanConsoleTrialGetParams, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xinxuan/console/trial`,
      method: "GET",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        endRow?: number;
        firstPage?: number;
        hasNextPage?: boolean;
        hasPreviousPage?: boolean;
        isFirstPage?: boolean;
        isLastPage?: boolean;
        lastPage?: number;
        list?: {
          activityImg?: string;
          activityName?: string;
          activityStatus?: number;
          applyBeginTime?: string;
          applyEndTime?: string;
          applyThresholdLevel?: object[];
          applyThresholdStatus?: boolean;
          feedbackNum?: number;
          goodsCoverImg?: string;
          goodsDetail?: {
            bannerImgs?: string[];
            code?: string;
            coverImg?: string;
            detailDesc?: string;
            gmtCreate?: string;
            gmtModified?: string;
            goodsPropertyList?: {
              gmtCreate?: string;
              gmtModified?: string;
              goodsId?: number;
              id?: number;
              propName?: string;
              propertyValueList?: object[];
            }[];
            id?: number;
            integralIs?: boolean;
            name?: string;
            outerId?: string;
            salesVolume?: number;
            skuList?: {
              code?: string;
              gmtCreate?: string;
              gmtModified?: string;
              goodsId?: number;
              id?: number;
              integral?: number;
              integralSalesVolume?: number;
              integralShelfIs?: boolean;
              integralStock?: number;
              outerId?: string;
              outerPrice?: number;
              price?: number;
              salesVolume?: number;
              shelfIs?: boolean;
              skuImg?: string;
              skuName?: string;
              specIds?: number[];
              specNames?: string[];
              stock?: number;
              version?: string;
            }[];
            stock?: number;
            trialIs?: boolean;
          };
          goodsId?: number;
          goodsList?: {
            activityId?: number;
            delIs?: boolean;
            gmtCreate?: string;
            gmtModified?: string;
            goodsId?: number;
            goodsName?: string;
            goodsNo?: string;
            goodsPrice?: number;
            id?: number;
            skuId?: number;
            skuImg?: string;
            specName?: string;
            trialNumber?: number;
          }[];
          goodsName?: string;
          goodsNum?: number;
          id?: number;
          indexStatus?: boolean;
          participateNum?: number;
          reportDeadline?: string;
          richText?: string;
          status?: boolean;
          winNum?: number;
        }[];
        navigateFirstPage?: number;
        navigateLastPage?: number;
        navigatePages?: number;
        navigatepageNums?: number[];
        nextPage?: number;
        pageNum?: number;
        pageSize?: number;
        pages?: number;
        prePage?: number;
        size?: number;
        startRow?: number;
        total?: number;
      };
      msg?: string;
    }>,
  /**
   * No description
   * @name PUT /xinxuan/console/trial/indexStatus
   * @summary 设置首页是否显示
   * @tags 试用活动相关接口
   * @response `200` `{ code?: number, data?: object, msg?: string }` successful operation
   */
  "/xinxuan/console/trial/indexStatus_PUT": (root: { id?: number; status?: boolean }, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xinxuan/console/trial/indexStatus`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; data?: object; msg?: string }>,
  /**
   * No description
   * @name GET /xinxuan/console/trial/record
   * @summary 试用记录
   * @tags 试用活动相关接口
   * @response `200` `{ code?: number, data?: { endRow?: number, firstPage?: number, hasNextPage?: boolean, hasPreviousPage?: boolean, isFirstPage?: boolean, isLastPage?: boolean, lastPage?: number, list?: ({ activityId?: number, activityName?: string, applyTime?: string, blackStatus?: boolean, feedbackContent?: string, feedbackEndTime?: string, feedbackImg?: (object)[], feedbackScore?: number, feedbackStatus?: boolean, feedbackSubmitTime?: string, goodsId?: number, goodsImg?: string, goodsName?: string, goodsNo?: string, id?: number, logisticsCompany?: string, logisticsNo?: string, pushStatus?: boolean, receiverAddress?: string, receiverName?: string, receiverPhone?: string, receiverStatus?: boolean, resultStatus?: boolean, skuId?: number, specName?: string, userId?: number, userMobile?: string, userName?: string })[], navigateFirstPage?: number, navigateLastPage?: number, navigatePages?: number, navigatepageNums?: (number)[], nextPage?: number, pageNum?: number, pageSize?: number, pages?: number, prePage?: number, size?: number, startRow?: number, total?: number }, msg?: string }` successful operation
   */
  "/xinxuan/console/trial/record_GET": (
    query: XinxuanConsoleTrialRecordGetParams,
    raw: File,
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/trial/record`,
      method: "GET",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        endRow?: number;
        firstPage?: number;
        hasNextPage?: boolean;
        hasPreviousPage?: boolean;
        isFirstPage?: boolean;
        isLastPage?: boolean;
        lastPage?: number;
        list?: {
          activityId?: number;
          activityName?: string;
          applyTime?: string;
          blackStatus?: boolean;
          feedbackContent?: string;
          feedbackEndTime?: string;
          feedbackImg?: object[];
          feedbackScore?: number;
          feedbackStatus?: boolean;
          feedbackSubmitTime?: string;
          goodsId?: number;
          goodsImg?: string;
          goodsName?: string;
          goodsNo?: string;
          id?: number;
          logisticsCompany?: string;
          logisticsNo?: string;
          pushStatus?: boolean;
          receiverAddress?: string;
          receiverName?: string;
          receiverPhone?: string;
          receiverStatus?: boolean;
          resultStatus?: boolean;
          skuId?: number;
          specName?: string;
          userId?: number;
          userMobile?: string;
          userName?: string;
        }[];
        navigateFirstPage?: number;
        navigateLastPage?: number;
        navigatePages?: number;
        navigatepageNums?: number[];
        nextPage?: number;
        pageNum?: number;
        pageSize?: number;
        pages?: number;
        prePage?: number;
        size?: number;
        startRow?: number;
        total?: number;
      };
      msg?: string;
    }>,
  /**
   * No description
   * @name POST /xinxuan/console/muteWords
   * @summary 创建敏感词
   * @tags 敏感词管理
   * @response `200` `{ code?: number, data?: { content: string, contentReplace: string, id: number }, msg?: string }` successful operation
   */
  "/xinxuan/console/muteWords_POST": (root: { content: string; contentReplace: string }, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xinxuan/console/muteWords`,
      method: "POST",
      data: root,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: { content: string; contentReplace: string; id: number };
      msg?: string;
    }>,
  /**
   * No description
   * @name GET /xinxuan/console/muteWords
   * @summary 搜索敏感词
   * @tags 敏感词管理
   * @response `200` `{ code?: number, data?: { endRow?: number, firstPage?: number, hasNextPage?: boolean, hasPreviousPage?: boolean, isFirstPage?: boolean, isLastPage?: boolean, lastPage?: number, list?: ({ content: string, contentReplace: string, id: number })[], navigateFirstPage?: number, navigateLastPage?: number, navigatePages?: number, navigatepageNums?: (number)[], nextPage?: number, pageNum?: number, pageSize?: number, pages?: number, prePage?: number, size?: number, startRow?: number, total?: number }, msg?: string }` successful operation
   */
  "/xinxuan/console/muteWords_GET": (query: XinxuanConsoleMuteWordsGetParams, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xinxuan/console/muteWords`,
      method: "GET",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        endRow?: number;
        firstPage?: number;
        hasNextPage?: boolean;
        hasPreviousPage?: boolean;
        isFirstPage?: boolean;
        isLastPage?: boolean;
        lastPage?: number;
        list?: { content: string; contentReplace: string; id: number }[];
        navigateFirstPage?: number;
        navigateLastPage?: number;
        navigatePages?: number;
        navigatepageNums?: number[];
        nextPage?: number;
        pageNum?: number;
        pageSize?: number;
        pages?: number;
        prePage?: number;
        size?: number;
        startRow?: number;
        total?: number;
      };
      msg?: string;
    }>,
  /**
   * No description
   * @name DELETE /xinxuan/console/muteWords/{id}
   * @summary 删除敏感词
   * @tags 敏感词管理
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xinxuan/console/muteWords/{id}_DELETE": (id: string, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xinxuan/console/muteWords/${id}`,
      method: "DELETE",
      data: raw,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name PUT /xinxuan/console/muteWords/{id}
   * @summary 更新敏感词
   * @tags 敏感词管理
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xinxuan/console/muteWords/{id}_PUT": (
    id: string,
    root: { content: string; contentReplace: string },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/muteWords/${id}`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name GET /xinxuan/console/muteWords/{id}
   * @summary 详情
   * @tags 敏感词管理
   * @response `200` `{ code?: number, data?: { content: string, contentReplace: string, id: number }, msg?: string }` successful operation
   */
  "/xinxuan/console/muteWords/{id}_GET": (id: string, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xinxuan/console/muteWords/${id}`,
      method: "GET",
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: { content: string; contentReplace: string; id: number };
      msg?: string;
    }>,
  /**
   * No description
   * @name PUT /xinxuan/console/live/status
   * @summary 修改直播状态
   * @tags 直播相关接口
   * @response `200` `{ code?: number, data?: object, msg?: string }` successful operation
   */
  "/xinxuan/console/live/status_PUT": (root: { id?: number; status?: boolean }, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xinxuan/console/live/status`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; data?: object; msg?: string }>,
  /**
   * No description
   * @name GET /xinxuan/console/live
   * @summary 查询直播列表
   * @tags 直播相关接口
   * @response `200` `{ code?: number, data?: ({ anchorImg?: string, anchorName?: string, homeImg?: string, id?: number, initialNumber?: number, introduction?: string, liveDesc?: string, liveName?: string, liveTime?: string, posterStatus?: boolean, promotionalVideo?: (object)[], status?: boolean, studioId?: number, studioName?: string, subscribeNum?: number, subscribeNumber?: number, trailerRich?: string })[], msg?: string }` successful operation
   */
  "/xinxuan/console/live_GET": (query: XinxuanConsoleLiveGetParams, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xinxuan/console/live`,
      method: "GET",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        anchorImg?: string;
        anchorName?: string;
        homeImg?: string;
        id?: number;
        initialNumber?: number;
        introduction?: string;
        liveDesc?: string;
        liveName?: string;
        liveTime?: string;
        posterStatus?: boolean;
        promotionalVideo?: object[];
        status?: boolean;
        studioId?: number;
        studioName?: string;
        subscribeNum?: number;
        subscribeNumber?: number;
        trailerRich?: string;
      }[];
      msg?: string;
    }>,
          /**
   * No description
   * @name PUT /community/console/live
   * @summary 新增直播
   * @tags 直播相关接口
   * @response `200` `{ code?: number, data?: object, msg?: string }` successful operation
   */
  "/xinxuan/console/live_POST": (
    root: {
      anchorImg: string;
      anchorName: string;
      homeImg: string;
      id?: number;
      initialNumber?: number;
      introduction: string;
      liveDesc: string;
      liveName: string;
      promotionalVideo: object[];
      trailerRich?: string;
    },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/live`,
      method: "POST",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; data?: object; msg?: string }>,
  /**
   * No description
   * @name PUT /xinxuan/console/live
   * @summary 编辑直播
   * @tags 直播相关接口
   * @response `200` `{ code?: number, data?: object, msg?: string }` successful operation
   */
  "/xinxuan/console/live_PUT": (
    root: {
      anchorImg: string;
      anchorName: string;
      homeImg: string;
      id?: number;
      initialNumber?: number;
      introduction: string;
      liveDesc: string;
      liveName: string;
      promotionalVideo: object[];
      trailerRich?: string;
    },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/live`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; data?: object; msg?: string }>,
  /**
   * No description
   * @name GET /xinxuan/console/live/{id}
   * @summary 查询直播详情
   * @tags 直播相关接口
   * @response `200` `{ code?: number, data?: { anchorImg?: string, anchorName?: string, homeImg?: string, id?: number, initialNumber?: number, introduction?: string, liveDesc?: string, liveName?: string, liveTime?: string, posterStatus?: boolean, promotionalVideo?: (object)[], status?: boolean, studioId?: number, studioName?: string, subscribeNum?: number, subscribeNumber?: number, trailerRich?: string }, msg?: string }` successful operation
   */
  "/xinxuan/console/live/{id}_GET": (id: string, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xinxuan/console/live/${id}`,
      method: "GET",
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        anchorImg?: string;
        anchorName?: string;
        homeImg?: string;
        id?: number;
        initialNumber?: number;
        introduction?: string;
        liveDesc?: string;
        liveName?: string;
        liveTime?: string;
        posterStatus?: boolean;
        promotionalVideo?: object[];
        status?: boolean;
        studioId?: number;
        studioName?: string;
        subscribeNum?: number;
        subscribeNumber?: number;
        trailerRich?: string;
      };
      msg?: string;
    }>,
  /**
   * No description
   * @name GET /xinxuan/console/oss/policy
   * @summary 获取OSS临时凭证
   * @tags oss-console-controller
   * @response `200` `{ code?: number, data?: object, msg?: string }` successful operation
   */
  "/xinxuan/console/oss/policy_GET": (
    query: XinxuanConsoleOssPolicyGetParams,
    raw: File,
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/oss/policy`,
      method: "GET",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{ code?: number; data?: object; msg?: string }>,
  /**
   * No description
   * @name GET /xinxuan/console/lotteryRecord
   * @summary 查询抽奖记录
   * @tags 抽奖查询接口
   * @response `200` `{ code?: number, data?: { endRow?: number, firstPage?: number, hasNextPage?: boolean, hasPreviousPage?: boolean, isFirstPage?: boolean, isLastPage?: boolean, lastPage?: number, list?: ({ activityId: number, activityName?: string, consumeIntegral?: number, drawTime?: string, expirationTime?: string, express?: string, expressNo?: string, gmtCreate?: string, gmtModified?: string, id?: number, lotteryResult: boolean, lotteryTime?: string, operationTime?: string, operator?: string, prizeName?: string, prizeType?: number, receiveStatus?: boolean, receiveTime?: string, recipient?: string, recipientAddress?: string, recipientMobile?: string, shippingStatus?: boolean, type: number, userId: number, userMobile?: string, userName?: string })[], navigateFirstPage?: number, navigateLastPage?: number, navigatePages?: number, navigatepageNums?: (number)[], nextPage?: number, pageNum?: number, pageSize?: number, pages?: number, prePage?: number, size?: number, startRow?: number, total?: number }, msg?: string }` successful operation
   */
  "/xinxuan/console/lotteryRecord_GET": (
    query: XinxuanConsoleLotteryRecordGetParams,
    raw: File,
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/lotteryRecord`,
      method: "GET",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        endRow?: number;
        firstPage?: number;
        hasNextPage?: boolean;
        hasPreviousPage?: boolean;
        isFirstPage?: boolean;
        isLastPage?: boolean;
        lastPage?: number;
        list?: {
          activityId: number;
          activityName?: string;
          consumeIntegral?: number;
          drawTime?: string;
          expirationTime?: string;
          express?: string;
          expressNo?: string;
          gmtCreate?: string;
          gmtModified?: string;
          id?: number;
          lotteryResult: boolean;
          lotteryTime?: string;
          operationTime?: string;
          operator?: string;
          prizeName?: string;
          prizeType?: number;
          receiveStatus?: boolean;
          receiveTime?: string;
          recipient?: string;
          recipientAddress?: string;
          recipientMobile?: string;
          shippingStatus?: boolean;
          type: number;
          userId: number;
          userMobile?: string;
          userName?: string;
        }[];
        navigateFirstPage?: number;
        navigateLastPage?: number;
        navigatePages?: number;
        navigatepageNums?: number[];
        nextPage?: number;
        pageNum?: number;
        pageSize?: number;
        pages?: number;
        prePage?: number;
        size?: number;
        startRow?: number;
        total?: number;
      };
      msg?: string;
    }>,
  /**
   * No description
   * @name POST /xinxuan/console/lotteryRecord
   * @summary 确认发货
   * @tags 抽奖查询接口
   * @response `200` `{ code?: number, data?: object, msg?: string }` successful operation
   */
  "/xinxuan/console/lotteryRecord_POST": (
    root: { express: string; expressNo: string; id: number },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/lotteryRecord`,
      method: "POST",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; data?: object; msg?: string }>,
  /**
   * No description
   * @name PUT /xinxuan/console/tags/tags4groups
   * @summary 为圈子添加tag
   * @tags 标签-标签管理
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xinxuan/console/tags/tags4groups_PUT": (
    root: { groupIds?: number[]; tagIds?: number[] },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/tags/tags4groups`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name PUT /xinxuan/console/tags/tags4users
   * @summary 为用户添加tag
   * @tags 标签-标签管理
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xinxuan/console/tags/tags4users_PUT": (
    root: { tagIds?: number[]; userIds?: number[] },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/tags/tags4users`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name PUT /xinxuan/console/tags/{id}
   * @summary 修改标签
   * @tags 标签-标签管理
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xinxuan/console/tags/{id}_PUT": (
    id: string,
    root: { categoryId?: number; enabled?: boolean; groupCnt?: number; id: number; memberCnt: number; name: string },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/tags/${id}`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name DELETE /xinxuan/console/tags/{id}
   * @summary 删除标签
   * @tags 标签-标签管理
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xinxuan/console/tags/{id}_DELETE": (id: string, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xinxuan/console/tags/${id}`,
      method: "DELETE",
      data: raw,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name PUT /xinxuan/console/tags/enable
   * @summary 启用/禁用标签
   * @tags 标签-标签管理
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xinxuan/console/tags/enable_PUT": (root: { decision?: boolean; id?: number }, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xinxuan/console/tags/enable`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name GET /xinxuan/console/tags
   * @summary 搜索标签
   * @tags 标签-标签管理
   * @response `200` `{ code?: number, data?: { endRow?: number, firstPage?: number, hasNextPage?: boolean, hasPreviousPage?: boolean, isFirstPage?: boolean, isLastPage?: boolean, lastPage?: number, list?: ({ categoryId: number, categoryName: string, enabled: boolean, groupCnt: number, id: number, memberCnt: number, name: string })[], navigateFirstPage?: number, navigateLastPage?: number, navigatePages?: number, navigatepageNums?: (number)[], nextPage?: number, pageNum?: number, pageSize?: number, pages?: number, prePage?: number, size?: number, startRow?: number, total?: number }, msg?: string }` successful operation
   */
  "/xinxuan/console/tags_GET": (query: XinxuanConsoleTagsGetParams, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xinxuan/console/tags`,
      method: "GET",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        endRow?: number;
        firstPage?: number;
        hasNextPage?: boolean;
        hasPreviousPage?: boolean;
        isFirstPage?: boolean;
        isLastPage?: boolean;
        lastPage?: number;
        list?: {
          categoryId: number;
          categoryName: string;
          enabled: boolean;
          groupCnt: number;
          id: number;
          memberCnt: number;
          name: string;
        }[];
        navigateFirstPage?: number;
        navigateLastPage?: number;
        navigatePages?: number;
        navigatepageNums?: number[];
        nextPage?: number;
        pageNum?: number;
        pageSize?: number;
        pages?: number;
        prePage?: number;
        size?: number;
        startRow?: number;
        total?: number;
      };
      msg?: string;
    }>,
  /**
   * No description
   * @name POST /xinxuan/console/tags
   * @summary 标签创建
   * @tags 标签-标签管理
   * @response `200` `{ code?: number, data?: { categoryId: number, categoryName: string, enabled: boolean, groupCnt: number, id: number, memberCnt: number, name: string }, msg?: string }` successful operation
   */
  "/xinxuan/console/tags_POST": (
    root: { categoryId?: number; enabled?: boolean; groupCnt?: number; id: number; memberCnt: number; name: string },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/tags`,
      method: "POST",
      data: root,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        categoryId: number;
        categoryName: string;
        enabled: boolean;
        groupCnt: number;
        id: number;
        memberCnt: number;
        name: string;
      };
      msg?: string;
    }>,
  /**
   * No description
   * @name PUT /xinxuan/console/tagCategories/{id}
   * @summary 修改标签分组
   * @tags 标签分组管理
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xinxuan/console/tagCategories/{id}_PUT": (id: string, root: { name: string }, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xinxuan/console/tagCategories/${id}`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name DELETE /xinxuan/console/tagCategories/{id}
   * @summary 删除标签分组
   * @tags 标签分组管理
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xinxuan/console/tagCategories/{id}_DELETE": (id: string, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xinxuan/console/tagCategories/${id}`,
      method: "DELETE",
      data: raw,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name GET /xinxuan/console/tagCategories
   * @summary 所有标签分组
   * @tags 标签分组管理
   * @response `200` `{ code?: number, data?: ({ id: number, name: string })[], msg?: string }` successful operation
   */
  "/xinxuan/console/tagCategories_GET": (raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xinxuan/console/tagCategories`,
      method: "GET",
      data: raw,
      ...options
    }) as unknown as Promise<{ code?: number; data?: { id: number; name: string }[]; msg?: string }>,
  /**
   * No description
   * @name POST /xinxuan/console/tagCategories
   * @summary 标签分组创建
   * @tags 标签分组管理
   * @response `200` `{ code?: number, data?: { id: number, name: string }, msg?: string }` successful operation
   */
  "/xinxuan/console/tagCategories_POST": (root: { name: string }, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xinxuan/console/tagCategories`,
      method: "POST",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; data?: { id: number; name: string }; msg?: string }>,
  /**
   * No description
   * @name GET /xinxuan/console/workOrder
   * @summary 工单列表
   * @tags 工单-问题反馈接口
   * @response `200` `{ code?: number, data?: { endRow?: number, firstPage?: number, hasNextPage?: boolean, hasPreviousPage?: boolean, isFirstPage?: boolean, isLastPage?: boolean, lastPage?: number, list?: ({ auditStatus?: number, content?: string, disposeTime?: string, gaiaAuditTime?: string, gaiaStatus?: number, gaiaUser?: string, gmtCreate?: string, gmtModified?: string, id?: number, imgUrl?: (object)[], sysAuditContent?: string, sysAuditImg?: (object)[], sysAuditTime?: string, sysAuditUser?: string, sysAuditUserId?: number, type?: number, userId?: number, userMobile?: string, userName?: string })[], navigateFirstPage?: number, navigateLastPage?: number, navigatePages?: number, navigatepageNums?: (number)[], nextPage?: number, pageNum?: number, pageSize?: number, pages?: number, prePage?: number, size?: number, startRow?: number, total?: number }, msg?: string }` successful operation
   */
  "/xinxuan/console/workOrder_GET": (query: XinxuanConsoleWorkOrderGetParams, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xinxuan/console/workOrder`,
      method: "GET",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        endRow?: number;
        firstPage?: number;
        hasNextPage?: boolean;
        hasPreviousPage?: boolean;
        isFirstPage?: boolean;
        isLastPage?: boolean;
        lastPage?: number;
        list?: {
          auditStatus?: number;
          content?: string;
          disposeTime?: string;
          gaiaAuditTime?: string;
          gaiaStatus?: number;
          gaiaUser?: string;
          gmtCreate?: string;
          gmtModified?: string;
          id?: number;
          imgUrl?: object[];
          sysAuditContent?: string;
          sysAuditImg?: object[];
          sysAuditTime?: string;
          sysAuditUser?: string;
          sysAuditUserId?: number;
          type?: number;
          userId?: number;
          userMobile?: string;
          userName?: string;
        }[];
        navigateFirstPage?: number;
        navigateLastPage?: number;
        navigatePages?: number;
        navigatepageNums?: number[];
        nextPage?: number;
        pageNum?: number;
        pageSize?: number;
        pages?: number;
        prePage?: number;
        size?: number;
        startRow?: number;
        total?: number;
      };
      msg?: string;
    }>,
  /**
   * No description
   * @name POST /xinxuan/console/workOrder
   * @summary 平台审核
   * @tags 工单-问题反馈接口
   * @response `200` `{ code?: number, data?: object, msg?: string }` successful operation
   */
  "/xinxuan/console/workOrder_POST": (
    root: { id: number; pushStatus: boolean; sysAuditContent?: string; sysAuditImg?: object[] },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/workOrder`,
      method: "POST",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; data?: object; msg?: string }>,
  /**
   * No description
   * @name GET /xinxuan/console/workOrder/{id}
   * @summary 工单详情
   * @tags 工单-问题反馈接口
   * @response `200` `{ code?: number, data?: { auditStatus?: number, content?: string, disposeTime?: string, gaiaAuditTime?: string, gaiaStatus?: number, gaiaUser?: string, gmtCreate?: string, gmtModified?: string, id?: number, imgUrl?: (object)[], sysAuditContent?: string, sysAuditImg?: (object)[], sysAuditTime?: string, sysAuditUser?: string, sysAuditUserId?: number, type?: number, userId?: number, userMobile?: string, userName?: string }, msg?: string }` successful operation
   */
  "/xinxuan/console/workOrder/{id}_GET": (id: string, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xinxuan/console/workOrder/${id}`,
      method: "GET",
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        auditStatus?: number;
        content?: string;
        disposeTime?: string;
        gaiaAuditTime?: string;
        gaiaStatus?: number;
        gaiaUser?: string;
        gmtCreate?: string;
        gmtModified?: string;
        id?: number;
        imgUrl?: object[];
        sysAuditContent?: string;
        sysAuditImg?: object[];
        sysAuditTime?: string;
        sysAuditUser?: string;
        sysAuditUserId?: number;
        type?: number;
        userId?: number;
        userMobile?: string;
        userName?: string;
      };
      msg?: string;
    }>,
  /**
   * No description
   * @name GET /xinxuan/console/workOrder/{id}/confirm
   * @summary 盖亚审核后的最终确认
   * @tags 工单-问题反馈接口
   * @response `200` `{ code?: number, data?: object, msg?: string }` successful operation
   */
  "/xinxuan/console/workOrder/{id}/confirm_GET": (id: string, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xinxuan/console/workOrder/${id}/confirm`,
      method: "GET",
      data: raw,
      ...options
    }) as unknown as Promise<{ code?: number; data?: object; msg?: string }>,
  /**
   * No description
   * @name DELETE /xinxuan/console/topics/{id}
   * @summary 删除话题
   * @tags 话题相关接口
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xinxuan/console/topics/{id}_DELETE": (id: string, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xinxuan/console/topics/${id}`,
      method: "DELETE",
      data: raw,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name GET /xinxuan/console/topics
   * @summary 搜索话题列表
   * @tags 话题相关接口
   * @response `200` `{ code?: number, data?: { endRow?: number, firstPage?: number, hasNextPage?: boolean, hasPreviousPage?: boolean, isFirstPage?: boolean, isLastPage?: boolean, lastPage?: number, list?: ({ enabled: boolean, hot: boolean, id: number, mentionCnt: number, name: string, sortNum: number })[], navigateFirstPage?: number, navigateLastPage?: number, navigatePages?: number, navigatepageNums?: (number)[], nextPage?: number, pageNum?: number, pageSize?: number, pages?: number, prePage?: number, size?: number, startRow?: number, total?: number }, msg?: string }` successful operation
   */
  "/xinxuan/console/topics_GET": (query: XinxuanConsoleTopicsGetParams, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xinxuan/console/topics`,
      method: "GET",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        endRow?: number;
        firstPage?: number;
        hasNextPage?: boolean;
        hasPreviousPage?: boolean;
        isFirstPage?: boolean;
        isLastPage?: boolean;
        lastPage?: number;
        list?: { enabled: boolean; hot: boolean; id: number; mentionCnt: number; name: string; sortNum: number }[];
        navigateFirstPage?: number;
        navigateLastPage?: number;
        navigatePages?: number;
        navigatepageNums?: number[];
        nextPage?: number;
        pageNum?: number;
        pageSize?: number;
        pages?: number;
        prePage?: number;
        size?: number;
        startRow?: number;
        total?: number;
      };
      msg?: string;
    }>,
  /**
   * No description
   * @name POST /xinxuan/console/taskValidators
   * @summary 创建
   * @tags 任务-任务校验库
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xinxuan/console/taskValidators_POST": (root: { memo?: string; name?: string }, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xinxuan/console/taskValidators`,
      method: "POST",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name GET /xinxuan/console/taskValidators
   * @summary 搜索
   * @tags 任务-任务校验库
   * @response `200` `{ code?: number, data?: { endRow?: number, firstPage?: number, hasNextPage?: boolean, hasPreviousPage?: boolean, isFirstPage?: boolean, isLastPage?: boolean, lastPage?: number, list?: ({ bindTaskId?: number, createUser?: string, gmtCreated?: string, id?: number, memo?: string, name?: string })[], navigateFirstPage?: number, navigateLastPage?: number, navigatePages?: number, navigatepageNums?: (number)[], nextPage?: number, pageNum?: number, pageSize?: number, pages?: number, prePage?: number, size?: number, startRow?: number, total?: number }, msg?: string }` successful operation
   */
  "/xinxuan/console/taskValidators_GET": (
    query: XinxuanConsoleTaskValidatorsGetParams,
    raw: File,
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/taskValidators`,
      method: "GET",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        endRow?: number;
        firstPage?: number;
        hasNextPage?: boolean;
        hasPreviousPage?: boolean;
        isFirstPage?: boolean;
        isLastPage?: boolean;
        lastPage?: number;
        list?: {
          bindTaskId?: number;
          createUser?: string;
          gmtCreated?: string;
          id?: number;
          memo?: string;
          name?: string;
        }[];
        navigateFirstPage?: number;
        navigateLastPage?: number;
        navigatePages?: number;
        navigatepageNums?: number[];
        nextPage?: number;
        pageNum?: number;
        pageSize?: number;
        pages?: number;
        prePage?: number;
        size?: number;
        startRow?: number;
        total?: number;
      };
      msg?: string;
    }>,
  /**
   * No description
   * @name DELETE /xinxuan/console/taskValidators/{id}
   * @summary 删除
   * @tags 任务-任务校验库
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xinxuan/console/taskValidators/{id}_DELETE": (id: string, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xinxuan/console/taskValidators/${id}`,
      method: "DELETE",
      data: raw,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name POST /xinxuan/console/taskValidators/data
   * @summary 批量创建验证数据
   * @tags 任务-任务校验库
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xinxuan/console/taskValidators/data_POST": (
    root: { dataList: { matchContent?: string }[]; validatorId: number },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/taskValidators/data`,
      method: "POST",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name GET /xinxuan/console/taskValidators/details
   * @summary 验证数据搜索
   * @tags 任务-任务校验库
   * @response `200` `{ code?: number, data?: { endRow?: number, firstPage?: number, hasNextPage?: boolean, hasPreviousPage?: boolean, isFirstPage?: boolean, isLastPage?: boolean, lastPage?: number, list?: ({ evidenceUrl?: string, id?: number, matchContent?: string, matchMemberId?: number, matchMemberNickname?: string, taskId?: number, validatorId?: number, verified?: boolean, verifyTime?: string })[], navigateFirstPage?: number, navigateLastPage?: number, navigatePages?: number, navigatepageNums?: (number)[], nextPage?: number, pageNum?: number, pageSize?: number, pages?: number, prePage?: number, size?: number, startRow?: number, total?: number }, msg?: string }` successful operation
   */
  "/xinxuan/console/taskValidators/details_GET": (
    query: XinxuanConsoleTaskValidatorsDetailsGetParams,
    raw: File,
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/taskValidators/details`,
      method: "GET",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        endRow?: number;
        firstPage?: number;
        hasNextPage?: boolean;
        hasPreviousPage?: boolean;
        isFirstPage?: boolean;
        isLastPage?: boolean;
        lastPage?: number;
        list?: {
          evidenceUrl?: string;
          id?: number;
          matchContent?: string;
          matchMemberId?: number;
          matchMemberNickname?: string;
          taskId?: number;
          validatorId?: number;
          verified?: boolean;
          verifyTime?: string;
        }[];
        navigateFirstPage?: number;
        navigateLastPage?: number;
        navigatePages?: number;
        navigatepageNums?: number[];
        nextPage?: number;
        pageNum?: number;
        pageSize?: number;
        pages?: number;
        prePage?: number;
        size?: number;
        startRow?: number;
        total?: number;
      };
      msg?: string;
    }>,
  /**
   * No description
   * @name PUT /xinxuan/console/tasks/enable
   * @summary 任务启用禁用
   * @tags 任务-任务管理
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xinxuan/console/tasks/enable_PUT": (root: { decision?: boolean; taskId?: number }, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xinxuan/console/tasks/enable`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name GET /xinxuan/console/tasks/{id}
   * @summary 任务详情
   * @tags 任务-任务管理
   * @response `200` `{ code?: number, data?: { allowLevel?: string, awardGrowth?: number, awardIntegral?: number, description: string, enabled?: boolean, endTime: string, finishWay: { checkDataDescription: string, checkDataId: number, id: number, multiple: boolean, taskId: number, type: number }, hasPrize: boolean, id: number, lotteryTime: string, name: string, notAnyMore?: boolean, participantCnt?: number, participated?: boolean, prizes: ({ cnt: number, id: number, imgUrl?: string, name: string, taskId: number })[], recommend: boolean, sortNum: number, startTime: string, subjectImgUrl?: string, top: boolean, totalGrowthLimit?: number, totalIntegralLimit?: number }, msg?: string }` successful operation
   */
  "/xinxuan/console/tasks/{id}_GET": (id: string, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xinxuan/console/tasks/${id}`,
      method: "GET",
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        allowLevel?: string;
        awardGrowth?: number;
        awardIntegral?: number;
        description: string;
        enabled?: boolean;
        endTime: string;
        finishWay: {
          checkDataDescription: string;
          checkDataId: number;
          id: number;
          multiple: boolean;
          taskId: number;
          type: number;
        };
        hasPrize: boolean;
        id: number;
        lotteryTime: string;
        name: string;
        notAnyMore?: boolean;
        participantCnt?: number;
        participated?: boolean;
        prizes: { cnt: number; id: number; imgUrl?: string; name: string; taskId: number }[];
        recommend: boolean;
        sortNum: number;
        startTime: string;
        subjectImgUrl?: string;
        top: boolean;
        totalGrowthLimit?: number;
        totalIntegralLimit?: number;
      };
      msg?: string;
    }>,
  /**
   * No description
   * @name PUT /xinxuan/console/tasks/{id}
   * @summary 修改任务信息
   * @tags 任务-任务管理
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xinxuan/console/tasks/{id}_PUT": (
    id: string,
    root: {
      allowLevel?: string;
      awardGrowth?: number;
      awardIntegral?: number;
      description?: string;
      enabled?: boolean;
      endTime: string;
      finishWay?: { checkDataDescription?: string; checkDataId?: number; multiple?: boolean; type: number };
      hasPrize: boolean;
      lotteryTime?: string;
      name: string;
      prizes?: { cnt: number; imgUrl?: string; name: string }[];
      sortNum: number;
      startTime: string;
      subjectImgUrl?: string;
      top?: boolean;
      totalGrowthLimit?: number;
      totalIntegralLimit?: number;
    },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/tasks/${id}`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name DELETE /xinxuan/console/tasks/{id}
   * @summary 删除任务
   * @tags 任务-任务管理
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xinxuan/console/tasks/{id}_DELETE": (id: string, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xinxuan/console/tasks/${id}`,
      method: "DELETE",
      data: raw,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name POST /xinxuan/console/tasks
   * @summary 创建任务
   * @tags 任务-任务管理
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xinxuan/console/tasks_POST": (
    root: {
      allowLevel?: string;
      awardGrowth?: number;
      awardIntegral?: number;
      description?: string;
      enabled?: boolean;
      endTime: string;
      finishWay?: { checkDataDescription?: string; checkDataId?: number; multiple?: boolean; type: number };
      hasPrize: boolean;
      lotteryTime?: string;
      name: string;
      prizes?: { cnt: number; imgUrl?: string; name: string }[];
      sortNum: number;
      startTime: string;
      subjectImgUrl?: string;
      top?: boolean;
      totalGrowthLimit?: number;
      totalIntegralLimit?: number;
    },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/tasks`,
      method: "POST",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name GET /xinxuan/console/tasks
   * @summary 搜索任务
   * @tags 任务-任务管理
   * @response `200` `{ code?: number, data?: { endRow?: number, firstPage?: number, hasNextPage?: boolean, hasPreviousPage?: boolean, isFirstPage?: boolean, isLastPage?: boolean, lastPage?: number, list?: ({ allowLevel?: string, enabled: boolean, endTime: string, hasPrize: boolean, id: number, name: string, recommend: boolean, sortNum: number, startTime: string, top: boolean, wayType: number })[], navigateFirstPage?: number, navigateLastPage?: number, navigatePages?: number, navigatepageNums?: (number)[], nextPage?: number, pageNum?: number, pageSize?: number, pages?: number, prePage?: number, size?: number, startRow?: number, total?: number }, msg?: string }` successful operation
   */
  "/xinxuan/console/tasks_GET": (query: XinxuanConsoleTasksGetParams, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xinxuan/console/tasks`,
      method: "GET",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        endRow?: number;
        firstPage?: number;
        hasNextPage?: boolean;
        hasPreviousPage?: boolean;
        isFirstPage?: boolean;
        isLastPage?: boolean;
        lastPage?: number;
        list?: {
          allowLevel?: string;
          enabled: boolean;
          endTime: string;
          hasPrize: boolean;
          id: number;
          name: string;
          recommend: boolean;
          sortNum: number;
          startTime: string;
          top: boolean;
          wayType: number;
        }[];
        navigateFirstPage?: number;
        navigateLastPage?: number;
        navigatePages?: number;
        navigatepageNums?: number[];
        nextPage?: number;
        pageNum?: number;
        pageSize?: number;
        pages?: number;
        prePage?: number;
        size?: number;
        startRow?: number;
        total?: number;
      };
      msg?: string;
    }>,
  /**
   * No description
   * @name PUT /xinxuan/console/tasks/top
   * @summary 置顶取消置顶
   * @tags 任务-任务管理
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xinxuan/console/tasks/top_PUT": (root: { decision?: boolean; taskId?: number }, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xinxuan/console/tasks/top`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name PUT /xinxuan/console/tasks/recommend
   * @summary 首页推荐或取消推荐
   * @tags 任务-任务管理
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xinxuan/console/tasks/recommend_PUT": (
    root: { decision?: boolean; taskId?: number },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/tasks/recommend`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name POST /xinxuan/console/public/jstDeliver
   * @summary jstDeliver
   * @tags 公开访问的APIs
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xinxuan/console/public/jstDeliver_POST": (
    query: XinxuanConsolePublicJstDeliverPostParams,
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/public/jstDeliver`,
      method: "POST",
      params: query,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name POST /xinxuan/console/public/forgot
   * @summary 忘记密码
   * @tags 公开访问的APIs
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xinxuan/console/public/forgot_POST": (
    root: { code?: string; mobile?: string; password?: string },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/public/forgot`,
      method: "POST",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name POST /xinxuan/console/public/register
   * @summary 注册（返回token）
   * @tags 公开访问的APIs
   * @response `200` `{ code?: number, data?: string, msg?: string }` successful operation
   */
  "/xinxuan/console/public/register_POST": (
    root: { code?: string; mobile?: string; password?: string },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/public/register`,
      method: "POST",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; data?: string; msg?: string }>,
  /**
   * No description
   * @name POST /xinxuan/console/public/login
   * @summary 登录
   * @tags 公开访问的APIs
   * @response `200` `{ code?: number, data?: string, msg?: string }` successful operation
   */
  "/xinxuan/console/public/login_POST": (
    root: { agent?: string; loginIp?: string; mobile?: string; password?: string },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/public/login`,
      method: "POST",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; data?: string; msg?: string }>,
  /**
   * No description
   * @name PUT /xinxuan/console/groupApproves
   * @summary 审批操作
   * @tags 圈子-圈子审批
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xinxuan/console/groupApproves_PUT": (
    root: { approveId: number; approverId?: number; memo?: string; status: "APPROVED" | "CREATED" | "REJECTED" },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/groupApproves`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name GET /xinxuan/console/groupApproves
   * @summary 搜索审批列表
   * @tags 圈子-圈子审批
   * @response `200` `{ code?: number, data?: { endRow?: number, firstPage?: number, hasNextPage?: boolean, hasPreviousPage?: boolean, isFirstPage?: boolean, isLastPage?: boolean, lastPage?: number, list?: ({ applicantId: number, applyTime: string, approveTime: string, approverId?: number, creatorMobile: string, creatorNickname: string, enumStatus: number, groupId: number, id: number, leastLevel: number, name: string, subTitle: string })[], navigateFirstPage?: number, navigateLastPage?: number, navigatePages?: number, navigatepageNums?: (number)[], nextPage?: number, pageNum?: number, pageSize?: number, pages?: number, prePage?: number, size?: number, startRow?: number, total?: number }, msg?: string }` successful operation
   */
  "/xinxuan/console/groupApproves_GET": (
    query: XinxuanConsoleGroupApprovesGetParams,
    raw: File,
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/groupApproves`,
      method: "GET",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        endRow?: number;
        firstPage?: number;
        hasNextPage?: boolean;
        hasPreviousPage?: boolean;
        isFirstPage?: boolean;
        isLastPage?: boolean;
        lastPage?: number;
        list?: {
          applicantId: number;
          applyTime: string;
          approveTime: string;
          approverId?: number;
          creatorMobile: string;
          creatorNickname: string;
          enumStatus: number;
          groupId: number;
          id: number;
          leastLevel: number;
          name: string;
          subTitle: string;
        }[];
        navigateFirstPage?: number;
        navigateLastPage?: number;
        navigatePages?: number;
        navigatepageNums?: number[];
        nextPage?: number;
        pageNum?: number;
        pageSize?: number;
        pages?: number;
        prePage?: number;
        size?: number;
        startRow?: number;
        total?: number;
      };
      msg?: string;
    }>,
  /**
   * @description ## 请求示例 ``` json { "activityBeginDate": "2021-11-18 00:00:00", "activityEndDate": "2021-11-19 00:00:00", "activityImgUrl": "https://qingyangimg.oss-cn-beijing.aliyuncs.com/img/2jsaC5QXCtD3dQS78ES2Hrh6JBjstYf2.png", "activityName": "活动名称", "buttonImgUrl": "https://qingyangimg.oss-cn-beijing.aliyuncs.com/img/2t53iKfzSmwXbrciP3aPw8ZQsrcxbPmm.jpg", "consumeIntegral": 1, "richText": "活动规则" } ``` ## 说明 在配置完积分消耗后调用接口，将返回活动信息
   * @name POST /xinxuan/console/lotteryTurntable
   * @summary 新增大转盘活动
   * @tags 大转盘活动相关接口
   * @response `200` `{ code?: number, data?: { activityBeginDate: string, activityEndDate: string, activityImgUrl: string, activityName: string, buttonImgUrl: string, consumeIntegral: number, del?: boolean, draftStatus?: boolean, gmtCreate?: string, gmtModified?: string, id: number, prizeDetailsList: ({ integral?: number, location?: number, prizeImg?: string, prizeName?: string, prizeNumber?: number, rouletteImg?: string, type?: number })[], prizeList: ({ activityId?: number, del?: boolean, gmtCreate?: string, gmtModified?: string, id: number, integral?: number, prizeImg: string, prizeName: string, prizeNumber: number, type: number })[], richText?: string, status?: boolean, ticketBeginDate?: string, ticketEndDate?: string }, msg?: string }` successful operation
   */
  "/xinxuan/console/lotteryTurntable_POST": (
    root: {
      activityBeginDate: string;
      activityEndDate: string;
      activityImgUrl: string;
      activityName: string;
      buttonImgUrl: string;
      consumeIntegral: number;
      del?: boolean;
      gmtCreate?: string;
      gmtModified?: string;
      id?: number;
      richText?: string;
      status?: boolean;
      ticketBeginDate?: string;
      ticketEndDate?: string;
    },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/lotteryTurntable`,
      method: "POST",
      data: root,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        activityBeginDate: string;
        activityEndDate: string;
        activityImgUrl: string;
        activityName: string;
        buttonImgUrl: string;
        consumeIntegral: number;
        del?: boolean;
        draftStatus?: boolean;
        gmtCreate?: string;
        gmtModified?: string;
        id: number;
        prizeDetailsList: {
          integral?: number;
          location?: number;
          prizeImg?: string;
          prizeName?: string;
          prizeNumber?: number;
          rouletteImg?: string;
          type?: number;
        }[];
        prizeList: {
          activityId?: number;
          del?: boolean;
          gmtCreate?: string;
          gmtModified?: string;
          id: number;
          integral?: number;
          prizeImg: string;
          prizeName: string;
          prizeNumber: number;
          type: number;
        }[];
        richText?: string;
        status?: boolean;
        ticketBeginDate?: string;
        ticketEndDate?: string;
      };
      msg?: string;
    }>,
  /**
   * No description
   * @name GET /xinxuan/console/lotteryTurntable
   * @summary 查询大转盘活动
   * @tags 大转盘活动相关接口
   * @response `200` `{ code?: number, data?: { endRow?: number, firstPage?: number, hasNextPage?: boolean, hasPreviousPage?: boolean, isFirstPage?: boolean, isLastPage?: boolean, lastPage?: number, list?: ({ activityBeginDate?: string, activityEndDate?: string, activityName?: string, activityStatus?: number, id?: number, participationNum?: number, status?: boolean, winNum?: number })[], navigateFirstPage?: number, navigateLastPage?: number, navigatePages?: number, navigatepageNums?: (number)[], nextPage?: number, pageNum?: number, pageSize?: number, pages?: number, prePage?: number, size?: number, startRow?: number, total?: number }, msg?: string }` successful operation
   */
  "/xinxuan/console/lotteryTurntable_GET": (
    query: XinxuanConsoleLotteryTurntableGetParams,
    raw: File,
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/lotteryTurntable`,
      method: "GET",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        endRow?: number;
        firstPage?: number;
        hasNextPage?: boolean;
        hasPreviousPage?: boolean;
        isFirstPage?: boolean;
        isLastPage?: boolean;
        lastPage?: number;
        list?: {
          activityBeginDate?: string;
          activityEndDate?: string;
          activityName?: string;
          activityStatus?: number;
          id?: number;
          participationNum?: number;
          status?: boolean;
          winNum?: number;
        }[];
        navigateFirstPage?: number;
        navigateLastPage?: number;
        navigatePages?: number;
        navigatepageNums?: number[];
        nextPage?: number;
        pageNum?: number;
        pageSize?: number;
        pages?: number;
        prePage?: number;
        size?: number;
        startRow?: number;
        total?: number;
      };
      msg?: string;
    }>,
  /**
   * @description ## 请求示例 ```json { "id":1, "activityBeginDate": "2021-11-18 00:00:00", "activityEndDate": "2021-11-24 00:00:00", "activityImgUrl": "https://qingyangimg.oss-cn-beijing.aliyuncs.com/img/2jsaC5QXCtD3dQS78ES2Hrh6JBjstYf2.png", "activityName": "活动名称啊", "buttonImgUrl": "https://qingyangimg.oss-cn-beijing.aliyuncs.com/img/2t53iKfzSmwXbrciP3aPw8ZQsrcxbPmm.jpg", "consumeIntegral": 10, "richText": "活动规则更改" } ```
   * @name PUT /xinxuan/console/lotteryTurntable
   * @summary 编辑大转盘活动
   * @tags 大转盘活动相关接口
   * @response `200` `{ code?: number, data?: object, msg?: string }` successful operation
   */
  "/xinxuan/console/lotteryTurntable_PUT": (
    root: {
      activityBeginDate: string;
      activityEndDate: string;
      activityImgUrl: string;
      activityName: string;
      buttonImgUrl: string;
      consumeIntegral: number;
      del?: boolean;
      gmtCreate?: string;
      gmtModified?: string;
      id?: number;
      richText?: string;
      status?: boolean;
      ticketBeginDate?: string;
      ticketEndDate?: string;
    },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/lotteryTurntable`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; data?: object; msg?: string }>,
  /**
   * @description * 入参 ``` json { "activityId": 1, "prizeList": [ { "id": null, "prizeImg": "https://qingyangimg.oss-cn-beijing.aliyuncs.com/img/2t53iKfzSmwXbrciP3aPw8ZQsrcxbPmm.jpg", "prizeName": "奖品1", "prizeNumber": 10, "type": 1 }, { "id": null, "prizeImg": "https://qingyangimg.oss-cn-beijing.aliyuncs.com/img/2t53iKfzSmwXbrciP3aPw8ZQsrcxbPmm.jpg", "prizeName": "奖品2", "prizeNumber": 20, "type": 1 }, { "id": null, "integral": 100, "prizeImg": "https://qingyangimg.oss-cn-beijing.aliyuncs.com/img/2t53iKfzSmwXbrciP3aPw8ZQsrcxbPmm.jpg", "prizeName": "积分", "prizeNumber": 10, "type": 2 } ] } ``` * 返参 ``` json { "code": 0, "msg": "OK", "data": { "activityId": 1, "prizeList": [ { "id": 1, "activityId": 1, "prizeName": "奖品1", "prizeNumber": 10, "prizeImg": "https://qingyangimg.oss-cn-beijing.aliyuncs.com/img/2t53iKfzSmwXbrciP3aPw8ZQsrcxbPmm.jpg", "type": 1, "gmtCreate": 1637305916032, "del": false }, { "id": 2, "activityId": 1, "prizeName": "奖品2", "prizeNumber": 20, "prizeImg": "https://qingyangimg.oss-cn-beijing.aliyuncs.com/img/2t53iKfzSmwXbrciP3aPw8ZQsrcxbPmm.jpg", "type": 1, "gmtCreate": 1637305916043, "del": false }, { "id": 3, "activityId": 1, "prizeName": "积分", "prizeNumber": 10, "prizeImg": "https://qingyangimg.oss-cn-beijing.aliyuncs.com/img/2t53iKfzSmwXbrciP3aPw8ZQsrcxbPmm.jpg", "integral": 100, "type": 2, "gmtCreate": 1637305916050, "del": false } ] } } ```
   * @name POST /xinxuan/console/lotteryTurntable/prize
   * @summary 保存大转盘活动奖品
   * @tags 大转盘活动相关接口
   * @response `200` `{ code?: number, data?: object, msg?: string }` successful operation
   */
  "/xinxuan/console/lotteryTurntable/prize_POST": (
    root: {
      activityId: number;
      prizeList: {
        activityId?: number;
        del?: boolean;
        gmtCreate?: string;
        gmtModified?: string;
        id: number;
        integral?: number;
        prizeImg: string;
        prizeName: string;
        prizeNumber: number;
        type: number;
      }[];
    },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/lotteryTurntable/prize`,
      method: "POST",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; data?: object; msg?: string }>,
  /**
   * @description ### 请求 ``` json { "activityId": 1, "configList": [ { "id": null, "prizeId": 1, "rouletteImg": "https://qingyangimg.oss-cn-beijing.aliyuncs.com/img/2t53iKfzSmwXbrciP3aPw8ZQsrcxbPmm.jpg", "probability": 10, "location": 1 }, { "id": null, "prizeId": 2, "rouletteImg": "https://qingyangimg.oss-cn-beijing.aliyuncs.com/img/2t53iKfzSmwXbrciP3aPw8ZQsrcxbPmm.jpg", "probability": 20, "location": 2 }, { "id": null, "prizeId": 3, "rouletteImg": "https://qingyangimg.oss-cn-beijing.aliyuncs.com/img/2t53iKfzSmwXbrciP3aPw8ZQsrcxbPmm.jpg", "probability": 10, "location": 3 }, { "id": null, "prizeId": 1, "rouletteImg": "https://qingyangimg.oss-cn-beijing.aliyuncs.com/img/2t53iKfzSmwXbrciP3aPw8ZQsrcxbPmm.jpg", "probability": 10, "location": 4 }, { "id": null, "prizeId": 2, "rouletteImg": "https://qingyangimg.oss-cn-beijing.aliyuncs.com/img/2t53iKfzSmwXbrciP3aPw8ZQsrcxbPmm.jpg", "probability": 10, "location": 5 }, { "id": null, "prizeId": 3, "rouletteImg": "https://qingyangimg.oss-cn-beijing.aliyuncs.com/img/2t53iKfzSmwXbrciP3aPw8ZQsrcxbPmm.jpg", "probability": 10, "location": 6 }, { "id": null, "prizeId": 0, "rouletteImg": "https://qingyangimg.oss-cn-beijing.aliyuncs.com/img/2t53iKfzSmwXbrciP3aPw8ZQsrcxbPmm.jpg", "probability": 10, "location": 7 }, { "id": null, "prizeId": 0, "rouletteImg": "https://qingyangimg.oss-cn-beijing.aliyuncs.com/img/2t53iKfzSmwXbrciP3aPw8ZQsrcxbPmm.jpg", "probability": 20, "location": 8 } ] } ``` ### 返回 ``` { "code": 0, "msg": "OK" } ```
   * @name POST /xinxuan/console/lotteryTurntable/config
   * @summary 保存大转盘转盘配置
   * @tags 大转盘活动相关接口
   * @response `200` `{ code?: number, data?: object, msg?: string }` successful operation
   */
  "/xinxuan/console/lotteryTurntable/config_POST": (
    root: {
      activityId: number;
      configList: {
        activityId?: number;
        gmtCreate?: string;
        gmtModified?: string;
        id: number;
        location?: number;
        prizeId?: number;
        probability?: number;
        rouletteImg?: string;
      }[];
    },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/lotteryTurntable/config`,
      method: "POST",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; data?: object; msg?: string }>,
  /**
   * No description
   * @name DELETE /xinxuan/console/lotteryTurntable/{id}
   * @summary 删除大转盘活动
   * @tags 大转盘活动相关接口
   * @response `200` `{ code?: number, data?: object, msg?: string }` successful operation
   */
  "/xinxuan/console/lotteryTurntable/{id}_DELETE": (id: string, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xinxuan/console/lotteryTurntable/${id}`,
      method: "DELETE",
      data: raw,
      ...options
    }) as unknown as Promise<{ code?: number; data?: object; msg?: string }>,
  /**
   * @description ## 返回示例 ``` { "code": 0, "msg": "OK", "data": { "id": 1, "activityName": "活动名称啊", "activityBeginDate": 1637164800000, "activityEndDate": 1637510400000, "activityImgUrl": "https://qingyangimg.oss-cn-beijing.aliyuncs.com/img/2jsaC5QXCtD3dQS78ES2Hrh6JBjstYf2.png", "buttonImgUrl": "https://qingyangimg.oss-cn-beijing.aliyuncs.com/img/2t53iKfzSmwXbrciP3aPw8ZQsrcxbPmm.jpg", "richText": "活动规则更改", "consumeIntegral": 10, "gmtCreate": 1637245469000, "gmtModified": 1637476439000, "status": false, "del": false, "draftStatus": false } } ```
   * @name GET /xinxuan/console/lotteryTurntable/{id}
   * @summary 查询大转盘详情
   * @tags 大转盘活动相关接口
   * @response `200` `{ code?: number, data?: { activityBeginDate: string, activityEndDate: string, activityImgUrl: string, activityName: string, buttonImgUrl: string, consumeIntegral: number, del?: boolean, draftStatus?: boolean, gmtCreate?: string, gmtModified?: string, id: number, prizeDetailsList: ({ integral?: number, location?: number, prizeImg?: string, prizeName?: string, prizeNumber?: number, rouletteImg?: string, type?: number })[], prizeList: ({ activityId?: number, del?: boolean, gmtCreate?: string, gmtModified?: string, id: number, integral?: number, prizeImg: string, prizeName: string, prizeNumber: number, type: number })[], richText?: string, status?: boolean, ticketBeginDate?: string, ticketEndDate?: string }, msg?: string }` successful operation
   */
  "/xinxuan/console/lotteryTurntable/{id}_GET": (id: string, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xinxuan/console/lotteryTurntable/${id}`,
      method: "GET",
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        activityBeginDate: string;
        activityEndDate: string;
        activityImgUrl: string;
        activityName: string;
        buttonImgUrl: string;
        consumeIntegral: number;
        del?: boolean;
        draftStatus?: boolean;
        gmtCreate?: string;
        gmtModified?: string;
        id: number;
        prizeDetailsList: {
          integral?: number;
          location?: number;
          prizeImg?: string;
          prizeName?: string;
          prizeNumber?: number;
          rouletteImg?: string;
          type?: number;
        }[];
        prizeList: {
          activityId?: number;
          del?: boolean;
          gmtCreate?: string;
          gmtModified?: string;
          id: number;
          integral?: number;
          prizeImg: string;
          prizeName: string;
          prizeNumber: number;
          type: number;
        }[];
        richText?: string;
        status?: boolean;
        ticketBeginDate?: string;
        ticketEndDate?: string;
      };
      msg?: string;
    }>,
  /**
   * @description ## 返回示例 ``` json { "code": 0, "msg": "OK", "data": [ { "id": 1, "activityId": 1, "prizeName": "奖品1", "prizeNumber": 10, "prizeImg": "https://qingyangimg.oss-cn-beijing.aliyuncs.com/img/2t53iKfzSmwXbrciP3aPw8ZQsrcxbPmm.jpg", "integral": 0, "type": 1, "del": false }, { "id": 2, "activityId": 1, "prizeName": "奖品2", "prizeNumber": 20, "prizeImg": "https://qingyangimg.oss-cn-beijing.aliyuncs.com/img/2t53iKfzSmwXbrciP3aPw8ZQsrcxbPmm.jpg", "integral": 0, "type": 1, "del": false }, { "id": 3, "activityId": 1, "prizeName": "积分", "prizeNumber": 10, "prizeImg": "https://qingyangimg.oss-cn-beijing.aliyuncs.com/img/2t53iKfzSmwXbrciP3aPw8ZQsrcxbPmm.jpg", "integral": 100, "type": 2, "del": false } ] } ```
   * @name GET /xinxuan/console/lotteryTurntable/{activityId}/prize
   * @summary 查询大转盘奖品设置
   * @tags 大转盘活动相关接口
   * @response `200` `{ code?: number, data?: ({ activityId: number, del?: boolean, id: number, integral?: number, prizeImg: string, prizeName: string, prizeNumber: number, type: number })[], msg?: string }` successful operation
   */
  "/xinxuan/console/lotteryTurntable/{activityId}/prize_GET": (
    activityId: string,
    raw: File,
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/lotteryTurntable/${activityId}/prize`,
      method: "GET",
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        activityId: number;
        del?: boolean;
        id: number;
        integral?: number;
        prizeImg: string;
        prizeName: string;
        prizeNumber: number;
        type: number;
      }[];
      msg?: string;
    }>,
  /**
   * No description
   * @name GET /xinxuan/console/lotteryTurntable/{activityId}/config
   * @summary 查询大转盘轮盘设置
   * @tags 大转盘活动相关接口
   * @response `200` `{ code?: number, data?: ({ activityId?: number, gmtCreate?: string, gmtModified?: string, id: number, location?: number, prizeId?: number, probability?: number, rouletteImg?: string })[], msg?: string }` successful operation
   */
  "/xinxuan/console/lotteryTurntable/{activityId}/config_GET": (
    activityId: string,
    raw: File,
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/lotteryTurntable/${activityId}/config`,
      method: "GET",
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        activityId?: number;
        gmtCreate?: string;
        gmtModified?: string;
        id: number;
        location?: number;
        prizeId?: number;
        probability?: number;
        rouletteImg?: string;
      }[];
      msg?: string;
    }>,
  /**
   * No description
   * @name PUT /xinxuan/console/lotteryTurntable/status
   * @summary 编辑大转盘上下架状态
   * @tags 大转盘活动相关接口
   * @response `200` `{ code?: number, data?: object, msg?: string }` successful operation
   */
  "/xinxuan/console/lotteryTurntable/status_PUT": (
    root: { id?: number; status?: boolean },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/lotteryTurntable/status`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; data?: object; msg?: string }>,
  /**
   * No description
   * @name DELETE /xinxuan/console/problemClassify/{id}
   * @summary 删除问题分类
   * @tags 问题分类
   * @response `200` `{ code?: number, data?: object, msg?: string }` successful operation
   */
  "/xinxuan/console/problemClassify/{id}_DELETE": (id: string, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xinxuan/console/problemClassify/${id}`,
      method: "DELETE",
      data: raw,
      ...options
    }) as unknown as Promise<{ code?: number; data?: object; msg?: string }>,
  /**
   * @description ### 请求示例 ``` { "status": true, "name": "问题分类" } ```
   * @name POST /xinxuan/console/problemClassify
   * @summary 新增问题分类
   * @tags 问题分类
   * @response `200` `{ code?: number, data?: object, msg?: string }` successful operation
   */
  "/xinxuan/console/problemClassify_POST": (
    root: { id?: number; name: string; status: boolean },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/problemClassify`,
      method: "POST",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; data?: object; msg?: string }>,
  /**
   * No description
   * @name GET /xinxuan/console/problemClassify
   * @summary 查询全部问题分类
   * @tags 问题分类
   * @response `200` `{ code?: number, data?: ({ id?: number, name?: string, sort?: number, status?: boolean })[], msg?: string }` successful operation
   */
  "/xinxuan/console/problemClassify_GET": (raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xinxuan/console/problemClassify`,
      method: "GET",
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: { id?: number; name?: string; sort?: number; status?: boolean }[];
      msg?: string;
    }>,
  /**
   * @description ### 请求示例 ``` { "status": true, "id": 3, "name": "问题分类3" } ```
   * @name PUT /xinxuan/console/problemClassify
   * @summary 编辑问题分类
   * @tags 问题分类
   * @response `200` `{ code?: number, data?: object, msg?: string }` successful operation
   */
  "/xinxuan/console/problemClassify_PUT": (
    root: { id?: number; name: string; status: boolean },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/problemClassify`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; data?: object; msg?: string }>,
  /**
   * No description
   * @name DELETE /xinxuan/console/problem/{id}
   * @summary 删除常见问题
   * @tags 常见问题
   * @response `200` `{ code?: number, data?: object, msg?: string }` successful operation
   */
  "/xinxuan/console/problem/{id}_DELETE": (id: string, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xinxuan/console/problem/${id}`,
      method: "DELETE",
      data: raw,
      ...options
    }) as unknown as Promise<{ code?: number; data?: object; msg?: string }>,
  /**
   * No description
   * @name GET /xinxuan/console/problem/{id}
   * @summary 查询常见问题
   * @tags 常见问题
   * @response `200` `{ code?: number, data?: { answer?: string, classifyId?: number, id?: number, sort?: number, status?: boolean, title?: string }, msg?: string }` successful operation
   */
  "/xinxuan/console/problem/{id}_GET": (id: string, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xinxuan/console/problem/${id}`,
      method: "GET",
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: { answer?: string; classifyId?: number; id?: number; sort?: number; status?: boolean; title?: string };
      msg?: string;
    }>,
  /**
   * @description ### 请求示例 ``` { "classifyId": 1, "sort": 1, "status": false, "title": "问题标题1", "answer": "答案富文本" } ```
   * @name POST /xinxuan/console/problem
   * @summary 新增常见问题
   * @tags 常见问题
   * @response `200` `{ code?: number, data?: object, msg?: string }` successful operation
   */
  "/xinxuan/console/problem_POST": (
    root: { answer?: string; classifyId: number; id?: number; sort: number; status: boolean; title: string },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/problem`,
      method: "POST",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; data?: object; msg?: string }>,
  /**
   * No description
   * @name GET /xinxuan/console/problem
   * @summary 查询常见问题
   * @tags 常见问题
   * @response `200` `{ code?: number, data?: { endRow?: number, firstPage?: number, hasNextPage?: boolean, hasPreviousPage?: boolean, isFirstPage?: boolean, isLastPage?: boolean, lastPage?: number, list?: ({ answer?: string, classifyId?: number, id?: number, sort?: number, status?: boolean, title?: string })[], navigateFirstPage?: number, navigateLastPage?: number, navigatePages?: number, navigatepageNums?: (number)[], nextPage?: number, pageNum?: number, pageSize?: number, pages?: number, prePage?: number, size?: number, startRow?: number, total?: number }, msg?: string }` successful operation
   */
  "/xinxuan/console/problem_GET": (query: XinxuanConsoleProblemGetParams, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xinxuan/console/problem`,
      method: "GET",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        endRow?: number;
        firstPage?: number;
        hasNextPage?: boolean;
        hasPreviousPage?: boolean;
        isFirstPage?: boolean;
        isLastPage?: boolean;
        lastPage?: number;
        list?: { answer?: string; classifyId?: number; id?: number; sort?: number; status?: boolean; title?: string }[];
        navigateFirstPage?: number;
        navigateLastPage?: number;
        navigatePages?: number;
        navigatepageNums?: number[];
        nextPage?: number;
        pageNum?: number;
        pageSize?: number;
        pages?: number;
        prePage?: number;
        size?: number;
        startRow?: number;
        total?: number;
      };
      msg?: string;
    }>,
  /**
   * @description ### 请求示例 ``` { "id":3, "classifyId": 1, "sort": 4, "status": true, "title": "问题标题3", "answer": "答案富文本" } ```
   * @name PUT /xinxuan/console/problem
   * @summary 编辑常见问题
   * @tags 常见问题
   * @response `200` `{ code?: number, data?: object, msg?: string }` successful operation
   */
  "/xinxuan/console/problem_PUT": (
    root: { answer?: string; classifyId: number; id?: number; sort: number; status: boolean; title: string },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/problem`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; data?: object; msg?: string }>,
  /**
   * No description
   * @name PUT /xinxuan/console/problem/status
   * @summary 更改问题状态
   * @tags 常见问题
   * @response `200` `{ code?: number, data?: object, msg?: string }` successful operation
   */
  "/xinxuan/console/problem/status_PUT": (root: { id?: number; status?: boolean }, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xinxuan/console/problem/status`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; data?: object; msg?: string }>,
  /**
   * No description
   * @name PUT /xinxuan/console/user/cancelGroupCreator
   * @summary 批量将用户撤销白名单圈主
   * @tags 用户-用户信息相关接口
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xinxuan/console/user/cancelGroupCreator_PUT": (root: number[], options: RequestConfig = {}) =>
    requestInstance({
      url: `/xinxuan/console/user/cancelGroupCreator`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name PUT /xinxuan/console/user/groupCreator
   * @summary 批量将用户设置为白名单圈主
   * @tags 用户-用户信息相关接口
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xinxuan/console/user/groupCreator_PUT": (root: number[], options: RequestConfig = {}) =>
    requestInstance({
      url: `/xinxuan/console/user/groupCreator`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * @description ##
   * @name GET /xinxuan/console/user
   * @summary 用户列表查询(包含圈主白名单用户列表查询)
   * @tags 用户-用户信息相关接口
   * @response `200` `{ code?: number, data?: { endRow?: number, firstPage?: number, hasNextPage?: boolean, hasPreviousPage?: boolean, isFirstPage?: boolean, isLastPage?: boolean, lastPage?: number, list?: ({ address?: { address?: string, city?: string, district?: string, gmtCreate?: string, id?: number, isDefault?: boolean, mobile?: string, name?: string, province?: string, userId?: number }, birthday?: string, family?: { boyBirthday?: (object)[], boyNum?: number, elderNum?: number, girlBirthday?: (object)[], girlNum?: number, id?: number, userId?: number }, groupCreator?: boolean, groupCreatorTime?: string, growth?: number, headImgUrl?: string, historyIntegral?: number, id?: number, integral?: number, level?: number, mail?: string, mobile?: string, nextGrowth?: number, nickname?: string, openid?: string, registerDate?: string, sex?: number, status?: boolean, tagList?: ({ gmtCreate?: string, id?: number, tagId?: number, tagName?: string, userId?: number })[] })[], navigateFirstPage?: number, navigateLastPage?: number, navigatePages?: number, navigatepageNums?: (number)[], nextPage?: number, pageNum?: number, pageSize?: number, pages?: number, prePage?: number, size?: number, startRow?: number, total?: number }, msg?: string }` successful operation
   */
  "/xinxuan/console/user_GET": (query: XinxuanConsoleUserGetParams, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xinxuan/console/user`,
      method: "GET",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        endRow?: number;
        firstPage?: number;
        hasNextPage?: boolean;
        hasPreviousPage?: boolean;
        isFirstPage?: boolean;
        isLastPage?: boolean;
        lastPage?: number;
        list?: {
          address?: {
            address?: string;
            city?: string;
            district?: string;
            gmtCreate?: string;
            id?: number;
            isDefault?: boolean;
            mobile?: string;
            name?: string;
            province?: string;
            userId?: number;
          };
          birthday?: string;
          family?: {
            boyBirthday?: object[];
            boyNum?: number;
            elderNum?: number;
            girlBirthday?: object[];
            girlNum?: number;
            id?: number;
            userId?: number;
          };
          groupCreator?: boolean;
          groupCreatorTime?: string;
          growth?: number;
          headImgUrl?: string;
          historyIntegral?: number;
          id?: number;
          integral?: number;
          level?: number;
          mail?: string;
          mobile?: string;
          nextGrowth?: number;
          nickname?: string;
          openid?: string;
          registerDate?: string;
          sex?: number;
          status?: boolean;
          tagList?: { gmtCreate?: string; id?: number; tagId?: number; tagName?: string; userId?: number }[];
        }[];
        navigateFirstPage?: number;
        navigateLastPage?: number;
        navigatePages?: number;
        navigatepageNums?: number[];
        nextPage?: number;
        pageNum?: number;
        pageSize?: number;
        pages?: number;
        prePage?: number;
        size?: number;
        startRow?: number;
        total?: number;
      };
      msg?: string;
    }>,
  /**
   * No description
   * @name PUT /xinxuan/console/user
   * @summary 用户状态修改
   * @tags 用户-用户信息相关接口
   * @response `200` `{ code?: number, data?: object, msg?: string }` successful operation
   */
  "/xinxuan/console/user_PUT": (root: { id?: number; status?: boolean }, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xinxuan/console/user`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; data?: object; msg?: string }>,
  /**
   * @description ## 返回示例 ``` { "code": 0, "msg": "OK", "data": { "id": 3, "nickname": "昵称", "mobile": "18505452704", "headImgUrl": "https://thirdwx.qlogo.cn/mmopen/vi_32/DYAIOgq83epo40KyxqJDRN1cykS8VGiaSyoc1HZquG3PTAp2zlwd6l4sKIp4nJjia2WKnPOovxKt3icj1B2vfINtA/132", "sex": 0, "registerDate": 1637486177000, "integral": 0, "historyIntegral": 0, "growth": 0, "level": 3, "address": { "id": 1, "userId": 3, "name": "姓名", "mobile": "123456", "province": "省", "city": "市", "district": "区", "address": "详细", "isDefault": true, "gmtCreate": 1637119766000 }, "status": true } } ```
   * @name GET /xinxuan/console/user/{id}
   * @summary 用户详情
   * @tags 用户-用户信息相关接口
   * @response `200` `{ code?: number, data?: { address?: { address?: string, city?: string, district?: string, gmtCreate?: string, id?: number, isDefault?: boolean, mobile?: string, name?: string, province?: string, userId?: number }, birthday?: string, family?: { boyBirthday?: (object)[], boyNum?: number, elderNum?: number, girlBirthday?: (object)[], girlNum?: number, id?: number, userId?: number }, groupCreator?: boolean, groupCreatorTime?: string, growth?: number, headImgUrl?: string, historyIntegral?: number, id?: number, integral?: number, level?: number, mail?: string, mobile?: string, nextGrowth?: number, nickname?: string, openid?: string, registerDate?: string, sex?: number, status?: boolean, tagList?: ({ gmtCreate?: string, id?: number, tagId?: number, tagName?: string, userId?: number })[] }, msg?: string }` successful operation
   */
  "/xinxuan/console/user/{id}_GET": (id: string, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xinxuan/console/user/${id}`,
      method: "GET",
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        address?: {
          address?: string;
          city?: string;
          district?: string;
          gmtCreate?: string;
          id?: number;
          isDefault?: boolean;
          mobile?: string;
          name?: string;
          province?: string;
          userId?: number;
        };
        birthday?: string;
        family?: {
          boyBirthday?: object[];
          boyNum?: number;
          elderNum?: number;
          girlBirthday?: object[];
          girlNum?: number;
          id?: number;
          userId?: number;
        };
        groupCreator?: boolean;
        groupCreatorTime?: string;
        growth?: number;
        headImgUrl?: string;
        historyIntegral?: number;
        id?: number;
        integral?: number;
        level?: number;
        mail?: string;
        mobile?: string;
        nextGrowth?: number;
        nickname?: string;
        openid?: string;
        registerDate?: string;
        sex?: number;
        status?: boolean;
        tagList?: { gmtCreate?: string; id?: number; tagId?: number; tagName?: string; userId?: number }[];
      };
      msg?: string;
    }>,
  /**
   * No description
   * @name GET /xinxuan/console/user/simple
   * @summary 简单搜索
   * @tags 用户-用户信息相关接口
   * @response `200` `{ code?: number, data?: { endRow?: number, firstPage?: number, hasNextPage?: boolean, hasPreviousPage?: boolean, isFirstPage?: boolean, isLastPage?: boolean, lastPage?: number, list?: ({ id?: number, mobile?: string, nickname?: string })[], navigateFirstPage?: number, navigateLastPage?: number, navigatePages?: number, navigatepageNums?: (number)[], nextPage?: number, pageNum?: number, pageSize?: number, pages?: number, prePage?: number, size?: number, startRow?: number, total?: number }, msg?: string }` successful operation
   */
  "/xinxuan/console/user/simple_GET": (
    query: XinxuanConsoleUserSimpleGetParams,
    raw: File,
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/user/simple`,
      method: "GET",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        endRow?: number;
        firstPage?: number;
        hasNextPage?: boolean;
        hasPreviousPage?: boolean;
        isFirstPage?: boolean;
        isLastPage?: boolean;
        lastPage?: number;
        list?: { id?: number; mobile?: string; nickname?: string }[];
        navigateFirstPage?: number;
        navigateLastPage?: number;
        navigatePages?: number;
        navigatepageNums?: number[];
        nextPage?: number;
        pageNum?: number;
        pageSize?: number;
        pages?: number;
        prePage?: number;
        size?: number;
        startRow?: number;
        total?: number;
      };
      msg?: string;
    }>,
  /**
   * No description
   * @name POST /xinxuan/console/userLevel
   * @summary 新增等级
   * @tags 用户-用户等级信息相关接口
   * @response `200` `{ code?: number, data?: object, msg?: string }` successful operation
   */
  "/xinxuan/console/userLevel_POST": (
    root: { gmtCreate?: string; gmtModified?: string; growthValue?: number; id?: number },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/userLevel`,
      method: "POST",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; data?: object; msg?: string }>,
  /**
   * No description
   * @name GET /xinxuan/console/userLevel
   * @summary 用户等级列表查询
   * @tags 用户-用户等级信息相关接口
   * @response `200` `{ code?: number, data?: ({ growthValue?: number, id?: number })[], msg?: string }` successful operation
   */
  "/xinxuan/console/userLevel_GET": (raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xinxuan/console/userLevel`,
      method: "GET",
      data: raw,
      ...options
    }) as unknown as Promise<{ code?: number; data?: { growthValue?: number; id?: number }[]; msg?: string }>,
  /**
   * No description
   * @name PUT /xinxuan/console/userLevel
   * @summary 编辑等级
   * @tags 用户-用户等级信息相关接口
   * @response `200` `{ code?: number, data?: object, msg?: string }` successful operation
   */
  "/xinxuan/console/userLevel_PUT": (
    root: { gmtCreate?: string; gmtModified?: string; growthValue?: number; id?: number },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/userLevel`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; data?: object; msg?: string }>,
  /**
   * No description
   * @name GET /xinxuan/console/userGrowthRecord
   * @summary 查询用户成长值记录
   * @tags 用户成长值记录相关接口
   * @response `200` `{ code?: number, data?: { endRow?: number, firstPage?: number, hasNextPage?: boolean, hasPreviousPage?: boolean, isFirstPage?: boolean, isLastPage?: boolean, lastPage?: number, list?: ({ changeValue?: number, gmtCreate?: string, id?: number, remark?: string, submitTime?: string, sysSubmitUser?: string, sysSubmitUserId?: number, type?: number, userId?: number })[], navigateFirstPage?: number, navigateLastPage?: number, navigatePages?: number, navigatepageNums?: (number)[], nextPage?: number, pageNum?: number, pageSize?: number, pages?: number, prePage?: number, size?: number, startRow?: number, total?: number }, msg?: string }` successful operation
   */
  "/xinxuan/console/userGrowthRecord_GET": (
    query: XinxuanConsoleUserGrowthRecordGetParams,
    raw: File,
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/userGrowthRecord`,
      method: "GET",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        endRow?: number;
        firstPage?: number;
        hasNextPage?: boolean;
        hasPreviousPage?: boolean;
        isFirstPage?: boolean;
        isLastPage?: boolean;
        lastPage?: number;
        list?: {
          changeValue?: number;
          gmtCreate?: string;
          id?: number;
          remark?: string;
          submitTime?: string;
          sysSubmitUser?: string;
          sysSubmitUserId?: number;
          type?: number;
          userId?: number;
        }[];
        navigateFirstPage?: number;
        navigateLastPage?: number;
        navigatePages?: number;
        navigatepageNums?: number[];
        nextPage?: number;
        pageNum?: number;
        pageSize?: number;
        pages?: number;
        prePage?: number;
        size?: number;
        startRow?: number;
        total?: number;
      };
      msg?: string;
    }>,
  /**
   * No description
   * @name POST /xinxuan/console/userGrowthRecord/adjust
   * @summary 调整用户成长值
   * @tags 用户成长值记录相关接口
   * @response `200` `{ code?: number, data?: object, msg?: string }` successful operation
   */
  "/xinxuan/console/userGrowthRecord/adjust_POST": (
    root: { changeValue: number; type: number; userId?: number },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/userGrowthRecord/adjust`,
      method: "POST",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; data?: object; msg?: string }>,
  /**
   * No description
   * @name POST /xinxuan/console/userIntegralRecord/audit
   * @summary 二次审核
   * @tags 用户积分记录相关接口
   * @response `200` `{ code?: number, data?: object, msg?: string }` successful operation
   */
  "/xinxuan/console/userIntegralRecord/audit_POST": (
    root: { auditStatus: boolean; id: number },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/userIntegralRecord/audit`,
      method: "POST",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; data?: object; msg?: string }>,
  /**
   * No description
   * @name GET /xinxuan/console/userIntegralRecord/audit
   * @summary 二次审核人员查询用户积分记录
   * @tags 用户积分记录相关接口
   * @response `200` `{ code?: number, data?: { endRow?: number, firstPage?: number, hasNextPage?: boolean, hasPreviousPage?: boolean, isFirstPage?: boolean, isLastPage?: boolean, lastPage?: number, list?: ({ auditStatus?: number, auditTime?: string, changeTime?: string, changeType?: number, changeValue?: number, gmtCreate?: string, id?: number, remark?: string, submitTime?: string, sysAuditUser?: string, sysAuditUserId?: number, sysSubmitUser?: string, sysSubmitUserId?: number, type?: number, userId?: number, userMobile?: string, userName?: string })[], navigateFirstPage?: number, navigateLastPage?: number, navigatePages?: number, navigatepageNums?: (number)[], nextPage?: number, pageNum?: number, pageSize?: number, pages?: number, prePage?: number, size?: number, startRow?: number, total?: number }, msg?: string }` successful operation
   */
  "/xinxuan/console/userIntegralRecord/audit_GET": (
    query: XinxuanConsoleUserIntegralRecordAuditGetParams,
    raw: File,
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/userIntegralRecord/audit`,
      method: "GET",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        endRow?: number;
        firstPage?: number;
        hasNextPage?: boolean;
        hasPreviousPage?: boolean;
        isFirstPage?: boolean;
        isLastPage?: boolean;
        lastPage?: number;
        list?: {
          auditStatus?: number;
          auditTime?: string;
          changeTime?: string;
          changeType?: number;
          changeValue?: number;
          gmtCreate?: string;
          id?: number;
          remark?: string;
          submitTime?: string;
          sysAuditUser?: string;
          sysAuditUserId?: number;
          sysSubmitUser?: string;
          sysSubmitUserId?: number;
          type?: number;
          userId?: number;
          userMobile?: string;
          userName?: string;
        }[];
        navigateFirstPage?: number;
        navigateLastPage?: number;
        navigatePages?: number;
        navigatepageNums?: number[];
        nextPage?: number;
        pageNum?: number;
        pageSize?: number;
        pages?: number;
        prePage?: number;
        size?: number;
        startRow?: number;
        total?: number;
      };
      msg?: string;
    }>,
  /**
   * @description ## 返回示例 ``` { "code": 0, "msg": "OK", "data": { "pageNum": 1, "pageSize": 1, "size": 1, "startRow": 0, "endRow": 0, "total": 1, "pages": 1, "list": [ { "id": 1, "changeValue": 100, "type": 1, "remark": "增加积分", "changeTime": 1637506554000 } ], "prePage": 0, "nextPage": 0, "isFirstPage": true, "isLastPage": true, "hasPreviousPage": false, "hasNextPage": false, "navigatePages": 8, "navigatepageNums": [ 1 ], "navigateFirstPage": 1, "navigateLastPage": 1, "firstPage": 1, "lastPage": 1 } } ```
   * @name GET /xinxuan/console/userIntegralRecord
   * @summary 查询用户积分记录
   * @tags 用户积分记录相关接口
   * @response `200` `{ code?: number, data?: { endRow?: number, firstPage?: number, hasNextPage?: boolean, hasPreviousPage?: boolean, isFirstPage?: boolean, isLastPage?: boolean, lastPage?: number, list?: ({ auditStatus?: number, auditTime?: string, changeTime?: string, changeType?: number, changeValue?: number, gmtCreate?: string, id?: number, remark?: string, submitTime?: string, sysAuditUser?: string, sysAuditUserId?: number, sysSubmitUser?: string, sysSubmitUserId?: number, type?: number, userId?: number, userMobile?: string, userName?: string })[], navigateFirstPage?: number, navigateLastPage?: number, navigatePages?: number, navigatepageNums?: (number)[], nextPage?: number, pageNum?: number, pageSize?: number, pages?: number, prePage?: number, size?: number, startRow?: number, total?: number }, msg?: string }` successful operation
   */
  "/xinxuan/console/userIntegralRecord_GET": (
    query: XinxuanConsoleUserIntegralRecordGetParams,
    raw: File,
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/userIntegralRecord`,
      method: "GET",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        endRow?: number;
        firstPage?: number;
        hasNextPage?: boolean;
        hasPreviousPage?: boolean;
        isFirstPage?: boolean;
        isLastPage?: boolean;
        lastPage?: number;
        list?: {
          auditStatus?: number;
          auditTime?: string;
          changeTime?: string;
          changeType?: number;
          changeValue?: number;
          gmtCreate?: string;
          id?: number;
          remark?: string;
          submitTime?: string;
          sysAuditUser?: string;
          sysAuditUserId?: number;
          sysSubmitUser?: string;
          sysSubmitUserId?: number;
          type?: number;
          userId?: number;
          userMobile?: string;
          userName?: string;
        }[];
        navigateFirstPage?: number;
        navigateLastPage?: number;
        navigatePages?: number;
        navigatepageNums?: number[];
        nextPage?: number;
        pageNum?: number;
        pageSize?: number;
        pages?: number;
        prePage?: number;
        size?: number;
        startRow?: number;
        total?: number;
      };
      msg?: string;
    }>,
  /**
   * @description ## 请求示例 ``` { "changeValue": 50, "remark": "remark", "userId": 3, "type": 1 } ```
   * @name POST /xinxuan/console/userIntegralRecord/adjust
   * @summary 调整用户积分
   * @tags 用户积分记录相关接口
   * @response `200` `{ code?: number, data?: object, msg?: string }` successful operation
   */
  "/xinxuan/console/userIntegralRecord/adjust_POST": (
    root: { changeValue?: number; remark?: string; type?: number; userId?: number },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/userIntegralRecord/adjust`,
      method: "POST",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; data?: object; msg?: string }>,
  /**
   * No description
   * @name GET /xinxuan/console/userInvitedRecord
   * @summary 查询用户邀请好友记录
   * @tags 用户邀请记录相关接口
   * @response `200` `{ code?: number, data?: { endRow?: number, firstPage?: number, hasNextPage?: boolean, hasPreviousPage?: boolean, isFirstPage?: boolean, isLastPage?: boolean, lastPage?: number, list?: ({ beInviterUserId?: number, beInviterUserMobile?: string, beInviterUserName?: string, gmtCreate?: string, id?: number, userId?: number })[], navigateFirstPage?: number, navigateLastPage?: number, navigatePages?: number, navigatepageNums?: (number)[], nextPage?: number, pageNum?: number, pageSize?: number, pages?: number, prePage?: number, size?: number, startRow?: number, total?: number }, msg?: string }` successful operation
   */
  "/xinxuan/console/userInvitedRecord_GET": (
    query: XinxuanConsoleUserInvitedRecordGetParams,
    raw: File,
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/userInvitedRecord`,
      method: "GET",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        endRow?: number;
        firstPage?: number;
        hasNextPage?: boolean;
        hasPreviousPage?: boolean;
        isFirstPage?: boolean;
        isLastPage?: boolean;
        lastPage?: number;
        list?: {
          beInviterUserId?: number;
          beInviterUserMobile?: string;
          beInviterUserName?: string;
          gmtCreate?: string;
          id?: number;
          userId?: number;
        }[];
        navigateFirstPage?: number;
        navigateLastPage?: number;
        navigatePages?: number;
        navigatepageNums?: number[];
        nextPage?: number;
        pageNum?: number;
        pageSize?: number;
        pages?: number;
        prePage?: number;
        size?: number;
        startRow?: number;
        total?: number;
      };
      msg?: string;
    }>,
  /**
   * No description
   * @name POST /xinxuan/console/console/sysUser/roles-user
   * @summary 保存员工与角色的对应关系
   * @tags 系统-用户管理
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xinxuan/console/console/sysUser/roles-user_POST": (
    root: { roleIds?: number[]; userId?: number },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/console/sysUser/roles-user`,
      method: "POST",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name PUT /xinxuan/console/console/sysUser/update
   * @summary 员工修改
   * @tags 系统-用户管理
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xinxuan/console/console/sysUser/update_PUT": (
    root: { deptIds?: string; email?: string; id?: number; mobile?: string; roleIds?: number[]; username?: string },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/console/sysUser/update`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name DELETE /xinxuan/console/console/sysUser/delete
   * @summary 员工删除
   * @tags 系统-用户管理
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xinxuan/console/console/sysUser/delete_DELETE": (
    query: XinxuanConsoleConsoleSysUserDeleteDeleteParams,
    raw: File,
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/console/sysUser/delete`,
      method: "DELETE",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name POST /xinxuan/console/console/sysUser/add
   * @summary 员工新增(返回ID)
   * @tags 系统-用户管理
   * @response `200` `{ code?: number, data?: number, msg?: string }` successful operation
   */
  "/xinxuan/console/console/sysUser/add_POST": (
    root: { deptIds?: string; email?: string; id?: number; mobile?: string; roleIds?: number[]; username?: string },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/console/sysUser/add`,
      method: "POST",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; data?: number; msg?: string }>,
  /**
   * No description
   * @name GET /xinxuan/console/console/sysUser/query
   * @summary 员工表分页查询
   * @tags 系统-用户管理
   * @response `200` `{ code?: number, data?: { endRow?: number, firstPage?: number, hasNextPage?: boolean, hasPreviousPage?: boolean, isFirstPage?: boolean, isLastPage?: boolean, lastPage?: number, list?: ({ deptIds?: string, deptNames?: string, email?: string, gmtCreated?: string, gmtModified?: string, id?: number, mobile?: string, roleIds?: string, roleNames?: string, username?: string })[], navigateFirstPage?: number, navigateLastPage?: number, navigatePages?: number, navigatepageNums?: (number)[], nextPage?: number, pageNum?: number, pageSize?: number, pages?: number, prePage?: number, size?: number, startRow?: number, total?: number }, msg?: string }` successful operation
   */
  "/xinxuan/console/console/sysUser/query_GET": (
    query: XinxuanConsoleConsoleSysUserQueryGetParams,
    raw: File,
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/console/sysUser/query`,
      method: "GET",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        endRow?: number;
        firstPage?: number;
        hasNextPage?: boolean;
        hasPreviousPage?: boolean;
        isFirstPage?: boolean;
        isLastPage?: boolean;
        lastPage?: number;
        list?: {
          deptIds?: string;
          deptNames?: string;
          email?: string;
          gmtCreated?: string;
          gmtModified?: string;
          id?: number;
          mobile?: string;
          roleIds?: string;
          roleNames?: string;
          username?: string;
        }[];
        navigateFirstPage?: number;
        navigateLastPage?: number;
        navigatePages?: number;
        navigatepageNums?: number[];
        nextPage?: number;
        pageNum?: number;
        pageSize?: number;
        pages?: number;
        prePage?: number;
        size?: number;
        startRow?: number;
        total?: number;
      };
      msg?: string;
    }>,
  /**
   * No description
   * @name GET /xinxuan/console/console/sysUser/{id}/roles
   * @summary 根据员工ID查询员工关联的角色集合
   * @tags 系统-用户管理
   * @response `200` `{ code?: number, data?: ({ authority?: string, createUser?: string, description?: string, gmtCreated?: string, gmtModified?: string, id?: number, modifyUser?: string, roleName?: string, status?: number })[], msg?: string }` successful operation
   */
  "/xinxuan/console/console/sysUser/{id}/roles_GET": (id: string, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xinxuan/console/console/sysUser/${id}/roles`,
      method: "GET",
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        authority?: string;
        createUser?: string;
        description?: string;
        gmtCreated?: string;
        gmtModified?: string;
        id?: number;
        modifyUser?: string;
        roleName?: string;
        status?: number;
      }[];
      msg?: string;
    }>,
  /**
   * No description
   * @name GET /xinxuan/console/console/sysUser/{id}/resources
   * @summary 根据员工ID获取员工可访问的资源
   * @tags 系统-用户管理
   * @response `200` `{ code?: number, data?: ({ code?: string, createUser?: string, gmtCreated?: string, gmtModified?: string, icon?: string, id?: number, memo?: string, method?: string, modifyUser?: string, name?: string, parentId?: number, path?: string, sortNum?: number, status?: number, type?: number, visible?: boolean })[], msg?: string }` successful operation
   */
  "/xinxuan/console/console/sysUser/{id}/resources_GET": (id: string, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xinxuan/console/console/sysUser/${id}/resources`,
      method: "GET",
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        code?: string;
        createUser?: string;
        gmtCreated?: string;
        gmtModified?: string;
        icon?: string;
        id?: number;
        memo?: string;
        method?: string;
        modifyUser?: string;
        name?: string;
        parentId?: number;
        path?: string;
        sortNum?: number;
        status?: number;
        type?: number;
        visible?: boolean;
      }[];
      msg?: string;
    }>,
  /**
   * No description
   * @name GET /xinxuan/console/console/sysUser/current-authorities
   * @summary 获取当前用户权限
   * @tags 系统-用户管理
   * @response `200` `{ code?: number, data?: { apis?: (object)[], buttons?: (string)[], email?: string, menusTree?: ({ children?: (any)[], detail?: object, id?: number, key?: string, parentId?: number, sortNum?: number, title?: string })[], username?: string }, msg?: string }` successful operation
   */
  "/xinxuan/console/console/sysUser/current-authorities_GET": (raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xinxuan/console/console/sysUser/current-authorities`,
      method: "GET",
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        apis?: object[];
        buttons?: string[];
        email?: string;
        menusTree?: {
          children?: any[];
          detail?: object;
          id?: number;
          key?: string;
          parentId?: number;
          sortNum?: number;
          title?: string;
        }[];
        username?: string;
      };
      msg?: string;
    }>,
  /**
   * No description
   * @name DELETE /xinxuan/console/console/sysUser/resetDefault
   * @summary 重置密码
   * @tags 系统-用户管理
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xinxuan/console/console/sysUser/resetDefault_DELETE": (
    query: XinxuanConsoleConsoleSysUserResetDefaultDeleteParams,
    raw: File,
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/console/sysUser/resetDefault`,
      method: "DELETE",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name PUT /xinxuan/console/console/sysUser/resetPwd
   * @summary 重置密码
   * @tags 系统-用户管理
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xinxuan/console/console/sysUser/resetPwd_PUT": (
    root: { newPassword?: string; password?: string },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/console/sysUser/resetPwd`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name PUT /xinxuan/console/console/sysDept/update
   * @summary 部门修改
   * @tags 系统-组织机构管理
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xinxuan/console/console/sysDept/update_PUT": (
    root: { id?: number; name?: string; pid?: number },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/console/sysDept/update`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name DELETE /xinxuan/console/console/sysDept/delete
   * @summary 部门删除
   * @tags 系统-组织机构管理
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xinxuan/console/console/sysDept/delete_DELETE": (
    query: XinxuanConsoleConsoleSysDeptDeleteDeleteParams,
    raw: File,
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/console/sysDept/delete`,
      method: "DELETE",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name POST /xinxuan/console/console/sysDept/add
   * @summary 部门新增(返回ID)
   * @tags 系统-组织机构管理
   * @response `200` `{ code?: number, data?: number, msg?: string }` successful operation
   */
  "/xinxuan/console/console/sysDept/add_POST": (
    root: { id?: number; name?: string; pid?: number },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/console/sysDept/add`,
      method: "POST",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; data?: number; msg?: string }>,
  /**
   * No description
   * @name GET /xinxuan/console/console/sysDept/queryAll
   * @summary 部门表不分页查询
   * @tags 系统-组织机构管理
   * @response `200` `{ code?: number, data?: ({ children?: (any)[], gmtCreated?: string, id?: number, name?: string, pid?: number, userNum?: number })[], msg?: string }` successful operation
   */
  "/xinxuan/console/console/sysDept/queryAll_GET": (raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xinxuan/console/console/sysDept/queryAll`,
      method: "GET",
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: { children?: any[]; gmtCreated?: string; id?: number; name?: string; pid?: number; userNum?: number }[];
      msg?: string;
    }>,
  /**
   * No description
   * @name GET /xinxuan/console/console/sysDept/queryAllHaveUser
   * @summary 部门表不分页查询（包含员工信息）
   * @tags 系统-组织机构管理
   * @response `200` `{ code?: number, data?: ({ children?: ({ children?: (any)[], gmtCreated?: string, id?: number, name?: string, pid?: number, userNum?: number })[], gmtCreated?: string, id?: number, name?: string, pid?: number, userList?: ({ deptIds?: string, deptNames?: string, email?: string, gmtCreated?: string, gmtModified?: string, id?: number, mobile?: string, roleIds?: string, roleNames?: string, username?: string })[], userNum?: number })[], msg?: string }` successful operation
   */
  "/xinxuan/console/console/sysDept/queryAllHaveUser_GET": (raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xinxuan/console/console/sysDept/queryAllHaveUser`,
      method: "GET",
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        children?: {
          children?: any[];
          gmtCreated?: string;
          id?: number;
          name?: string;
          pid?: number;
          userNum?: number;
        }[];
        gmtCreated?: string;
        id?: number;
        name?: string;
        pid?: number;
        userList?: {
          deptIds?: string;
          deptNames?: string;
          email?: string;
          gmtCreated?: string;
          gmtModified?: string;
          id?: number;
          mobile?: string;
          roleIds?: string;
          roleNames?: string;
          username?: string;
        }[];
        userNum?: number;
      }[];
      msg?: string;
    }>,
  /**
   * No description
   * @name GET /xinxuan/console/console/sysDept/query
   * @summary 部门表分页查询
   * @tags 系统-组织机构管理
   * @response `200` `{ code?: number, data?: { endRow?: number, firstPage?: number, hasNextPage?: boolean, hasPreviousPage?: boolean, isFirstPage?: boolean, isLastPage?: boolean, lastPage?: number, list?: ({ children?: (any)[], gmtCreated?: string, id?: number, name?: string, pid?: number, userNum?: number })[], navigateFirstPage?: number, navigateLastPage?: number, navigatePages?: number, navigatepageNums?: (number)[], nextPage?: number, pageNum?: number, pageSize?: number, pages?: number, prePage?: number, size?: number, startRow?: number, total?: number }, msg?: string }` successful operation
   */
  "/xinxuan/console/console/sysDept/query_GET": (
    query: XinxuanConsoleConsoleSysDeptQueryGetParams,
    raw: File,
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/console/sysDept/query`,
      method: "GET",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        endRow?: number;
        firstPage?: number;
        hasNextPage?: boolean;
        hasPreviousPage?: boolean;
        isFirstPage?: boolean;
        isLastPage?: boolean;
        lastPage?: number;
        list?: { children?: any[]; gmtCreated?: string; id?: number; name?: string; pid?: number; userNum?: number }[];
        navigateFirstPage?: number;
        navigateLastPage?: number;
        navigatePages?: number;
        navigatepageNums?: number[];
        nextPage?: number;
        pageNum?: number;
        pageSize?: number;
        pages?: number;
        prePage?: number;
        size?: number;
        startRow?: number;
        total?: number;
      };
      msg?: string;
    }>,
  /**
   * No description
   * @name PUT /xinxuan/console/console/sysRole/update
   * @summary 修改角色
   * @tags 系统-角色管理
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xinxuan/console/console/sysRole/update_PUT": (
    root: { authority?: string; description?: string; id?: number; resourceIds?: number[]; roleName?: string },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/console/sysRole/update`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name POST /xinxuan/console/console/sysRole/resources-role
   * @summary 批量保存角色和资源的对应关系
   * @tags 系统-角色管理
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xinxuan/console/console/sysRole/resources-role_POST": (
    root: { resourceIds?: number[]; roleId?: number },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/console/sysRole/resources-role`,
      method: "POST",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name POST /xinxuan/console/console/sysRole/add
   * @summary 新增角色(返回ID)
   * @tags 系统-角色管理
   * @response `200` `{ code?: number, data?: number, msg?: string }` successful operation
   */
  "/xinxuan/console/console/sysRole/add_POST": (
    root: { authority?: string; description?: string; id?: number; resourceIds?: number[]; roleName?: string },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/console/sysRole/add`,
      method: "POST",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; data?: number; msg?: string }>,
  /**
   * No description
   * @name GET /xinxuan/console/console/sysRole/{id}/resources
   * @summary 获取角色对应的资源集合
   * @tags 系统-角色管理
   * @response `200` `{ code?: number, data?: ({ code?: string, createUser?: string, gmtCreated?: string, gmtModified?: string, icon?: string, id?: number, memo?: string, method?: string, modifyUser?: string, name?: string, parentId?: number, path?: string, sortNum?: number, status?: number, type?: number, visible?: boolean })[], msg?: string }` successful operation
   */
  "/xinxuan/console/console/sysRole/{id}/resources_GET": (id: string, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xinxuan/console/console/sysRole/${id}/resources`,
      method: "GET",
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        code?: string;
        createUser?: string;
        gmtCreated?: string;
        gmtModified?: string;
        icon?: string;
        id?: number;
        memo?: string;
        method?: string;
        modifyUser?: string;
        name?: string;
        parentId?: number;
        path?: string;
        sortNum?: number;
        status?: number;
        type?: number;
        visible?: boolean;
      }[];
      msg?: string;
    }>,
  /**
   * No description
   * @name DELETE /xinxuan/console/console/sysRole/delete
   * @summary 角色删除
   * @tags 系统-角色管理
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xinxuan/console/console/sysRole/delete_DELETE": (
    query: XinxuanConsoleConsoleSysRoleDeleteDeleteParams,
    raw: File,
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/console/sysRole/delete`,
      method: "DELETE",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name GET /xinxuan/console/console/sysRole/queryAll
   * @summary 角色表不分页查询
   * @tags 系统-角色管理
   * @response `200` `{ code?: number, data?: ({ authority?: string, description?: string, gmtCreated?: string, gmtModified?: string, id?: number, roleName?: string, userNum?: number })[], msg?: string }` successful operation
   */
  "/xinxuan/console/console/sysRole/queryAll_GET": (
    query: XinxuanConsoleConsoleSysRoleQueryAllGetParams,
    raw: File,
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/console/sysRole/queryAll`,
      method: "GET",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        authority?: string;
        description?: string;
        gmtCreated?: string;
        gmtModified?: string;
        id?: number;
        roleName?: string;
        userNum?: number;
      }[];
      msg?: string;
    }>,
  /**
   * No description
   * @name GET /xinxuan/console/console/sysRole/query
   * @summary 角色表分页查询
   * @tags 系统-角色管理
   * @response `200` `{ code?: number, data?: { endRow?: number, firstPage?: number, hasNextPage?: boolean, hasPreviousPage?: boolean, isFirstPage?: boolean, isLastPage?: boolean, lastPage?: number, list?: ({ authority?: string, description?: string, gmtCreated?: string, gmtModified?: string, id?: number, roleName?: string, userNum?: number })[], navigateFirstPage?: number, navigateLastPage?: number, navigatePages?: number, navigatepageNums?: (number)[], nextPage?: number, pageNum?: number, pageSize?: number, pages?: number, prePage?: number, size?: number, startRow?: number, total?: number }, msg?: string }` successful operation
   */
  "/xinxuan/console/console/sysRole/query_GET": (
    query: XinxuanConsoleConsoleSysRoleQueryGetParams,
    raw: File,
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/console/sysRole/query`,
      method: "GET",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        endRow?: number;
        firstPage?: number;
        hasNextPage?: boolean;
        hasPreviousPage?: boolean;
        isFirstPage?: boolean;
        isLastPage?: boolean;
        lastPage?: number;
        list?: {
          authority?: string;
          description?: string;
          gmtCreated?: string;
          gmtModified?: string;
          id?: number;
          roleName?: string;
          userNum?: number;
        }[];
        navigateFirstPage?: number;
        navigateLastPage?: number;
        navigatePages?: number;
        navigatepageNums?: number[];
        nextPage?: number;
        pageNum?: number;
        pageSize?: number;
        pages?: number;
        prePage?: number;
        size?: number;
        startRow?: number;
        total?: number;
      };
      msg?: string;
    }>,
  /**
   * No description
   * @name GET /xinxuan/console/console/sysRole/{id}
   * @summary 详情
   * @tags 系统-角色管理
   * @response `200` `{ code?: number, data?: { apiIds?: (number)[], authority?: string, buttonIds?: (number)[], description?: string, gmtCreated?: string, gmtModified?: string, id?: number, menuIds?: (number)[], roleName?: string, userNum?: number }, msg?: string }` successful operation
   */
  "/xinxuan/console/console/sysRole/{id}_GET": (id: string, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xinxuan/console/console/sysRole/${id}`,
      method: "GET",
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        apiIds?: number[];
        authority?: string;
        buttonIds?: number[];
        description?: string;
        gmtCreated?: string;
        gmtModified?: string;
        id?: number;
        menuIds?: number[];
        roleName?: string;
        userNum?: number;
      };
      msg?: string;
    }>,
  /**
   * No description
   * @name PUT /xinxuan/console/console/sysResource
   * @summary 修改
   * @tags 系统-资源管理
   * @response `200` `{ code?: number, data?: string, msg?: string }` successful operation
   */
  "/xinxuan/console/console/sysResource_PUT": (
    root: {
      code?: string;
      createUser?: string;
      gmtCreated?: string;
      gmtModified?: string;
      icon?: string;
      id?: number;
      memo?: string;
      method?: string;
      modifyUser?: string;
      name?: string;
      parentId?: number;
      path?: string;
      sortNum?: number;
      status?: number;
      type?: number;
      visible?: boolean;
    },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/console/sysResource`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; data?: string; msg?: string }>,
  /**
   * No description
   * @name GET /xinxuan/console/console/sysResource
   * @summary 搜索资源
   * @tags 系统-资源管理
   * @response `200` `{ code?: number, data?: { endRow?: number, firstPage?: number, hasNextPage?: boolean, hasPreviousPage?: boolean, isFirstPage?: boolean, isLastPage?: boolean, lastPage?: number, list?: ({ code?: string, createUser?: string, gmtCreated?: string, gmtModified?: string, icon?: string, id?: number, memo?: string, method?: string, modifyUser?: string, name?: string, parentId?: number, path?: string, sortNum?: number, status?: number, type?: number, visible?: boolean })[], navigateFirstPage?: number, navigateLastPage?: number, navigatePages?: number, navigatepageNums?: (number)[], nextPage?: number, pageNum?: number, pageSize?: number, pages?: number, prePage?: number, size?: number, startRow?: number, total?: number }, msg?: string }` successful operation
   */
  "/xinxuan/console/console/sysResource_GET": (
    query: XinxuanConsoleConsoleSysResourceGetParams,
    raw: File,
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/console/sysResource`,
      method: "GET",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        endRow?: number;
        firstPage?: number;
        hasNextPage?: boolean;
        hasPreviousPage?: boolean;
        isFirstPage?: boolean;
        isLastPage?: boolean;
        lastPage?: number;
        list?: {
          code?: string;
          createUser?: string;
          gmtCreated?: string;
          gmtModified?: string;
          icon?: string;
          id?: number;
          memo?: string;
          method?: string;
          modifyUser?: string;
          name?: string;
          parentId?: number;
          path?: string;
          sortNum?: number;
          status?: number;
          type?: number;
          visible?: boolean;
        }[];
        navigateFirstPage?: number;
        navigateLastPage?: number;
        navigatePages?: number;
        navigatepageNums?: number[];
        nextPage?: number;
        pageNum?: number;
        pageSize?: number;
        pages?: number;
        prePage?: number;
        size?: number;
        startRow?: number;
        total?: number;
      };
      msg?: string;
    }>,
  /**
   * No description
   * @name POST /xinxuan/console/console/sysResource
   * @summary 新增
   * @tags 系统-资源管理
   * @response `200` `{ code?: number, data?: string, msg?: string }` successful operation
   */
  "/xinxuan/console/console/sysResource_POST": (
    root: {
      code?: string;
      createUser?: string;
      gmtCreated?: string;
      gmtModified?: string;
      icon?: string;
      id?: number;
      memo?: string;
      method?: string;
      modifyUser?: string;
      name?: string;
      parentId?: number;
      path?: string;
      sortNum?: number;
      status?: number;
      type?: number;
      visible?: boolean;
    },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/console/sysResource`,
      method: "POST",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; data?: string; msg?: string }>,
  /**
   * No description
   * @name PUT /xinxuan/console/console/sysResource/{id}
   * @summary 修改
   * @tags 系统-资源管理
   * @response `200` `{ code?: number, data?: string, msg?: string }` successful operation
   */
  "/xinxuan/console/console/sysResource/{id}_PUT": (
    id: string,
    root: {
      code?: string;
      createUser?: string;
      gmtCreated?: string;
      gmtModified?: string;
      icon?: string;
      id?: number;
      memo?: string;
      method?: string;
      modifyUser?: string;
      name?: string;
      parentId?: number;
      path?: string;
      sortNum?: number;
      status?: number;
      type?: number;
      visible?: boolean;
    },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/console/sysResource/${id}`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; data?: string; msg?: string }>,
  /**
   * No description
   * @name DELETE /xinxuan/console/console/sysResource/{id}
   * @summary 删除
   * @tags 系统-资源管理
   * @response `200` `{ code?: number, data?: string, msg?: string }` successful operation
   */
  "/xinxuan/console/console/sysResource/{id}_DELETE": (id: string, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xinxuan/console/console/sysResource/${id}`,
      method: "DELETE",
      data: raw,
      ...options
    }) as unknown as Promise<{ code?: number; data?: string; msg?: string }>,
  /**
   * No description
   * @name GET /xinxuan/console/console/sysResource/{id}
   * @summary 详情
   * @tags 系统-资源管理
   * @response `200` `{ code?: number, data?: { code?: string, createUser?: string, gmtCreated?: string, gmtModified?: string, icon?: string, id?: number, memo?: string, method?: string, modifyUser?: string, name?: string, parentId?: number, path?: string, sortNum?: number, status?: number, type?: number, visible?: boolean }, msg?: string }` successful operation
   */
  "/xinxuan/console/console/sysResource/{id}_GET": (id: string, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xinxuan/console/console/sysResource/${id}`,
      method: "GET",
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        code?: string;
        createUser?: string;
        gmtCreated?: string;
        gmtModified?: string;
        icon?: string;
        id?: number;
        memo?: string;
        method?: string;
        modifyUser?: string;
        name?: string;
        parentId?: number;
        path?: string;
        sortNum?: number;
        status?: number;
        type?: number;
        visible?: boolean;
      };
      msg?: string;
    }>,
  /**
   * No description
   * @name GET /xinxuan/console/console/sysResource/{menu-id}/buttons-and-apis
   * @summary 根据菜单ID加载菜单下所有的接口资源和按钮资源
   * @tags 系统-资源管理
   * @response `200` `{ code?: number, data?: { apis?: (object)[], buttons?: (object)[] }, msg?: string }` successful operation
   */
  "/xinxuan/console/console/sysResource/{menu-id}/buttons-and-apis_GET": (
    menuId: string,
    raw: File,
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/console/sysResource/${menuId}/buttons-and-apis`,
      method: "GET",
      data: raw,
      ...options
    }) as unknown as Promise<{ code?: number; data?: { apis?: object[]; buttons?: object[] }; msg?: string }>,
  /**
   * No description
   * @name GET /xinxuan/console/console/sysResource/buttons-and-apis-batch
   * @summary 根据菜单ID加载菜单下所有的接口资源和按钮资源（批量）
   * @tags 系统-资源管理
   * @response `200` `{ code?: number, data?: ({ buttonAndApi?: { apiIds?: (number)[], buttonIds?: (number)[] }, menuId?: number })[], msg?: string }` successful operation
   */
  "/xinxuan/console/console/sysResource/buttons-and-apis-batch_GET": (
    query: XinxuanConsoleConsoleSysResourceButtonsAndApisBatchGetParams,
    raw: File,
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/console/sysResource/buttons-and-apis-batch`,
      method: "GET",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: { buttonAndApi?: { apiIds?: number[]; buttonIds?: number[] }; menuId?: number }[];
      msg?: string;
    }>,
  /**
   * No description
   * @name GET /xinxuan/console/console/sysResource/tree
   * @summary 获取所有资源列表（树状结构）
   * @tags 系统-资源管理
   * @response `200` `{ code?: number, data?: ({ children?: (any)[], detail?: object, id?: number, key?: string, parentId?: number, sortNum?: number, title?: string })[], msg?: string }` successful operation
   */
  "/xinxuan/console/console/sysResource/tree_GET": (
    query: XinxuanConsoleConsoleSysResourceTreeGetParams,
    raw: File,
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/console/sysResource/tree`,
      method: "GET",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        children?: any[];
        detail?: object;
        id?: number;
        key?: string;
        parentId?: number;
        sortNum?: number;
        title?: string;
      }[];
      msg?: string;
    }>,
  /**
   * No description
   * @name POST /xinxuan/console/surveyTemplates
   * @summary 创建
   * @tags 调研模板-模板管理
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xinxuan/console/surveyTemplates_POST": (
    root: {
      description?: string;
      name: string;
      questions: { content?: string; enumChooseMode: number; options?: { name?: string; picUrl: string }[] }[];
    },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/surveyTemplates`,
      method: "POST",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name GET /xinxuan/console/surveyTemplates
   * @summary 搜索
   * @tags 调研模板-模板管理
   * @response `200` `{ code?: number, data?: { endRow?: number, firstPage?: number, hasNextPage?: boolean, hasPreviousPage?: boolean, isFirstPage?: boolean, isLastPage?: boolean, lastPage?: number, list?: ({ createUser?: string, description: string, gmtCreated?: string, id: number, name: string, participantCnt?: number })[], navigateFirstPage?: number, navigateLastPage?: number, navigatePages?: number, navigatepageNums?: (number)[], nextPage?: number, pageNum?: number, pageSize?: number, pages?: number, prePage?: number, size?: number, startRow?: number, total?: number }, msg?: string }` successful operation
   */
  "/xinxuan/console/surveyTemplates_GET": (
    query: XinxuanConsoleSurveyTemplatesGetParams,
    raw: File,
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/surveyTemplates`,
      method: "GET",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        endRow?: number;
        firstPage?: number;
        hasNextPage?: boolean;
        hasPreviousPage?: boolean;
        isFirstPage?: boolean;
        isLastPage?: boolean;
        lastPage?: number;
        list?: {
          createUser?: string;
          description: string;
          gmtCreated?: string;
          id: number;
          name: string;
          participantCnt?: number;
        }[];
        navigateFirstPage?: number;
        navigateLastPage?: number;
        navigatePages?: number;
        navigatepageNums?: number[];
        nextPage?: number;
        pageNum?: number;
        pageSize?: number;
        pages?: number;
        prePage?: number;
        size?: number;
        startRow?: number;
        total?: number;
      };
      msg?: string;
    }>,
  /**
   * No description
   * @name DELETE /xinxuan/console/surveyTemplates/{id}
   * @summary 删除
   * @tags 调研模板-模板管理
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xinxuan/console/surveyTemplates/{id}_DELETE": (id: string, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xinxuan/console/surveyTemplates/${id}`,
      method: "DELETE",
      data: raw,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name PUT /xinxuan/console/surveyTemplates/{id}
   * @summary 更新
   * @tags 调研模板-模板管理
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xinxuan/console/surveyTemplates/{id}_PUT": (
    id: string,
    root: {
      description?: string;
      name: string;
      questions: { content?: string; enumChooseMode: number; options?: { name?: string; picUrl: string }[] }[];
    },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/surveyTemplates/${id}`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name GET /xinxuan/console/surveyTemplates/{id}
   * @summary 详情
   * @tags 调研模板-模板管理
   * @response `200` `{ code?: number, data?: { description?: string, id: number, name: string, questions?: ({ content?: string, enumChooseMode: number, id: number, options: ({ id: number, name?: string, picUrl: string, questionId: number, templateId: number })[], templateId: number })[] }, msg?: string }` successful operation
   */
  "/xinxuan/console/surveyTemplates/{id}_GET": (id: string, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xinxuan/console/surveyTemplates/${id}`,
      method: "GET",
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        description?: string;
        id: number;
        name: string;
        questions?: {
          content?: string;
          enumChooseMode: number;
          id: number;
          options: { id: number; name?: string; picUrl: string; questionId: number; templateId: number }[];
          templateId: number;
        }[];
      };
      msg?: string;
    }>,
  /**
   * @description ## 请求示例 ``` { "id": 1, "status": false } ```
   * @name PUT /xinxuan/console/banner/status
   * @summary 修改banner状态
   * @tags 首页banner相关接口
   * @response `200` `{ code?: number, data?: object, msg?: string }` successful operation
   */
  "/xinxuan/console/banner/status_PUT": (
    root: {
      gmtCreate?: string;
      gmtModified?: string;
      id?: number;
      imgUrl: string;
      jumpDesc?: string;
      jumpUrl?: string;
      sort: number;
      status: boolean;
      typeList: { bannerId?: number; gmtCreate?: string; id?: number; type?: number }[];
    },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/banner/status`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; data?: object; msg?: string }>,
  /**
   * No description
   * @name DELETE /xinxuan/console/banner/{id}
   * @summary 删除banner
   * @tags 首页banner相关接口
   * @response `200` `{ code?: number, data?: object, msg?: string }` successful operation
   */
  "/xinxuan/console/banner/{id}_DELETE": (id: string, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xinxuan/console/banner/${id}`,
      method: "DELETE",
      data: raw,
      ...options
    }) as unknown as Promise<{ code?: number; data?: object; msg?: string }>,
  /**
   * No description
   * @name GET /xinxuan/console/banner/{id}
   * @summary 查询banner详情
   * @tags 首页banner相关接口
   * @response `200` `{ code?: number, data?: { id?: number, imgUrl?: string, jumpDesc?: string, jumpUrl?: string, sort?: number, status?: boolean, typeList?: ({ bannerId?: number, gmtCreate?: string, id?: number, type?: number })[] }, msg?: string }` successful operation
   */
  "/xinxuan/console/banner/{id}_GET": (id: string, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xinxuan/console/banner/${id}`,
      method: "GET",
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        id?: number;
        imgUrl?: string;
        jumpDesc?: string;
        jumpUrl?: string;
        sort?: number;
        status?: boolean;
        typeList?: { bannerId?: number; gmtCreate?: string; id?: number; type?: number }[];
      };
      msg?: string;
    }>,
  /**
   * @description ## 请求示例 ``` { "imgUrl": "http://dummyimage.com/250x250", "sort": 1, "status": true, "typeList": [ { "type": 1 }, { "type": 2 } ] } ```
   * @name POST /xinxuan/console/banner
   * @summary 新增banner
   * @tags 首页banner相关接口
   * @response `200` `{ code?: number, data?: object, msg?: string }` successful operation
   */
  "/xinxuan/console/banner_POST": (
    root: {
      gmtCreate?: string;
      gmtModified?: string;
      id?: number;
      imgUrl: string;
      jumpDesc?: string;
      jumpUrl?: string;
      sort: number;
      status: boolean;
      typeList: { bannerId?: number; gmtCreate?: string; id?: number; type?: number }[];
    },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/banner`,
      method: "POST",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; data?: object; msg?: string }>,
  /**
   * No description
   * @name GET /xinxuan/console/banner
   * @summary 查询banner
   * @tags 首页banner相关接口
   * @response `200` `{ code?: number, data?: ({ id?: number, imgUrl?: string, jumpDesc?: string, jumpUrl?: string, sort?: number, status?: boolean, typeList?: ({ bannerId?: number, gmtCreate?: string, id?: number, type?: number })[] })[], msg?: string }` successful operation
   */
  "/xinxuan/console/banner_GET": (query: XinxuanConsoleBannerGetParams, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xinxuan/console/banner`,
      method: "GET",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        id?: number;
        imgUrl?: string;
        jumpDesc?: string;
        jumpUrl?: string;
        sort?: number;
        status?: boolean;
        typeList?: { bannerId?: number; gmtCreate?: string; id?: number; type?: number }[];
      }[];
      msg?: string;
    }>,
  /**
   * @description ## 请求示例 ``` { "id":1, "imgUrl": "http://dummyimage.com/", "sort": 11, "status": true, "typeList": [ { "type": 1 }, { "type": 2 } ] } ```
   * @name PUT /xinxuan/console/banner
   * @summary 编辑banner
   * @tags 首页banner相关接口
   * @response `200` `{ code?: number, data?: object, msg?: string }` successful operation
   */
  "/xinxuan/console/banner_PUT": (
    root: {
      gmtCreate?: string;
      gmtModified?: string;
      id?: number;
      imgUrl: string;
      jumpDesc?: string;
      jumpUrl?: string;
      sort: number;
      status: boolean;
      typeList: { bannerId?: number; gmtCreate?: string; id?: number; type?: number }[];
    },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/banner`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; data?: object; msg?: string }>,
  /**
   * No description
   * @name PUT /xinxuan/console/groups/mute
   * @summary 圈子封禁/取消封禁
   * @tags 圈子-圈子管理
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xinxuan/console/groups/mute_PUT": (root: { decision?: boolean; groupId?: number }, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xinxuan/console/groups/mute`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name GET /xinxuan/console/groups/{id}
   * @summary 圈子详情
   * @tags 圈子-圈子管理
   * @response `200` `{ code?: number, data?: { commentCnt?: number, createdTime?: string, creatorId: number, creatorNickname: string, enumStatus?: number, id: number, imgLogo?: string, leastLevel?: number, memberCnt?: number, name: string, normal?: boolean, postsCnt?: number, recommend?: boolean, subTitle: string, top?: boolean }, msg?: string }` successful operation
   */
  "/xinxuan/console/groups/{id}_GET": (id: string, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xinxuan/console/groups/${id}`,
      method: "GET",
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        commentCnt?: number;
        createdTime?: string;
        creatorId: number;
        creatorNickname: string;
        enumStatus?: number;
        id: number;
        imgLogo?: string;
        leastLevel?: number;
        memberCnt?: number;
        name: string;
        normal?: boolean;
        postsCnt?: number;
        recommend?: boolean;
        subTitle: string;
        top?: boolean;
      };
      msg?: string;
    }>,
  /**
   * No description
   * @name GET /xinxuan/console/groups
   * @summary 搜索圈子列表
   * @tags 圈子-圈子管理
   * @response `200` `{ code?: number, data?: { endRow?: number, firstPage?: number, hasNextPage?: boolean, hasPreviousPage?: boolean, isFirstPage?: boolean, isLastPage?: boolean, lastPage?: number, list?: ({ commentCnt?: number, createdTime?: string, creatorId: number, creatorNickname: string, enumStatus?: number, id: number, imgLogo?: string, leastLevel?: number, memberCnt?: number, name: string, normal?: boolean, postsCnt?: number, recommend?: boolean, subTitle: string, top?: boolean })[], navigateFirstPage?: number, navigateLastPage?: number, navigatePages?: number, navigatepageNums?: (number)[], nextPage?: number, pageNum?: number, pageSize?: number, pages?: number, prePage?: number, size?: number, startRow?: number, total?: number }, msg?: string }` successful operation
   */
  "/xinxuan/console/groups_GET": (query: XinxuanConsoleGroupsGetParams, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xinxuan/console/groups`,
      method: "GET",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        endRow?: number;
        firstPage?: number;
        hasNextPage?: boolean;
        hasPreviousPage?: boolean;
        isFirstPage?: boolean;
        isLastPage?: boolean;
        lastPage?: number;
        list?: {
          commentCnt?: number;
          createdTime?: string;
          creatorId: number;
          creatorNickname: string;
          enumStatus?: number;
          id: number;
          imgLogo?: string;
          leastLevel?: number;
          memberCnt?: number;
          name: string;
          normal?: boolean;
          postsCnt?: number;
          recommend?: boolean;
          subTitle: string;
          top?: boolean;
        }[];
        navigateFirstPage?: number;
        navigateLastPage?: number;
        navigatePages?: number;
        navigatepageNums?: number[];
        nextPage?: number;
        pageNum?: number;
        pageSize?: number;
        pages?: number;
        prePage?: number;
        size?: number;
        startRow?: number;
        total?: number;
      };
      msg?: string;
    }>,
  /**
   * No description
   * @name GET /xinxuan/console/groups/simple
   * @summary 简单搜索
   * @tags 圈子-圈子管理
   * @response `200` `{ code?: number, data?: { endRow?: number, firstPage?: number, hasNextPage?: boolean, hasPreviousPage?: boolean, isFirstPage?: boolean, isLastPage?: boolean, lastPage?: number, list?: ({ creatorNickname?: string, id?: number, name?: string })[], navigateFirstPage?: number, navigateLastPage?: number, navigatePages?: number, navigatepageNums?: (number)[], nextPage?: number, pageNum?: number, pageSize?: number, pages?: number, prePage?: number, size?: number, startRow?: number, total?: number }, msg?: string }` successful operation
   */
  "/xinxuan/console/groups/simple_GET": (
    query: XinxuanConsoleGroupsSimpleGetParams,
    raw: File,
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/groups/simple`,
      method: "GET",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        endRow?: number;
        firstPage?: number;
        hasNextPage?: boolean;
        hasPreviousPage?: boolean;
        isFirstPage?: boolean;
        isLastPage?: boolean;
        lastPage?: number;
        list?: { creatorNickname?: string; id?: number; name?: string }[];
        navigateFirstPage?: number;
        navigateLastPage?: number;
        navigatePages?: number;
        navigatepageNums?: number[];
        nextPage?: number;
        pageNum?: number;
        pageSize?: number;
        pages?: number;
        prePage?: number;
        size?: number;
        startRow?: number;
        total?: number;
      };
      msg?: string;
    }>,
  /**
   * No description
   * @name PUT /xinxuan/console/groups/top
   * @summary 置顶取消置顶
   * @tags 圈子-圈子管理
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xinxuan/console/groups/top_PUT": (root: { decision?: boolean; groupId?: number }, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xinxuan/console/groups/top`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name PUT /xinxuan/console/groups/recommend
   * @summary 首页推荐/取消推荐
   * @tags 圈子-圈子管理
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xinxuan/console/groups/recommend_PUT": (
    root: { decision?: boolean; groupId?: number },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/groups/recommend`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name PUT /xinxuan/console/posts/visible
   * @summary 上架下架
   * @tags 帖子-帖子管理
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xinxuan/console/posts/visible_PUT": (
    root: { decision?: boolean; groupId?: number; postsId?: number },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/posts/visible`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name DELETE /xinxuan/console/posts/{id}
   * @summary 删帖
   * @tags 帖子-帖子管理
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xinxuan/console/posts/{id}_DELETE": (id: string, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xinxuan/console/posts/${id}`,
      method: "DELETE",
      data: raw,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name GET /xinxuan/console/posts/{id}
   * @summary 帖子详情
   * @tags 帖子-帖子管理
   * @response `200` `{ code?: number, data?: { allowReply?: boolean, attachments?: ({ enumType: number, id: number, postsId: number, url?: string })[], commentCnt?: number, comments?: ({ content?: string, groupId: number, id: number, mentionMemberId?: number, postsId: number, publishTime?: string, publisherId: number })[], content?: string, followedPublisher?: boolean, groupId: number, groupName?: string, id: number, likeCnt?: number, memberList?: ({ address?: { address?: string, city?: string, district?: string, gmtCreate?: string, id?: number, isDefault?: boolean, mobile?: string, name?: string, province?: string, userId?: number }, birthday?: string, family?: { boyBirthday?: (object)[], boyNum?: number, elderNum?: number, girlBirthday?: (object)[], girlNum?: number, id?: number, userId?: number }, groupCreator?: boolean, groupCreatorTime?: string, growth?: number, headImgUrl?: string, historyIntegral?: number, id?: number, integral?: number, level?: number, mail?: string, mobile?: string, nextGrowth?: number, nickname?: string, openid?: string, registerDate?: string, sex?: number, status?: boolean, tagList?: ({ gmtCreate?: string, id?: number, tagId?: number, tagName?: string, userId?: number })[] })[], publishTime?: string, publisherId: number, publisherNickname: string, sortNum?: number, top?: boolean, topicId?: number, topicName?: string, topics?: ({ id: number, postsId: number, topicId: number })[] }, msg?: string }` successful operation
   */
  "/xinxuan/console/posts/{id}_GET": (id: string, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xinxuan/console/posts/${id}`,
      method: "GET",
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        allowReply?: boolean;
        attachments?: { enumType: number; id: number; postsId: number; url?: string }[];
        commentCnt?: number;
        comments?: {
          content?: string;
          groupId: number;
          id: number;
          mentionMemberId?: number;
          postsId: number;
          publishTime?: string;
          publisherId: number;
        }[];
        content?: string;
        followedPublisher?: boolean;
        groupId: number;
        groupName?: string;
        id: number;
        likeCnt?: number;
        memberList?: {
          address?: {
            address?: string;
            city?: string;
            district?: string;
            gmtCreate?: string;
            id?: number;
            isDefault?: boolean;
            mobile?: string;
            name?: string;
            province?: string;
            userId?: number;
          };
          birthday?: string;
          family?: {
            boyBirthday?: object[];
            boyNum?: number;
            elderNum?: number;
            girlBirthday?: object[];
            girlNum?: number;
            id?: number;
            userId?: number;
          };
          groupCreator?: boolean;
          groupCreatorTime?: string;
          growth?: number;
          headImgUrl?: string;
          historyIntegral?: number;
          id?: number;
          integral?: number;
          level?: number;
          mail?: string;
          mobile?: string;
          nextGrowth?: number;
          nickname?: string;
          openid?: string;
          registerDate?: string;
          sex?: number;
          status?: boolean;
          tagList?: { gmtCreate?: string; id?: number; tagId?: number; tagName?: string; userId?: number }[];
        }[];
        publishTime?: string;
        publisherId: number;
        publisherNickname: string;
        sortNum?: number;
        top?: boolean;
        topicId?: number;
        topicName?: string;
        topics?: { id: number; postsId: number; topicId: number }[];
      };
      msg?: string;
    }>,
  /**
   * No description
   * @name GET /xinxuan/console/posts
   * @summary 搜索帖子列表
   * @tags 帖子-帖子管理
   * @response `200` `{ code?: number, data?: { endRow?: number, firstPage?: number, hasNextPage?: boolean, hasPreviousPage?: boolean, isFirstPage?: boolean, isLastPage?: boolean, lastPage?: number, list?: ({ commentCnt?: number, content?: string, groupName?: string, id: number, likeCnt?: number, publishTime?: string, publisherId?: number, publisherNickname?: string, recommend?: boolean, shareCnt?: number, top?: boolean, visible?: boolean })[], navigateFirstPage?: number, navigateLastPage?: number, navigatePages?: number, navigatepageNums?: (number)[], nextPage?: number, pageNum?: number, pageSize?: number, pages?: number, prePage?: number, size?: number, startRow?: number, total?: number }, msg?: string }` successful operation
   */
  "/xinxuan/console/posts_GET": (query: XinxuanConsolePostsGetParams, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xinxuan/console/posts`,
      method: "GET",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<{
      code?: number;
      data?: {
        endRow?: number;
        firstPage?: number;
        hasNextPage?: boolean;
        hasPreviousPage?: boolean;
        isFirstPage?: boolean;
        isLastPage?: boolean;
        lastPage?: number;
        list?: {
          commentCnt?: number;
          content?: string;
          groupName?: string;
          id: number;
          likeCnt?: number;
          publishTime?: string;
          publisherId?: number;
          publisherNickname?: string;
          recommend?: boolean;
          shareCnt?: number;
          top?: boolean;
          visible?: boolean;
        }[];
        navigateFirstPage?: number;
        navigateLastPage?: number;
        navigatePages?: number;
        navigatepageNums?: number[];
        nextPage?: number;
        pageNum?: number;
        pageSize?: number;
        pages?: number;
        prePage?: number;
        size?: number;
        startRow?: number;
        total?: number;
      };
      msg?: string;
    }>,
  /**
   * No description
   * @name PUT /xinxuan/console/posts/top
   * @summary 是否置顶
   * @tags 帖子-帖子管理
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xinxuan/console/posts/top_PUT": (
    root: { decision?: boolean; groupId?: number; postsId?: number },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/posts/top`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name PUT /xinxuan/console/posts/recommend
   * @summary 是否首页推荐
   * @tags 帖子-帖子管理
   * @response `200` `{ code?: number, msg?: string }` successful operation
   */
  "/xinxuan/console/posts/recommend_PUT": (
    root: { postsId?: number; recommend?: boolean },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/posts/recommend`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<{ code?: number; msg?: string }>,
  /**
   * No description
   * @name GET /xinxuan/console/copywriter/{id}
   * @summary 查询运营文案
   * @tags 运营文案配置相关接口
   * @response `200` `{ code?: number, data?: { content?: string, id?: number }, msg?: string }` successful operation
   */
  "/xinxuan/console/copywriter/{id}_GET": (id: string, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xinxuan/console/copywriter/${id}`,
      method: "GET",
      data: raw,
      ...options
    }) as unknown as Promise<{ code?: number; data?: { content?: string; id?: number }; msg?: string }>,
  /**
   * No description
   * @name PUT /xinxuan/console/copywriter
   * @summary 编辑运营文案
   * @tags 运营文案配置相关接口
   * @response `200` `File` successful operation
   */
  "/xinxuan/console/copywriter_PUT": (
    root: { content?: string; gmtCreate?: string; gmtModified?: string; id?: number },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/xinxuan/console/copywriter`,
      method: "PUT",
      data: root,
      ...options
    }) as unknown as Promise<File>,


  // 2022-3-1 新增接口 复制 
  /**
 * No description
 * @name GET console/tags/search
 * @summary 搜索标签
 * @tags 标签-标签管理
 * @response `200` `{ code?: number, data?: { endRow?: number, firstPage?: number, hasNextPage?: boolean, hasPreviousPage?: boolean, isFirstPage?: boolean, isLastPage?: boolean, lastPage?: number, list?: ({ categoryId: number, categoryName: string, enabled: boolean, groupCnt: number, id: number, memberCnt: number, name: string })[], navigateFirstPage?: number, navigateLastPage?: number, navigatePages?: number, navigatepageNums?: (number)[], nextPage?: number, pageNum?: number, pageSize?: number, pages?: number, prePage?: number, size?: number, startRow?: number, total?: number }, msg?: string }` successful operation
 */
  "/xinxuan/console/tags/search_GET": (query: XinxuanConsoleTagsGetParams, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/xinxuan/console/tags/search`,
      method: "GET",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<any>,
  /**
   * No description
   * @name GET console/tags/search
   * @summary 分组标签 树状图  一级分组/二级分组/三级分组
   * @tags 标签-标签管理
   * @response `200` `{ code?: number, data?: { endRow?: number, firstPage?: number, hasNextPage?: boolean, hasPreviousPage?: boolean, isFirstPage?: boolean, isLastPage?: boolean, lastPage?: number, list?: ({ categoryId: number, categoryName: string, enabled: boolean, groupCnt: number, id: number, memberCnt: number, name: string })[], navigateFirstPage?: number, navigateLastPage?: number, navigatePages?: number, navigatepageNums?: (number)[], nextPage?: number, pageNum?: number, pageSize?: number, pages?: number, prePage?: number, size?: number, startRow?: number, total?: number }, msg?: string }` successful operation
   */
  "/xinxuan/console/user/tag_GET": (query: XinxuanConsoleTagsGetParams, raw: File, options: RequestConfig = {}) =>
    requestInstance({
      url: `/console/xinxuan/user/tag`,
      method: "GET",
      params: query,
      data: raw,
      ...options
    }) as unknown as Promise<any>,


  // 2022-3-10 新增 
  /**
   * 商品名称 输入模糊下拉
   * @name GET /xinxuan/console/goods
   * @summary 商品名称 输入模糊下拉
   * @tags 商品名称 输入模糊下拉
   * @response `200` `{ code?: number, data?: ({ id?: number, imgUrl?: string, jumpDesc?: string, jumpUrl?: string, sort?: number, status?: boolean, typeList?: ({ bannerId?: number, gmtCreate?: string, id?: number, type?: number })[] })[], msg?: string }` successful operation
   */
  "/xinxuan/console/goods/name_GET": (
    query: { name: string }
  ) =>
    requestInstance({
      url: `/xinxuan/console/goods/name`,
      method: "GET",
      params: query
    }) as unknown as Promise<File>,
  /**
  * 会员名称接口 输入模糊下拉
  * @name GET /xinxuan/console/user/name
  * @summary 会员名称接口 输入模糊下拉
  * @tags 会员名称接口 输入模糊下拉 
  * @response `200` `{ code?: number, data?: ({ id?: number, imgUrl?: string, jumpDesc?: string, jumpUrl?: string, sort?: number, status?: boolean, typeList?: ({ bannerId?: number, gmtCreate?: string, id?: number, type?: number })[] })[], msg?: string }` successful operation
  */
  "/xinxuan/console/user/name_GET": (
    query: { name: string }
  ) =>
    requestInstance({
      url: `/xinxuan/console/user/name`,
      method: "GET",
      params: query
    }) as unknown as Promise<File>,
  /**
   * 发货(修改接口)
   * @name PUT /console/order/delivery
   * @summary 发货(修改接口)
   * @tags 发货(修改接口)
   * @response `200` `File` successful operation
   */
  "/xinxuan/console/order/delivery_POST": (
    root: { id: string; expressCorp: string; expressOrderNo: string; },
    options: RequestConfig = {}
  ) =>
    requestInstance({
      url: `/console/order/delivery`,
      method: "POST",
      data: root,
      ...options
    }) as unknown as Promise<File>,
  /**
 * 订单列表 
 * @name GET /xinxuan/console/order/page
 * @summary 会员名称接口 输入模糊下拉
 * @tags 会员名称接口 输入模糊下拉 
 * @response `200` `{ code?: number, data?: ({ id?: number, imgUrl?: string, jumpDesc?: string, jumpUrl?: string, sort?: number, status?: boolean, typeList?: ({ bannerId?: number, gmtCreate?: string, id?: number, type?: number })[] })[], msg?: string }` successful operation
 */
  "/xinxuan/console/order/page_GET": (
    query: any
  ) =>
    requestInstance({
      url: `/xinxuan/console/order/page`,
      method: "GET",
      params: query
    }) as unknown as Promise<File>,
  // 2022-3-22 新增 
  /**
   * vlog 任务 列表
   * @name GET /xinxuan/console/vlog]
   * @response `200`
   */
  "/xinxuan/console/vlog_GET": (
    query: { [prop: string]: string }
  ) =>
    requestInstance({
      url: `/xinxuan/console/vlog`,
      method: "GET",
      params: query
    }) as Promise<any>,
  /**
   * vlog 任务 编辑
   * @name PUT /xinxuan/console/vlog
   * @response 
   */
  "/xinxuan/console/vlog_PUT": (
    data: { [prop: string]: string }
  ) =>
    requestInstance({
      url: `/xinxuan/console/vlog`,
      method: "PUT",
      data
    }) as Promise<any>,
  /**
   * vlog 任务 列表 导出数据  此处是 后端将数据传给前端 前端 自行 导出文件 
   * @name GET /xinxuan/console/vlog/export
   * @summary 商品名称 输入模糊下拉
   * @tags 商品名称 输入模糊下拉
   * @response `200`
   */
  "/xinxuan/console/vlog/export_POST": (
    data: { taskId: string }
  ) =>
    requestInstance({
      url: `/xinxuan/console/vlog/export`,
      method: "POST",
      data
    }) as Promise<any>,

  // 2022-3-31 新增 
  /**
   * 未激活用户列表
   * @name POST /xinxuan/console/user/dataTagUser]
   * @response `200`
   */
  "/xinxuan/console/user/dataTagUser_POST": (
    data: { [prop: string]: any }
  ) =>
    requestInstance({
      url: `/xinxuan/console/user/dataTagUser`,
      method: "POST",
      data
    }) as Promise<any>,
  /**
  * 用户列表 接口 重写 为 
  * @name POST /xinxuan/console/user/dataTagUser]
  * @response `200`
  */
  "/xinxuan/console/user/pagedUser_POST": (
    data: { [prop: string]: any }
  ) => requestInstance({
    url: `/xinxuan/console/user/pagedUser`,
    method: "POST",
    data
  }) as Promise<any>,
  // 2022-4-12 新增 公示文章模块 接口
  /**
   * 新增/修改 公示文章 
   * @name POST /xinxuan/console/publicInformation/saveOrSubmitArticle
   * @response `200`
   */
  "/xinxuan/console/publicInformation/saveOrSubmitArticle_POST": (
    data: { [prop: string]: string }
  ) => requestInstance({
    url: `/xinxuan/console/publicInformation/saveOrSubmitArticle`,
    method: "POST",
    data
  }) as Promise<any>,
  /**
   * 启用/禁用 公示文章 
   * @name POST /xinxuan/console/publicInformation/enableArticle
   * @response `200`
   */
  "/xinxuan/console/publicInformation/enableArticle_POST": (
    data: { id: string, status: string }
  ) => requestInstance({
    url: `/xinxuan/console/publicInformation/enableArticle`,
    method: "POST",
    data
  }) as Promise<any>,
  /**
   * 删除 公示文章 
   * @name POST /xinxuan/console/publicInformation/deleteArticle
   * @response `200`
   */
  "/xinxuan/console/publicInformation/deleteArticle_POST": (
    params: { id: string }
  ) => requestInstance({
    url: `/xinxuan/console/publicInformation/deleteArticle`,
    method: "POST",
    params
  }) as Promise<any>,
  /**
   * 公示文章 列表
   * @name GET /xinxuan/console/publicInformation/pagedArticle
   * @response `200`
   */
  "/xinxuan/console/publicInformation/pagedArticle_GET": (
    query: { [prop: string]: string }
  ) =>
    requestInstance({
      url: `/xinxuan/console/publicInformation/pagedArticle`,
      method: "GET",
      params: query
    }) as Promise<any>,
  /**
  * 公示文章 详情
  * @name GET /xinxuan/console/publicInformation/getArticle
  * @response `200`
  */
  "/xinxuan/console/publicInformation/getArticle_GET": (
    query: { id: string }
  ) =>
    requestInstance({
      url: `/xinxuan/console/publicInformation/getArticle`,
      method: "GET",
      params: query
    }) as Promise<any>,
  /**
   * 稀有 用户列表
   * @name GET /xinxuan/console/console/sysUser/listSysUser
   * @response `200` {username: '', id: ''}[]
   */
  "/xinxuan/console/console/sysUser/listSysUser_GET": (
    query: { username: string }
  ) =>
    requestInstance({
      url: `/xinxuan/console/console/sysUser/listSysUser`,
      method: "GET",
      params: query
    }) as Promise<any>,
  /**
   * 稀有 用户分组列表
   * @name POST /xinxuan/console/crmGroup/pageList
   * @response `200` 
   */
  "/xinxuan/console/crmGroup/pageList_POST": (
    data: { [prop: string]: any }
  ) =>
    requestInstance({
      url: `/xinxuan/console/crmGroup/pageList`,
      method: "POST",
      data
    }) as Promise<any>,
  /**
   * 稀有 用户分组用户列表
   * @name POST /console/crmGroupMember/pageList
   * @response `200` 
   */
  "/console/crmGroupMember/pageList_POST": (
    data: { [prop: string]: any }
  ) =>
    requestInstance({
      url: `/console/crmGroupMember/pageList`,
      method: "POST",
      data
    }) as Promise<any>,
  /**
   * 稀有 用户分组新建分组
   * @name POST /console/crmGroup/createCrmGroup
   * @response `200` 
   */
  "/console/crmGroup/createCrmGroup_POST": (
    data: { [prop: string]: any }
  ) =>
    requestInstance({
      url: `/console/crmGroup/createCrmGroup`,
      method: "POST",
      data
    }) as Promise<any>,
  /**
   * 稀有 用户分组删除分组
   * @name POST /console/crmGroup/deleteGroup
   * @response `200` 
   */
  "/console/crmGroup/deleteGroup_POST": (
    data: { [prop: string]: any }
  ) =>
    requestInstance({
      url: `/console/crmGroup/deleteGroup`,
      method: "POST",
      data
    }) as Promise<any>,
  /**
   * 稀有 用户分组新增用户
   * @name POST /console/crmGroupMember/addMembers
   * @response `200` 
   */
  "/console/crmGroupMember/addMembers_POST": (
    data: { [prop: string]: any }
  ) =>
    requestInstance({
      url: `/console/crmGroupMember/addMembers`,
      method: "POST",
      data
    }) as Promise<any>,
  /**
   * 稀有 用户分组删除用户
   * @name POST /console/crmGroupMember/deleteMember
   * @response `200` 
   */
  "/console/crmGroupMember/deleteMember_POST": (
    data: { [prop: string]: any }
  ) =>
    requestInstance({
      url: `/console/crmGroupMember/deleteMember`,
      method: "POST",
      data
    }) as Promise<any>,
  /**
   * 稀有 用户分组查询当前分组详情
   * @name GET /console/crmGroup/detail
   * @response `200` 
   */
  "/console/crmGroup/detail_GET": (
    query: { [prop: string]: any }
  ) =>
    requestInstance({
      url: `/console/crmGroup/detail`,
      method: "GET",
      params: query
    }) as Promise<any>,
  /**
   * 稀有 crm短信管理消息分页
   * @name GET /console/crmMessage/pagedMessage
   * @response `200` 
   */
  "/console/crmMessage/pagedMessage_GET": (
    query: { [prop: string]: any }
  ) =>
    requestInstance({
      url: `/console/crmMessage/pagedMessage`,
      method: "GET",
      params: query
    }) as Promise<any>,
  /**
   * 稀有 crm短信管理用户分页
   * @name GET /console/crmMessage/pagedCRMUser
   * @response `200` 
   */
  "/console/crmMessage/pagedCRMUser_GET": (
    query: { [prop: string]: any }
  ) =>
    requestInstance({
      url: `/console/crmMessage/pagedCRMUser`,
      method: "GET",
      params: query
    }) as Promise<any>,
    /**
     * 稀有 查询短信添加用户状态
     * @name GET /console/crmMessage/messageUserProcessingInfo
     * @response `200` 
     */
    "/console/crmMessage/messageUserProcessingInfo_GET": (
      query: { [prop: string]: any }
    ) =>
      requestInstance({
        url: `/console/crmMessage/messageUserProcessingInfo`,
        method: "GET",
        params: query
      }) as Promise<any>,
  /**
   * 稀有 投递消息
   * @name POST /console/crmMessage/SendMessage
   * @response `200` 
   */
  "/console/crmMessage/SendMessage_POST": (
    data: { [prop: string]: any }
  ) =>
    requestInstance({
      url: `/console/crmMessage/SendMessage`,
      method: "POST",
      data
    }) as Promise<any>,
  /**
   * 稀有 编辑投递消息
   * @name POST /console/crmMessage/editMessage
   * @response `200` 
   */
  "/console/crmMessage/editMessage_POST": (
    data: { [prop: string]: any }
  ) =>
    requestInstance({
      url: `/console/crmMessage/editMessage`,
      method: "POST",
      data
    }) as Promise<any>,
  /**
   * 稀有 发送测试消息
   * @name POST /console/crmMessage/sendTestMessage
   * @response `200` 
   */
  "/console/crmMessage/sendTestMessage_POST": (
    data: { [prop: string]: any }
  ) =>
    requestInstance({
      url: `/console/crmMessage/sendTestMessage`,
      method: "POST",
      data
    }) as Promise<any>,
  /**
   * 稀有 手动添加CRM用户
   * @name POST /console/crmMessage/addCRMUser
   * @response `200` 
   */
  "/console/crmMessage/addCRMUser_POST": (
    data: { [prop: string]: any }
  ) =>
    requestInstance({
      url: `/console/crmMessage/addCRMUser`,
      method: "POST",
      data
    }) as Promise<any>,
  /**
   * 稀有 删除CRM用户
   * @name POST /console/crmMessage/deleteCRMUser
   * @response `200` 
   */
  "/console/crmMessage/deleteCRMUser_POST": (
    data: { [prop: string]: any }
  ) =>
    requestInstance({
      url: `/console/crmMessage/deleteCRMUser`,
      method: "POST",
      data
    }) as Promise<any>,
  /**
   * 稀有 crm短信管理签名列表
   * @name GET /console/crmMessage/listSign
   * @response `200` 
   */
  "/console/crmMessage/listSign_GET": (
    query: { [prop: string]: any }
  ) =>
    requestInstance({
      url: `/console/crmMessage/listSign`,
      method: "GET",
      params: query
    }) as Promise<any>,
  /**
   * 稀有 从分组导入CRM用户
   * @name POST /console/crmMessage/importCRMUser
   * @response `200` 
   */
  "/console/crmMessage/importCRMUser_POST": (
    data: { [prop: string]: any }
  ) =>
    requestInstance({
      url: `/console/crmMessage/importCRMUser`,
      method: "POST",
      data
    }) as Promise<any>,
  /**
   * 稀有 获取短信id
   * @name POST /console/crmMessage/getLatestMessageId
   * @response `200` 
   */
  "/console/crmMessage/getLatestMessageId_POST": (
    data: { [prop: string]: any }
  ) =>
    requestInstance({
      url: `/console/crmMessage/getLatestMessageId`,
      method: "POST",
      data
    }) as Promise<any>,
  /**
   * 稀有 获取视频列表
   * @name GET /console/crmMessage/listVideoTemplate
   * @response `200` 
   */
   "/console/crmMessage/listVideoTemplate_GET": (
    query: { [prop: string]: any }
  ) =>
    requestInstance({
      url: `/console/crmMessage/listVideoTemplate`,
      method: "GET",
      params: query
    }) as Promise<any>,
    /**
     * 稀有 获取订单兑换积分活动列表
     * @name GET /xinxuan/console/order/exchange/page
     * @response `200` 
     */
     "/xinxuan/console/order/exchange/page_GET": (
      query: { [prop: string]: any }
    ) =>
      requestInstance({
        url: `/xinxuan/console/order/exchange/page`,
        method: "GET",
        params: query
      }) as Promise<any>,
    /**
     * 稀有 删除crm投递消息
     * @name POST /console/crmMessage/deleteMessage
     * @response `200` 
     */
    "/console/crmMessage/deleteMessage_POST": (
      data: { [prop: string]: any }
    ) =>
      requestInstance({
        url: `/console/crmMessage/deleteMessage`,
        method: "POST",
        data
      }) as Promise<any>,
    /**
     * 稀有 获取视频短链
     * @name POST /console/crmMessage/handleUrl
     * @response `200` 
     */
    "/console/crmMessage/handleUrl_POST": (
      data: { [prop: string]: any }
    ) =>
      requestInstance({
        url: `/console/crmMessage/handleUrl`,
        method: "POST",
        data
      }) as Promise<any>,
    /**
     * 稀有 限制短信发送人数
     * @name POST /console/crmMessage/limitSendCnt
     * @response `200` 
     */
    "/console/crmMessage/limitSendCnt_POST": (
      data: { [prop: string]: any }
    ) =>
      requestInstance({
        url: `/console/crmMessage/limitSendCnt`,
        method: "POST",
        data
      }) as Promise<any>,
    /**
     * 稀有 限制短信发送人数
     * @name POST /console/crmMessage/getLimitSendCnt
     * @response `200` 
     */
    "/console/crmMessage/getLimitSendCnt_POST": (
      data: { [prop: string]: any }
    ) =>
      requestInstance({
        url: `/console/crmMessage/getLimitSendCnt`,
        method: "POST",
        data
      }) as Promise<any>
};
